/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Rounds a number to the given number of decimals and formats it as a string.
 *
 * It does this in a way that means that we don't have floating point precision issues.
 * @param {*} num - The number to round and format
 * @param {*} decimals - The number of decimals to round to
 * @returns
 * @example
 * moneyRounding(1.23456, 2) // "1.23"
 * moneyRounding(1.23456, 3) // "1.235"
 * moneyRounding(1.23456, 0) // "1"
 * moneyRounding(1.23456, 4) // "1.2346"
 * moneyRounding(1.23456, 5) // "1.23456"
 */
function moneyRounding(num, decimals = 2) {
  const factor = Math.pow(10, decimals);
  return Math.round(num * factor) / factor;
}

/**
 * Calculate price including GST with correct rounding to avoid floating point errors.
 * @param {number} priceExGst - Price excluding GST
 * @param {number} taxRate - Tax multiplier (e.g. 1.1 for 10% GST, 1.0 for no tax)
 * @returns {number} - Price including GST rounded to 2 decimals
 */
function calculateIncGst(priceExGst, taxRate) {
  return Math.round(Math.round(priceExGst * 100) * taxRate) / 100;
}

function scrollToCollectionTop() {
  // Try to find the collection header/title element
  const cardHeader = document.querySelector('.collection .card__header');
  const collectionTitle = document.querySelector('.collection__title');
  const collection = document.querySelector('.collection');

  const targetElement = cardHeader || collectionTitle || collection;

  const header = document.querySelector('header.header');
  const headerHeight = header?.getBoundingClientRect()?.height || 0;

  if (targetElement) {
    const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - (headerHeight + 20);
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  } else {
    // Fallback to top of page if no collection element found
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

const API_URL = 'https://api.dashboard.livingstone.com.au/';
const PORTAL_URL = 'https://dashboard.livingstone.com.au';
const CUSTOMER_API_URL = 'https://api.dashboard.livingstone.com.au/';
const MAPBOX_URL = 'https://api.mapbox.com/geocoding/v5/mapbox.places';

function customPricingInit() {
  // console.log('~* Pipelabs Custom B2B Pricing Magic *~');

  /** Open pop up force login if VIP and no customer logged in  */

  /** Grab globals */
  const companyExternalId = document.body.dataset.companyExternalId;
  const isB2B = document.body.dataset.isB2b === 'true';

  /** Find skus to fetch prices for */
  const skus = findSkusOnPage();

  let priceBreakTargets = [];

  priceBreakTargets = findPriceTargets();
  fetchPricing(companyExternalId, skus, isB2B);

  /** Add listeners */
  const formsOnPage = document.querySelectorAll('form');
  for (const form of formsOnPage) {
    // Check if this form already has the product:rerender listener
    if (!form.hasAttribute('data-pricing-listener-attached')) {
      form.addEventListener('product:rerender', (event) => {
        renderPrices();
      });
      // Mark this form as having the listener attached
      form.setAttribute('data-pricing-listener-attached', 'true');
    }
  }

  document.addEventListener('quantity:change', (event) => {
    // console.log('quantity:change', event.detail.qty, '-', event.detail.elem);
    updateSumPrices(event);
  });

  /* So sometimes elements with price break tables aren't available at DOMContentLoaded
     This event can be fired when one of those processes are done, and this should sort it out
  */
  document.addEventListener('recommendations:loaded', (event) => {
    // console.log('recommendations:loaded');
    // breaks that were missed will still be invisible
    const unloadedSkus = Array.from(document.querySelectorAll('.invis[data-pricing-bk1-ex-gst]')).map(
      (e) => e.dataset['variantSku'],
    );

    // console.log({ unloadedSkus });

    // retarget all cells of the tables
    priceBreakTargets = findPriceTargets();

    // refetch just these skus
    fetchPricing(companyExternalId, unloadedSkus, isB2B);
  });
  document.addEventListener('recently-viewed:loaded', (event) => {
    // console.log('recently-viewed:loaded');
    // breaks that were missed will still be invisible
    const unloadedSkus = Array.from(document.querySelectorAll('.invis[data-pricing-bk1-ex-gst]')).map(
      (e) => e.dataset['variantSku'],
    );

    // console.log({ unloadedSkus });

    // retarget all cells of the tables
    priceBreakTargets = findPriceTargets();

    // refetch just these skus
    fetchPricing(companyExternalId, unloadedSkus, isB2B);
  });

  document.addEventListener('quickview:loaded', (event) => {
    // we use the table to find missing prices
    const unloadedSkus = Array.from(
      document.querySelectorAll('[data-section-type="product-quick-view"] [data-pricing-bk1-ex-gst]'),
    ).map((e) => e.dataset['variantSku']);

    // retarget all cells of the tables
    priceBreakTargets = findPriceTargets();

    // refetch just these skus
    fetchPricing(companyExternalId, unloadedSkus, isB2B);
  });

  /** Functions */
  function setLoadingState(skus) {
    // console.log('setting loading state for: ', skus);
    for (const priceBreak of priceBreakTargets) {
      for (const value of priceBreak.values) {
        if (!skus || skus.includes(value.dataset['variantSku'])) {
          value.classList.add('invis');
          // value.setAttribute('data-pricing-loading', true);
        }
      }
    }
    const SumTargets = document.querySelectorAll(`[data-pricing-sum-price]`);
    for (const target of SumTargets) {
      if (!skus || skus.includes(target.dataset['variantSku'])) {
        target.classList.add('invis');
      }
    }
  }

  function unhideDefaultPrices(skus) {
    // console.log('unhiding default prices for: ', skus);
    for (const priceBreak of priceBreakTargets) {
      for (const value of priceBreak.values) {
        if (!skus || skus.includes(value.dataset['variantSku'])) {
          value.classList.remove('invis');
          // value.setAttribute('data-pricing-loading', false);
        }
      }
    }
  }

  function renderPrices() {
    updateSumPrices();
    updatePriceBreaks();
  }

  // Add event listener for price:rerender
  document.addEventListener('price:rerender', () => {
    console.log('price:rerender');
    renderPrices();
  });

  function updateSumPrices(event) {
    // console.log('updateSumPrices');
    const SumTargets = document.querySelectorAll(`[data-pricing-sum-price]`);
    // console.log(Array.from(SumTargets).map((target) => target.dataset.variantSku));
    // console.log(SumTargets);

    /* Update sum prices */
    for (const target of SumTargets) {
      const sku = target?.dataset.variantSku;
      const breakList = getBreaksForVariant(sku);

      if (!breakList) {
        // console.warn('no break list for', sku);
        continue;
      }

      setSumPrice(target, breakList, event);
      setCartProperty(target, breakList);
      target.classList.remove('invis');
      target.classList.add('fadein');
    }

    /* define helper functions */

    function getHashForSku(sku) {
      const breaks = window.b2bpricing?.find((p) => p.sku === sku);
      return breaks.hmac;
    }

    function getBreaksForVariant(sku) {
      const breaks = window.b2bpricing?.find((p) => p.sku === sku);

      if (!breaks) return;

      // Find the correct pricebreak for the qty, then grab its price
      let breakList = [];
      for (let i = 1; i < 5; i++) {
        breakList.push({
          quantity: parseInt(breaks[`price_break${i}_qty`]),
          value: parseFloat(breaks[`price_break${i}_ex_gst`]),
        });
      }

      return breakList;
    }

    function getTaxRateForVariant(sku) {
      const breaks = window.b2bpricing?.find((p) => p.sku === sku);

      if (!breaks) return;

      return breaks['taxRate'];
    }

    function getPriceRequestForSku(sku) {
      const breaks = window.b2bpricing?.find((p) => p.sku === sku);

      if (!breaks) return;

      return {
        couponCode: breaks['couponCode'],
        accountNumber: breaks['accountNumber'],
        priceSource: breaks['price_source'],
      };
    }

    /* Set the visible price in target to match in breaklist based on closest quantity input */
    function setSumPrice(target, breakList, event) {
      // console.log('setSumPrice', target?.dataset.variantSku);

      // get global gst toggle
      const gstToggle = document.querySelector('#gst-toggle-input');
      const gstDisabled = gstToggle?.checked == false;

      const taxRate = getTaxRateForVariant(target?.dataset.variantSku);

      const closestQtyInput = target?.closest('form')?.querySelector('input[name="quantity"]');
      // if (!closestQtyInput) return;
      let qty = closestQtyInput?.value || 1;

      const overrideTargetId = event?.detail?.elem;
      if (overrideTargetId && overrideTargetId === closestQtyInput?.id) {
        qty = event?.detail?.qty;
      }

      const currentBreak = breakList.filter((b) => Number(b.quantity) <= qty && Number(b.quantity) > 0)?.reverse()?.[0];

      // const tax = parseInt(taxRate || '100') / 100;
      const tax = gstDisabled ? 1 : parseInt(taxRate || '100') / 100;
      // const finalPrice = (currentBreak.value * tax).toFixed(2);
      const finalPrice = calculateIncGst(currentBreak.value, tax).toFixed(2);

      let priceString = `<span>$${finalPrice}</span>`;

      const ogPrice = breakList.find((b) => (b.quantity = 1));

      const finalComparePrice = calculateIncGst(ogPrice.value, tax).toFixed(2);

      if (ogPrice.value > currentBreak.value) {
        priceString += `<span class="strike-price"> $${finalComparePrice}</span>`;
      }

      target.innerHTML = priceString;
    }

    function setCartProperty(target, breakList) {
      const hiddenInputs = target?.closest('form')?.querySelectorAll('[data-variant-sku]#priceBreaks');

      if (!hiddenInputs) return;

      const inputArray = Array.from(hiddenInputs);

      for (const hiddenInput of inputArray) {
        const hmac = getHashForSku(hiddenInput.dataset.variantSku);
        const taxRate = getTaxRateForVariant(hiddenInput.dataset.variantSku);
        const { couponCode, accountNumber, priceSource } = getPriceRequestForSku(hiddenInput.dataset.variantSku);
        hiddenInput.value = JSON.stringify({
          breaks: breakList,
          taxRate,
          hmac,
          couponCode,
          accountNumber,
          priceSource,
        });
      }
    }
  }

  function updatePriceBreaks() {
    // console.log('updatePriceBreaks');
    // get global gst toggle
    const gstToggle = document.querySelector('#gst-toggle-input');
    const gstDisabled = gstToggle?.checked == false;

    /* Hide prices if VIP subdomain and not logged in */
    const companyExternalId = document.body.dataset.companyExternalId;
    const forceLogin = document.querySelector('[data-force-login]');
    const hidePrices = forceLogin && !companyExternalId;

    if (hidePrices) {
      const priceTable = document.querySelector('[data-pdp-price-table]');
      if (priceTable) {
        priceTable.classList.add('d-none');
      }
      const noPricesMessage = document.querySelector('[data-no-prices-message]');
      if (noPricesMessage) {
        noPricesMessage.classList.remove('d-none');
      }
      return;
    }

    // console.log('updating price breaks...', window.b2bpricing.length);
    /** Update breaks */
    for (const price of window.b2bpricing) {
      for (let i = 1; i < 5; i++) {
        const CostTargets = document.querySelectorAll(`[data-variant-sku="${price.sku}"][data-pricing-bk${i}-ex-gst]`);
        for (const cost of CostTargets) {
          if (cost.innerText == '_') {
            cost.classList.add('fadein');
            cost.classList.remove('invis');
          }
          const taxRate = gstDisabled ? 1 : parseInt(price['taxRate'] || '100') / 100;
          const finalPrice = calculateIncGst(price[`price_break${i}_ex_gst`], taxRate).toFixed(2);
          cost.innerText = `$${finalPrice}`;
        }

        const QtyTargets = document.querySelectorAll(`[data-variant-sku="${price.sku}"][data-pricing-bk${i}-qty]`);
        for (const qty of QtyTargets) {
          if (qty.innerText == '_') {
            qty.classList.add('fadein');
            qty.classList.remove('invis');
          }
          qty.innerText = `+${price[`price_break${i}_qty`]}`;

          if (price[`price_break${i}_qty`] == 0) {
            qty.closest('tr').classList.add('d-none');
          } else {
            qty.closest('tr').classList.remove('d-none');
          }
        }
      }

      //update gst title if required

      const taxable = parseInt(price['taxRate'] || '100') / 100 != 1;

      if (gstDisabled) {
        const CostTargets = document.querySelectorAll(`[data-variant-sku="${price.sku}"][data-pricing-title]`);
        for (const cost of CostTargets) {
          cost.innerText = taxable ? '(Ex. GST)' : '(GST Free)';
        }
      } else {
        const CostTargets = document.querySelectorAll(`[data-variant-sku="${price.sku}"][data-pricing-title]`);
        for (const cost of CostTargets) {
          cost.innerText = '(Inc. GST)';
        }
      }
    }
  }

  function fetchPricing(companyExternalId, skus, isB2B) {
    setLoadingState(skus);

    const couponInput = document.querySelector('.coupon-input');
    let couponValue = couponInput?.value;

    if (!couponValue) {
      const storageValue = localStorage.getItem('coupon_code');
      if (storageValue) {
        couponValue = storageValue;
      }
    }

    // get b2b prices
    fetch(`${API_URL}/pricing${isB2B ? '' : '/dtc'}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        accountNumber: companyExternalId,
        token: 'f3243f29-cdba-4b1c-bb62-ef9330db1450',
        skus: skus,
        couponCode: couponValue,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.statusCode == 500) {
          console.log(`Failed to get b2b pricing: [${data.statusCode}]: ${data.message}`);
          window.b2bpricing = [];
        } else {
          if (!window.b2bpricing) {
            window.b2bpricing = [];
          }
          // we want to merge with any existing prices we've stored
          window.b2bpricing = [...window.b2bpricing, ...data];
        }

        document.dispatchEvent(new CustomEvent('price:loaded'));

        renderPrices();
        unhideDefaultPrices(skus);
      })
      .catch((error) => {
        console.error('Error:', error);
        unhideDefaultPrices(skus);
      });
  }

  function findSkusOnPage() {
    const skusLists = document.querySelectorAll('[data-product-skus]');

    let skus = [];
    for (const list of skusLists) {
      try {
        skus = [...skus, ...JSON.parse(list.dataset.productSkus)];
      } catch (e) {
        console.error(e);
      }
    }

    // reduce to unique entries
    skus = Array.from(new Set(skus));
    // console.log('skus on page', skus);
    return skus;
  }

  function findPriceTargets() {
    let result = [];

    for (let i = 1; i < 5; i++) {
      result.push({
        values: document.querySelectorAll(`[data-pricing-bk${i}-ex-gst]`),
        quantities: document.querySelectorAll(`[data-pricing-bk${i}-qty]`),
      });
    }
    return result;
  }
}

customPricingInit();

function openForceLoginPopup() {
  const loginUrl = `${PORTAL_URL}/login`;
  // Create modal backdrop
  const backdrop = document.createElement('div');
  backdrop.className = 'modal-backdrop';

  // Close modal function
  const closeModal = () => {
    document.body.removeChild(backdrop);
  };

  // Create modal box
  const modal = document.createElement('div');
  modal.className = 'modal-box';

  // Stop propagation to prevent closing when clicking inside
  modal.addEventListener('click', (e) => e.stopPropagation());

  // Create close button
  const closeBtn = document.createElement('span');
  closeBtn.className = 'modal-close';
  closeBtn.innerHTML = '&times;';
  closeBtn.onclick = closeModal;

  // Create message
  const message = document.createElement('h2');
  message.innerText = 'Please login to see your prices.';

  // Create login button
  const loginBtn = document.createElement('button');
  loginBtn.className = 'login-btn button button--primary';
  loginBtn.innerText = 'Login';
  loginBtn.onclick = () => {
    window.location.href = loginUrl;
  };

  // Add close on click outside
  backdrop.addEventListener('click', closeModal);

  // Append elements
  modal.appendChild(closeBtn);
  modal.appendChild(message);
  modal.appendChild(loginBtn);
  backdrop.appendChild(modal);
  document.body.appendChild(backdrop);
}

document.addEventListener('DOMContentLoaded', () => {
  const forceLogin = document.querySelector('[data-force-login]');
  // Don't show popup if we're already on the register page to avoid appearing stuck in a loop
  const isOnRegisterPage = window.location.pathname === '/pages/register';

  const isDev = window.location.hostname === 'livingstone-au.myshopify.com';

  if (forceLogin && !isOnRegisterPage && !isDev) {
    setTimeout(() => {
      openForceLoginPopup();
    }, 2000);
  }
});

class CustomRegistration extends HTMLElement {
  form = null;
  submitButton = null;
  registrationType = null;
  industrySelect = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this._init();
    this._addEventListeners();
    this._populateIndustries();
  }

  _init() {
    console.log('CUSTOMER_API_URL', CUSTOMER_API_URL);

    this.form = this.querySelector('form');
    if (!this.form) {
      console.error('No form found inside custom-registration');
      return;
    }

    this.submitButton = this.querySelector('button[type="submit"]');
    this.registrationType = this.dataset.registrationType || '';
    this.industrySelect = this.querySelector('select#Industry');
  }

  _addEventListeners() {
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  async _populateIndustries() {
    if (!this.industrySelect) return;

    try {
      const response = await fetch(`${CUSTOMER_API_URL}/registration?type=${this.registrationType}`);
      const data = await response.json();

      if (data.fields?.industry) {
        this._populateSelect(this.industrySelect, data.fields.industry);
      }
    } catch (error) {
      console.error('Error fetching industries:', error);
    }
  }

  _populateSelect(selectElement, options) {
    selectElement.innerHTML = '<option value="">Select an option</option>'; // Clear existing options

    options.forEach(({ id, name }) => {
      const option = document.createElement('option');
      option.value = id;
      option.textContent = name;
      selectElement.appendChild(option);
    });
  }

  validateForm() {
    let isValid = true;
    const requiredFields = this.form?.querySelectorAll('[required]') || [];

    requiredFields.forEach((field) => {
      const errorMessage = field.nextElementSibling;
      if (!field.value.trim()) {
        field.classList.add('registration__form-error');
        this._showErrorMessage(field, 'This field is required.');
        isValid = false;
      } else {
        field.classList.remove('registration__form-error');
        if (errorMessage && errorMessage.classList.contains('error-message')) {
          errorMessage.textContent = '';
        }
      }
    });

    return isValid;
  }

  _showErrorMessage(field, message) {
    let errorMessage = field.nextElementSibling;
    if (!errorMessage || !errorMessage.classList.contains('error-message')) {
      errorMessage = document.createElement('div');
      errorMessage.className = 'error-message';
      field.parentNode.insertBefore(errorMessage, field.nextSibling);
    }
    errorMessage.textContent = message;
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (!this.validateForm()) return;

    const formData = new FormData(this.form);
    const data = Object.fromEntries(formData);

    const signature = document.getElementById('sig-dataUrl')?.innerText;

    if (document.getElementById('sig-dataUrl') && !signature) {
      this._showErrorMessage(document.getElementById('sig-dataUrl'), 'This field is required.');
      return;
    }

    try {
      const response = await fetch(`${CUSTOMER_API_URL}/registration/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...data, type: data.type || 'custom', signature }),
      });

      if (response.ok) {
        this._onFormSuccess(await response.json());
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  }

  _onFormSuccess(response) {
    window.location.href = `/pages/thank-you${response?.customerReference ? `?ref=${response?.customerReference}` : ''}`;
  }
}

class RegisterEducation extends CustomRegistration {
  roleOptions = null;
  facultyFields = null;
  roleOptionClass = 'registration__form-role-option';
  roleOptionSelectedClass = 'registration__form-role-option--selected';
  suggestionItemClass = 'autocomplete__institute-suggestion-item';
  searchInput = null;
  suggestionsContainer = null;
  selectedIndex = -1;
  institutions = [];

  constructor() {
    super();
    this._debounceTimeout = null;
  }

  connectedCallback() {
    super.connectedCallback();
    this._addRoleSelectionListener();
    this._setupInstituteSearch();
  }

  _init() {
    super._init();
    this.roleOptions = this.querySelectorAll(`.${this.roleOptionClass}`);
    this.facultyFields = this.querySelectorAll('[data-role-only="faculty"]');
    this.searchInput = this.querySelector('#institute-name');

    this.suggestionsContainer = document.createElement('div');
    this.suggestionsContainer.classList.add('autocomplete__institute-suggestions');
    this.searchInput.insertAdjacentElement('afterend', this.suggestionsContainer);
  }

  _addRoleSelectionListener() {
    if (this.roleOptions) {
      this.roleOptions.forEach((option) => {
        option.addEventListener('click', this._handleRoleSelection.bind(this));
      });
    }
  }

  _handleRoleSelection(event) {
    const option = event.target.closest(`.${this.roleOptionClass}`);
    const selectedRole = option.dataset.role;

    this.roleOptions.forEach((option) => {
      option.classList.remove(this.roleOptionSelectedClass);
    });

    option.classList.add(this.roleOptionSelectedClass);

    if (selectedRole === 'faculty') {
      this.facultyFields.forEach((field) => {
        field.classList.remove('hidden');
      });
    } else {
      this.facultyFields.forEach((field) => {
        field.classList.add('hidden');
      });
    }
  }

  _setupInstituteSearch() {
    if (!this.searchInput) return;

    this.searchInput.addEventListener('input', (event) => {
      const query = event.target.value.trim();
      clearTimeout(this._debounceTimeout);

      if (query.length < 2) {
        this._clearSuggestions();
        return;
      }

      this._debounceTimeout = setTimeout(() => {
        this._fetchInstitutions(query);
      }, 300);
    });

    this.searchInput.addEventListener('keydown', (event) => this._handleKeyboardNavigation(event));
    this.suggestionsContainer.addEventListener('click', (event) => this._handleSuggestionClick(event));
    document.addEventListener('click', (event) => this._handleOutsideClick(event));
  }

  async _fetchInstitutions(query) {
    try {
      const response = await fetch(`${CUSTOMER_API_URL}/registration/institutions?q=${encodeURIComponent(query)}`);
      if (!response.ok) throw new Error('Failed to fetch institutions');

      this.institutions = await response.json();
      this._showSuggestions();
    } catch (error) {
      console.error('Error fetching institutions:', error);
    }
  }

  _showSuggestions() {
    this.suggestionsContainer.innerHTML = '';
    this.selectedIndex = -1;

    if (!this.institutions.length) {
      this.suggestionsContainer.innerHTML = `<p class="${this.suggestionItemClass} autocomplete__institute-no-results">No results found</p>`;
      return;
    }

    this.institutions.forEach((institution, index) => {
      const suggestionItem = document.createElement('div');
      suggestionItem.textContent = institution.name;
      suggestionItem.dataset.id = institution.id;
      suggestionItem.dataset.index = index;
      suggestionItem.classList.add(this.suggestionItemClass);
      this.suggestionsContainer.appendChild(suggestionItem);
    });
  }

  _clearSuggestions() {
    this.suggestionsContainer.innerHTML = '';
    this.selectedIndex = -1;
    this.institutions = [];
  }

  _handleSuggestionClick(event) {
    const item = event.target.closest(`.${this.suggestionItemClass}`);
    if (!item) return;

    this.searchInput.value = item.textContent;
    this._clearSuggestions();
  }

  _handleOutsideClick(event) {
    if (!this.suggestionsContainer.contains(event.target) && event.target !== this.searchInput) {
      this._clearSuggestions();
    }
  }

  _handleKeyboardNavigation(event) {
    const items = this.suggestionsContainer.querySelectorAll(`.${this.suggestionItemClass}`);
    if (!items.length) return;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.selectedIndex = (this.selectedIndex + 1) % items.length;
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.selectedIndex = (this.selectedIndex - 1 + items.length) % items.length;
        break;
      case 'Enter':
        event.preventDefault();
        if (this.selectedIndex > -1) {
          this.searchInput.value = items[this.selectedIndex].textContent;
          this._clearSuggestions();
        }
        break;
      case 'Escape':
        this._clearSuggestions();
        break;
    }

    items.forEach((item, index) => {
      item.classList.toggle('active', index === this.selectedIndex);
    });
  }
}

class AddressAutocomplete extends HTMLElement {
  mapboxToken = null;
  addressInput = null;
  suburbInput = null;
  stateSelect = null;
  postcodeInput = null;
  suggestionsContainer = null;
  debounceTimer = null;
  activeSuggestionIndex = -1;
  suggestions = [];

  constructor() {
    super();
  }

  connectedCallback() {
    this._init();
  }

  _init() {
    this.mapboxToken = this.dataset.mapboxToken;
    this.addressInput = this.querySelector('#address-line1');
    this.suburbInput = this.querySelector('#address-level2');
    this.stateSelect = this.querySelector('#address-level1');
    this.postcodeInput = this.querySelector('#postal-code');

    if (!this.mapboxToken) {
      console.error('AddressAutocomplete: Mapbox token not set');
      return;
    }

    if (!this.addressInput) {
      console.error('AddressAutocomplete: Could not find address input');
      return;
    }

    this._initAddressAutocomplete();
  }

  _initAddressAutocomplete() {
    this.suggestionsContainer = document.createElement('div');
    this.suggestionsContainer.classList.add('autocomplete__address-suggestions');
    this.addressInput.parentNode.appendChild(this.suggestionsContainer);
    this.isInputFocused = false;

    this.addressInput.addEventListener('input', (event) => {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this._fetchAddressSuggestions(event), 400);
    });

    this.addressInput.addEventListener('focus', () => {
      this.isInputFocused = true;
      // Re-show suggestions if they exist
      if (this.suggestions && this.suggestions.length > 0) {
        this._showSuggestions();
      }
    });

    this.addressInput.addEventListener('blur', () => {
      this.isInputFocused = false;
      // Delay clearing to allow click events on suggestions to fire
      setTimeout(() => {
        if (!this.isInputFocused) {
          this._clearSuggestions();
        }
      }, 200);
    });

    this.addressInput.addEventListener('keydown', this._handleKeyDown.bind(this));
  }

  async _fetchAddressSuggestions(event) {
    const query = event.target.value.trim();
    if (query.length < 3) {
      this._clearSuggestions();
      return;
    }

    const params = new URLSearchParams({
      access_token: this.mapboxToken,
      autocomplete: true,
      country: 'AU',
      types: 'address',
    });

    try {
      const response = await fetch(`${MAPBOX_URL}/${encodeURIComponent(query)}.json?${params.toString()}`);
      const data = await response.json();
      this.suggestions = data.features;
      this.activeSuggestionIndex = -1;
      this._showSuggestions();
    } catch (error) {
      console.error('Error fetching address suggestions:', error);
    }
  }

  _showSuggestions() {
    this.suggestionsContainer.innerHTML = '';

    // Only show suggestions if the input is focused
    if (this.suggestions.length === 0 || !this.isInputFocused) {
      return;
    }

    this.activeSuggestionIndex = 0;

    this.suggestions.forEach((place, index) => {
      const suggestionItem = document.createElement('div');
      suggestionItem.classList.add('autocomplete__suggestion-item');

      // Add 'active' class if it's the currently selected index
      if (index === this.activeSuggestionIndex) {
        suggestionItem.classList.add('active');
      }

      suggestionItem.textContent = place.place_name;
      suggestionItem.addEventListener('click', () => {
        this._fillAddressFields(place);
        this._clearSuggestions();
      });

      this.suggestionsContainer.appendChild(suggestionItem);
    });
  }

  _handleKeyDown(event) {
    if (!this.suggestions.length) return;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.activeSuggestionIndex = (this.activeSuggestionIndex + 1) % this.suggestions.length;
        this._updateActiveSuggestion();
        break;

      case 'ArrowUp':
        event.preventDefault();
        this.activeSuggestionIndex =
          (this.activeSuggestionIndex - 1 + this.suggestions.length) % this.suggestions.length;
        this._updateActiveSuggestion();
        break;

      case 'Enter':
        event.preventDefault();
        if (this.activeSuggestionIndex >= 0) {
          this._fillAddressFields(this.suggestions[this.activeSuggestionIndex]);
          this._clearSuggestions();
        }
        break;

      case 'Escape':
        this._clearSuggestions();
        break;
    }
  }

  _updateActiveSuggestion() {
    // Remove active class from all suggestions
    const suggestionItems = this.suggestionsContainer.querySelectorAll('.autocomplete__suggestion-item');
    suggestionItems.forEach((item) => item.classList.remove('active'));

    // Add active class to the new selected suggestion
    if (this.activeSuggestionIndex >= 0 && suggestionItems[this.activeSuggestionIndex]) {
      suggestionItems[this.activeSuggestionIndex].classList.add('active');
    }
  }

  _fillAddressFields(place) {
    const components = place.context.reduce((acc, item) => {
      if (item.id.startsWith('locality')) acc.suburb = item.text;
      if (item.id.startsWith('region')) acc.state = item.short_code.replace('AU-', '');
      if (item.id.startsWith('postcode')) acc.postcode = item.text;
      return acc;
    }, {});

    // Fallback to place if locality is not present
    if (!components.suburb) {
      components.suburb = place.text;
    }

    this._applyAutofillStyle(this.addressInput, place.address + ' ' + place.text);
    if (this.suburbInput) this._applyAutofillStyle(this.suburbInput, components.suburb || '');
    if (this.stateSelect) this._applyAutofillStyle(this.stateSelect, components.state || '');
    if (this.postcodeInput) this._applyAutofillStyle(this.postcodeInput, components.postcode || '');
  }

  _applyAutofillStyle(input, value) {
    input.value = value;
    input.classList.add('autofilled');
    setTimeout(() => input.classList.remove('autofilled'), 5000); // Remove highlight after 5 seconds
  }

  _clearSuggestions() {
    this.suggestions = [];
    this.suggestionsContainer.innerHTML = '';
  }
}

class BulkBuyQuoteForm extends HTMLElement {
  form = null;
  submitButton = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this._init();
    this._addEventListeners();
  }

  _init() {
    this.form = this.querySelector('form');
    if (!this.form) {
      console.error('No form found inside bulk-buy-registration');
      return;
    }
    this.submitButton = this.querySelector('button[type="submit"]');
  }

  _addEventListeners() {
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  validateForm() {
    let isValid = true;
    const requiredFields = this.form?.querySelectorAll('[required]') || [];

    requiredFields.forEach((field) => {
      if (!field.value.trim()) {
        field.classList.add('registration__form-error');
        this._showErrorMessage(field, 'This field is required.');
        isValid = false;
      } else if (field.id === 'quantity') {
        const quantity = parseInt(field.value, 10);
        if (isNaN(quantity) || quantity <= 0) {
          field.classList.add('registration__form-error');
          this._showErrorMessage(field, 'Please enter a valid quantity greater than 0.');
          isValid = false;
        } else {
          field.classList.remove('registration__form-error');
          const errorMessage = field.nextElementSibling;
          if (errorMessage?.classList.contains('error-message')) {
            errorMessage.remove();
          }
        }
      } else {
        field.classList.remove('registration__form-error');
        const errorMessage = field.nextElementSibling;
        if (errorMessage?.classList.contains('error-message')) {
          errorMessage.remove();
        }
      }
    });

    return isValid;
  }

  _showErrorMessage(field, message) {
    let errorMessage = field.nextElementSibling;
    if (!errorMessage || !errorMessage.classList.contains('error-message')) {
      errorMessage = document.createElement('div');
      errorMessage.className = 'error-message';
      field.parentNode.insertBefore(errorMessage, field.nextSibling);
    }
    errorMessage.textContent = message;
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (!this.validateForm()) return;

    const formData = new FormData(this.form);

    const data = {
      'contact[name]': formData.get('contact[contact_name]'),
      'contact[company]': formData.get('contact[business_name]'),
      'contact[email]': formData.get('contact[email]'),
      'contact[phone]': formData.get('contact[phone]'),
      'contact[type]': formData.get('contact[type]'),
      'request[quantity]': parseInt(formData.get('request[quantity]'), 10),
      'request[items]': formData.get('request[items]'),
    };

    try {
      const response = await fetch(`${API_URL}/bulk-quote`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (result.success) {
        this._onFormSuccess(result.message);
      } else {
        throw new Error(result.message || 'Failed to submit form');
      }
    } catch (error) {
      console.error('Error submitting bulk buy form:', error);
      this._showErrorMessage(this.submitButton, 'Failed to submit form. Please try again.');
    }
  }

  _onFormSuccess(message) {
    // Show success message
    const successMessage = document.createElement('div');
    successMessage.classList.add('form-success');
    successMessage.textContent = 'Thanks for your request! We will be in touch soon.';
    this.form.innerHTML = '';
    this.form.appendChild(successMessage);

    console.log(successMessage);
  }
}

class CartLines extends HTMLElement {
  cartState = null;

  constructor() {
    super();
  }

  async connectedCallback() {
    await this.fetchCart();
    this.attachEventListeners();
  }

  async fetchCart() {
    try {
      const response = await fetch('/cart.js');
      this.cartState = await response.json();
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  attachEventListeners() {
    this.querySelectorAll('.line-item__comment input').forEach((input) => {
      input.addEventListener('change', (event) => this.updateLineItemComment(event));
    });
  }

  async updateLineItemComment(event) {
    if (!this.cartState) {
      console.error('Cart not loaded yet');
      return;
    }

    const lineItemElement = event.target.closest('.line-item__meta');
    const lineItemId = lineItemElement?.dataset.lineItemId;
    if (!lineItemId) {
      console.error('Missing line item id');
      return;
    }

    const lineItem = this.cartState.items.find((item) => item.id == lineItemId);
    if (!lineItem) {
      console.error('Line item not found in cart');
      return;
    }

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineItemId,
          quantity: lineItem.quantity,
          properties: {
            ...lineItem.properties,
            Comment: event.target.value,
          },
        }),
      });
    } catch (error) {
      console.error('Error updating line item comment:', error);
    }
  }
}

class ProductCartRecommendations extends HTMLElement {
  isLoggedIn = null;
  products = [];

  constructor() {
    super();
  }

  connectedCallback() {
    const section = this.getAttribute('section');
    this.isLoggedIn = Boolean(document.body.dataset.isLoggedIn == 'true');
    this.fetchRecommendations(section);

    // listen for price:rerender
    document.addEventListener('price:rerender', () => {
      if (this.products.length == 0) {
        return;
      }

      this.renderProducts(this.products.slice(0, 6));
    });
  }

  async fetchRecommendations(section) {
    const lineItems = document.querySelectorAll(`[data-line-item-sku]`);
    const cartSkus = Array.from(lineItems)
      .map((l) => l.dataset['lineItemSku'])
      .reverse();
    const pageSkuDivs = document.querySelectorAll(`[data-variant-sku]`);
    const pageSkus = Array.from(pageSkuDivs).map((l) => l.dataset['variantSku']);

    let querySkus = cartSkus.length ? cartSkus : pageSkus.length ? pageSkus : ['GLRBRAMWAYM6'];

    const seed = document.querySelector('[data-seed]')?.dataset['seed'] || 0;

    /* A lil sneaky one for ya */
    if (seed > 0) {
      const a = (seed % (querySkus.length - 1)) + 1;
      querySkus = querySkus.slice(a, a + 1);
    }

    const couponInput = document.querySelector('.coupon-input');
    let couponValue = couponInput?.value;

    if (!couponValue) {
      const storageValue = localStorage.getItem('coupon_code');
      if (storageValue) {
        couponValue = storageValue;
      }
    }

    const response = await fetch(`${CUSTOMER_API_URL}/search/recommendations`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        skus: [...querySkus],
        accountCode: document.body?.dataset?.companyExternalId,
        campaignCode: couponValue,
      }),
    });
    const data = await response.json();
    if (!data || !data.recommendations?.products?.items || data.recommendations?.products?.items == 0) {
      return;
    }

    const products = data.recommendations.products.items
      .map((i) => ({
        imgUrl: i.image_url,
        title: i.title,
        variant_title: i.variant_title,
        price: 0,
        url: i.url,
        id: i.shopify_id,
        variant_id: i.variant_id,
        sku: i.sku,
        priceBreaksAttribute: i.priceBreaksAttribute,
        is_new: i.is_new,
        is_best_seller: i.is_best_seller,
        stock_status: i.stock_status,
        unit: i.unit,
      }))
      .filter((p) => p.priceBreaksAttribute);

    const loader = document.querySelector('.modal__loader.recommendation');
    if (loader) {
      loader.style.display = 'none';
    }

    this.products = products;

    switch (section) {
      case 'cart':
        this.renderProducts(products.slice(0, 6));
        break;
      case 'recommendations':
        this.renderRecommendations(products.slice(0, 5));
        break;
      default:
        this.renderProducts(products.slice(0, 6));
        break;
    }

    window.updateAllWishlistIcons();
  }

  renderProducts(products) {
    const shouldHidePrices = !document.body.dataset.companyExternalId && document.body.dataset.isVip === 'true';

    const productTable = (p) => {
      if (!p.priceBreaksAttribute) {
        return '';
      }

      // to pull tax
      const gstToggle = document.querySelector('#gst-toggle-input');
      const gstDisabled = gstToggle?.checked == false;

      const breaks = JSON.parse(p.priceBreaksAttribute)?.breaks;
      let tax = JSON.parse(p.priceBreaksAttribute)?.taxRate;
      if (tax > 2) {
        tax = tax / 100;
      }
      const taxable = tax != 1;

      if (!breaks || breaks[0].quantity == 0 || breaks[0].quantity == 999999) {
        return '';
      }

      const cells = breaks
        .map((b) => {
          if (b.quantity == 0) {
            return '';
          }

          // Multiply GST rounding up to nearest cent
          const gstPrice = calculateIncGst(b.value, tax).toFixed(2);

          // Determine price based on GST toggle
          const displayPrice = gstDisabled ? b.value.toFixed(2) : gstPrice;

          return `
         <tr style="border-bottom: 1px solid #eee;">
          <td
            style="text-align: center; border: 1px solid #ddd;"
          >
            ${b.quantity}+
          </td>
          <td
            class="fadein"
            style="text-align: center; border: 1px solid #ddd;"
          >
            ${displayPrice}
          </td>
        </tr>`;
        })
        .join('');

      // Dynamic label based on toggle state and tax
      const priceLabel = gstDisabled ? (taxable ? 'Ex. GST' : 'GST Free') : 'Inc. GST';

      return `<div class="price-breaks-table-wrapper" id="{{product_variant.id}}__price-breaks" style="margin-bottom: 1em;">
        <table style="width:100%; border-collapse: collapse;">
          <thead>
            <tr>
              <th style="border: 1px solid #ddd;">Quantity</th>
              <th style="border: 1px solid #ddd;">
                    Price (${priceLabel})
              </th>
            </tr>
          </thead>
          <tbody>
            ${cells}
          </tbody>
        </table>
      </div>`;
    };

    const productHTML = products
      .map(
        (product) => `
        <div class="product-item product-item--vertical 1/4--lap 1/5--desk 1/6--wide">
          <div class="badges-container">
            ${product.is_new ? `<div class="badge badge--new"><span class="badge__text">New</span></div>` : ''}
            ${
              product.is_best_seller
                ? `<div class="badge badge--best-seller"><svg fill="none" focusable="false" role="presentation" class="icon icon--rating-star rating__star rating__star--full" viewBox="0 0 896 832">
                <path d="M896 320l-313.5-40.781L448 0 313.469 279.219 0 320l230.469 208.875L171 831.938l277-148.812 277.062 148.812L665.5 528.875z" fill-rule="nonzero" fill="currentColor"></path>
              </svg><span class="badge__text">Top Seller</span></div>`
                : ''
            }
          </div>
          ${
            this.isLoggedIn
              ? `
          <wishlist-icon style="text-align: right;" data-product-id="${product.id}">
            <button style="cursor: pointer; text-align:center; width: 20px; height: 20px">
              <div>
                <div data-wishlist-unfav="${product.id}" style="display: none;">
                  <svg focusable="false" viewBox="0 0 24 23" role="presentation" height="20" width="20">
                    <g stroke-width="2" fill="none" fill-rule="evenodd">
                      <path d="M17 1c-2.1 0-3.9 1.1-5 2.7C10.9 2.1 9.1 1 7 1 3.7 1 1 3.7 1 7c0 6 11 15 11 15s11-9 11-15c0-3.3-2.7-6-6-6z" stroke="currentColor" stroke-linecap="square"></path>
                      <path d="M16 5c1.65 0 3 1.35 3 3" stroke="#00badb" stroke-linecap="round"></path>
                    </g>
                  </svg>
                </div>
                <div data-wishlist-fav="${product.id}" style="display: none">
                  <svg focusable="false" viewBox="0 0 24 23" role="presentation" height="20" width="20">
                    <g stroke-width="2" fill="currentColor" fill-rule="evenodd">
                      <path d="M17 1c-2.1 0-3.9 1.1-5 2.7C10.9 2.1 9.1 1 7 1 3.7 1 1 3.7 1 7c0 6 11 15 11 15s11-9 11-15c0-3.3-2.7-6-6-6z" stroke="currentColor" stroke-linecap="square"></path>
                      <path d="M16 5c1.65 0 3 1.35 3 3" stroke="#00badb" stroke-linecap="round"></path>
                    </g>
                  </svg>
                </div>
              </div>
            </button>
          </wishlist-icon>
          `
              : ''
          }
          <a href="${product.url}" class="product-item__image-wrapper">
            <div class="aspect-ratio aspect-ratio--short">
              <img src="${product.imgUrl}" alt="${product.variant_title || product.title}" width="100" height="100" class="product-item__primary-image">
            </div>
          </a>
          <div class="product-item__info">
            <div class="product-item__info-inner"> 
                <div class='justify-between' style="display: flex;"> 
                  ${product.sku}
                  ${
                    product.stock_status == 'low stock'
                      ? `<div><p class="product-label product-label--low-stock">Back Soon</p></div>`
                      : ''
                  }
                </div>
                
              <a href="${product.url}" class="product-item__title text--strong link" data-vtitle="${product.variant_title}">${product.variant_title || product.title}</a>
            </div>
            ${
              !shouldHidePrices
                ? `<form method="post" action="/cart/add" accept-charset="UTF-8" class="product-item__action-list button-stack" enctype="multipart/form-data">
              <input type="hidden" name="form_type" value="product">
              <input type="hidden" name="utf8" value="✓">
              <input type="hidden" name="id" value="${product.variant_id}">
              <input type="text" hidden="" id="priceBreaks" data-variant-sku="${product.sku}" name="properties[_priceBreaks]" readonly="" value='${product.priceBreaksAttribute}'>
              ${productTable(product)}
              <div class="quantity-selector d-flex justify-end unit px-2">
                <input class="quantity-selector__value" name="quantity" value="1" style="text-align:right">
                <div> ${product.unit || 'Units'} </div>
              </div>
              <button type="submit" class="product-item__action-button button button--small button--primary" data-action="add-to-cart">Add to cart</button>
            </form>`
                : 'Please Login for Prices'
            }
          </div>
        </div>
        `,
      )
      .join('');

    this.innerHTML = `
      <header class="section__header">
        <h2 class="section__title heading h3">You may also like</h2>
      </header>
      <div
        class="product-recommendations product-list product-list--scrollable" 
        style="border: 1px solid var(--border-color);flex-wrap:nowrap"
        >
        ${productHTML}
      </div>
    `;
  }

  renderRecommendations(products) {
    if (products.length === 0) {
      this.parentElement.innerHTML = '<p>No results.</p>';
      return;
    }

    const productHTML = products
      .map(
        (product) =>
          `<div class="product-search-item">
          <a href="${product.url}" class="product-search-link">
          <img class="product-search-image" src="${product.imgUrl}" alt="${product.title}">
          <div class="product-search-details">
          <h3 class="product-search-title">${product.title}</h3>
          <div class="product-search-code">${product.sku}</div>
          </div>  
          </a>
          </div>
      `,
      )
      .join('');
    this.innerHTML = `
        ${productHTML}
      `;
  }
}

class SearchDropdown extends HTMLElement {
  isNavigationVisible = false;

  constructor() {
    super();
    this._attachListeners();

    //** This is borked, so leaving out for now */
    // this._scrollHideInit();
  }

  _scrollHideInit() {
    // keep track of previous scroll position
    let prevScrollPos = window.pageYOffset;

    window.addEventListener('scroll', function () {
      // current scroll position
      const currentScrollPos = window.pageYOffset;

      const searchContainer = document.querySelector('.search-container');
      if (prevScrollPos > currentScrollPos) {
        // user has scrolled up
        searchContainer.classList.add('expanded');
      } else {
        // user has scrolled down
        searchContainer.classList.remove('expanded');
      }

      // update previous scroll position
      prevScrollPos = currentScrollPos;
    });
  }

  _attachListeners() {
    this.addEventListener('click', this._toggleNavigation.bind(this));
  }
  _onFocusOut(event2) {
    if (event2.relatedTarget !== null && !this.contains(event2.relatedTarget)) {
      this._closeNavigation();
    }
  }
  _onClick(event2) {
    if (!this.contains(event2.target)) {
      this._closeNavigation();
    }
  }
  _openNavigation() {
    this.querySelector('[data-type="menu"]').setAttribute('aria-hidden', 'false');
    this.querySelector('div[data-type="menu"]').classList.remove('click-through');
    this.isNavigationVisible = true;
  }
  _closeNavigation() {
    this.querySelector('[data-type="menu"]').setAttribute('aria-hidden', 'true');
    this.querySelector('div[data-type="menu"]').classList.add('click-through');
    this.isNavigationVisible = false;
  }
  _toggleNavigation(event2) {
    // console.log('_toggleNavigation', event2.target);
    event2.preventDefault();

    if (this.isNavigationVisible) {
      this._closeNavigation();
    } else {
      if (event2.target.id == 'search-dropdown-open' || event2.target.id == 'search-category-filter') {
        this._openNavigation();
      }
    }
  }
}

class BudgetWidget extends HTMLElement {
  customerId = null;
  locationId = null;
  storeId = null;
  hmac = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this._init();
  }

  async _init() {
    this.customerId = this.dataset.customerId;
    this.locationId = this.dataset.locationId;
    this.storeId = this.dataset.storeId;
    this.hmac = this.dataset.hmac;

    const response = await fetch(
      `${API_URL}/budgets/summary`,
      // `https://danpodburys-macbook-pro.taile55ad.ts.net/budgets/summary`,
      {
        method: 'GET',
        headers: {
          'X-Storefront-Customer-Id': this.customerId,
          'X-Storefront-Location-Id': this.locationId,
          'X-Storefront-Store-Id': this.storeId,
          'X-Hmac': this.hmac,
        },
      },
    );
    const data = await response.json();
    if (!data || data.length == 0) {
      return;
    }
    this._renderBudget(data[0]);
  }

  _renderBudget(data) {
    this.innerHTML = `
      <div style="border: 1px solid #ddd; border-radius: 2px;padding: 10px; margin-bottom:1em; display: flex; flex-direction: column">
        <div style="display: flex; flex-direction: column; width: 100%">
          <div style="font-weight: bold; font-size: 1.5em">Budget: ${data.name}</div>
          <div style="display: flex; flex-direction: row; gap: 1em; width: 100%">

            <div style="font-weight: bold">Remaining Spend:</div>
            <div>$${data.remaining}</div>
          </div>
        </div>
        <progress value="${data.spent}" max="${data.total}" style="colour:green; height: 30px; width: 100%"></progress>
      </div>
      `;
  }
}

class CouponCodeInput extends HTMLElement {
  storageKey = 'coupon_code';

  debounceTimer = null;
  isLoading = false;
  initalCart = null;
  cartCouponCode = null;
  textInputElement = null;
  applyButtonElement = null;
  validationIndicatorElement = null;
  appliedStatusMessageElement = null;
  errorDivElement = null;
  companyExternalId = null;
  isB2B = false;

  constructor() {
    super();
  }

  connectedCallback() {
    this._init();
  }

  async _init() {
    this.companyExternalId = document.body.dataset.companyExternalId;
    this.isB2B = document.body.dataset.isB2b === 'true';

    await this._disableCheckoutButton();

    await this._initialiseInputs();
    await this._initaliseValidationIndicator();
    await this._initialiseInputListeners();

    await this._initialiseCartState();
    await this._getCouponCodeFromCart();
    await this._reconcileBadCouponState();
    await this._initialiseCouponState();

    await this._updateValidationState();

    await this._enableCheckoutButton();

    console.log('CouponCodeInput: initialisation complete');
  }

  async _initialiseInputs() {
    this.textInputElement = this.querySelector('input');
    if (!this.textInputElement) {
      throw new Error('CouponCodeInput: No input element found');
    }

    this.applyButtonElement = document.querySelector('.coupon-code__apply-button');
    if (!this.applyButtonElement) {
      throw new Error('CouponCodeInput: No apply button element found');
    }

    this.errorDivElement = this.querySelector('.coupon-code__error');
    if (!this.errorDivElement) {
      throw new Error('CouponCodeInput: No error div element found');
    }

    this.appliedStatusMessageElement = document.querySelector('.coupon-code__applied-status-message');
  }

  async _initialiseInputListeners() {
    this.textInputElement.addEventListener('input', async () => {
      await this.textInputListener();
    });

    this.textInputElement.addEventListener('keyup', async (event) => {
      if (event.key === 'Enter') {
        await this.applyButtonListener();
      }
    });

    this.applyButtonElement.addEventListener('click', async () => {
      await this.applyButtonListener();
    });
  }

  async applyButtonListener() {
    const code = this.textInputElement.value.trim();

    // Set loading state
    this._setValidationState('loading');

    try {
      // Validate campaign code first
      const isValid = await this._validateCampaignCode(code);
      if (isValid) {
        this._setValidationState('valid-applying');
        await this._disableCheckoutButton();
        await this._applyCouponToCart(code);
      } else {
        this._setValidationState('invalid');
      }
    } catch (error) {
      await this._enableCheckoutButton();
      console.error('Failed to apply coupon: ' + error);
      this._displayError('Something went wrong, please try again later.');
      this._setValidationState('invalid');
    }
  }

  async textInputListener() {
    // loading state while typing
    this._setValidationState('loading');

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    this.debounceTimer = setTimeout(async () => {
      await this._updateValidationState();
    }, 500);
  }

  async _applyCouponToCart(code) {
    const lines = this.initalCart.items;

    // grab all the skus in the cart
    const skus = lines.map((line) => line.sku);

    // fetch the pricebreaks
    const pricebreaksResponse = await fetch(`${API_URL}/pricing${this.isB2B ? '' : '/dtc'}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        skus,
        couponCode: code,
        accountNumber: this.companyExternalId,
        token: 'f3243f29-cdba-4b1c-bb62-ef9330db1450',
      }),
    });

    const refetchedPricebreaks = await pricebreaksResponse.json();

    const breakMap = await this._parsePriceBreaks(refetchedPricebreaks);

    // update cart lines
    const updates = lines.map((line) => {
      return {
        id: line.id.toString(),
        quantity: line.quantity,
        properties: {
          ...line.properties,
          _priceBreaks: breakMap[line.sku],
        },
      };
    });

    for (const update of updates) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(update),
      });
    }

    // update cart attribute
    var formData = new FormData();
    formData.append('attributes[_campCode]', code);

    // clear existing dicount codes, because they can't be combined with campaign codes
    formData.append('discount', '');

    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData,
    });

    // reload the cart
    window.location.reload();
  }

  async _initaliseValidationIndicator() {
    // Create validation indicator element
    const validationIndicator = document.createElement('span');
    validationIndicator.className = 'coupon-code__validation-indicator';
    validationIndicator.style.cssText = `
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 20px;
          font-weight: bold;
          pointer-events: none;
          opacity: 0;
          z-index: 10;
        `;

    // Wrap input in a relative container that maintains flex behavior
    const inputWrapper = document.createElement('div');
    inputWrapper.style.cssText = 'position: relative; flex: 1; display: flex;';

    // Move input into wrapper
    const inputGroup = this.textInputElement.parentNode;
    inputGroup.insertBefore(inputWrapper, this.textInputElement);
    inputWrapper.appendChild(this.textInputElement);
    inputWrapper.appendChild(validationIndicator);

    // Make input take full width of wrapper and add padding for indicator
    this.textInputElement.style.cssText = this.textInputElement.style.cssText + '; width: 100%; padding-right: 45px;';

    this.validationIndicatorElement = this.querySelector('.coupon-code__validation-indicator');
    if (!this.validationIndicatorElement) {
      throw new Error('CouponCodeInput: No validation indicator element found');
    }
  }

  async _initialiseCartState() {
    /* get the inital cart */
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    this.initalCart = cart;
  }

  /* Either the cart has lines with a coupon code, or the cart is empty and we fallback to cart attribute */
  async _getCouponCodeFromCart() {
    if (this.initalCart.items.length > 0) {
      this.cartCouponCode = JSON.parse(this.initalCart.items[0].properties._priceBreaks || '{}').couponCode;
    } else {
      this.cartCouponCode = this.initalCart.attributes._campCode;
    }
  }

  /* If something has gone horribly wrong and the lines in the cart have different coupon codes
    or the lines have a coupon code but the cart attribute does not
    we need to refetch the pricebreaks and ensure these are all the same
  */
  async _reconcileBadCouponState() {
    // is there inconsistency between the lines and the cart attribute?
    const lines = this.initalCart.items;
    const cartAttribute = this.initalCart.attributes._campCode;

    const someLinesHaveDifferentCouponCodes = lines.some(
      (line) => (JSON.parse(line.properties._priceBreaks || '{}').couponCode || '') != (cartAttribute || ''),
    );

    if (someLinesHaveDifferentCouponCodes) {
      // use the cart attribute as the source of truth
      this.cartCouponCode = cartAttribute;

      console.warn('cart is in a bad state, reconciling');

      // grab all the skus in the cart
      const skus = lines.map((line) => line.sku);

      // fetch the pricebreaks
      const pricebreaksResponse = await fetch(`${API_URL}/pricing${this.isB2B ? '' : '/dtc'}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          skus,
          couponCode: this.cartCouponCode,
          accountNumber: this.companyExternalId,
          token: 'f3243f29-cdba-4b1c-bb62-ef9330db1450',
        }),
      });

      const refetchedPricebreaks = await pricebreaksResponse.json();

      const breakMap = await this._parsePriceBreaks(refetchedPricebreaks);

      // update the cart lines with the new pricebreaks
      const updates = lines.map((line) => {
        return {
          id: line.id.toString(),
          quantity: line.quantity,
          properties: {
            ...line.properties,
            _priceBreaks: breakMap[line.sku],
          },
        };
      });

      for (const update of updates) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(update),
        });
      }

      // reload the cart
      await window.location.reload();
    }
  }

  /* We always want to use the coupon code in the cart if it exists */
  async _initialiseCouponState() {
    if (this.cartCouponCode) {
      this.textInputElement.value = this.cartCouponCode;
      localStorage.setItem(this.storageKey, this.cartCouponCode);
    } else {
      this.textInputElement.value = '';
      localStorage.removeItem(this.storageKey);
    }
  }

  async _updateValidationState() {
    // initialise
    const query = this.textInputElement.value.trim();

    let isValid = false;
    this._setValidationState('loading');

    // empty input, no validation required
    if (!query) {
      this._setValidationState('valid-empty');
      return;
    }

    // coupon code is already applied to cart
    if (query == this.cartCouponCode) {
      this._setValidationState('valid-applied');
      return;
    }

    // validate
    try {
      isValid = await this._validateCampaignCode(query);
      this._setValidationState(isValid ? 'valid-unapplied' : 'invalid');
    } catch (error) {
      console.error('Failed to validate coupon:', error);
      this._setValidationState('invalid');
    }
  }

  async _setValidationState(newState) {
    this.applyButtonElement.classList.remove('is-loading');

    switch (newState) {
      case 'valid-unapplied':
        this.applyButtonElement.innerHTML = 'Apply';
        this.applyButtonElement.disabled = false;
        this.validationIndicatorElement.textContent = '✓';
        this.validationIndicatorElement.style.color = 'green';
        this.validationIndicatorElement.style.opacity = '1';
        this.appliedStatusMessageElement.classList.add('d-none');
        break;
      case 'valid-applying':
        this.applyButtonElement.innerHTML = 'Applying...';
        this.applyButtonElement.disabled = true;
        this.validationIndicatorElement.style.opacity = '0';
        this.appliedStatusMessageElement.classList.add('d-none');
        break;
      case 'valid-applied':
        this.applyButtonElement.innerHTML = 'Applied';
        this.applyButtonElement.disabled = true;
        this.validationIndicatorElement.style.opacity = '0';
        this.appliedStatusMessageElement.classList.remove('d-none');
        break;
      case 'valid-empty':
        this.applyButtonElement.innerHTML = this.cartCouponCode ? 'Clear' : 'Apply';
        this.applyButtonElement.disabled = false;
        this.validationIndicatorElement.style.opacity = '0';
        this.appliedStatusMessageElement.classList.add('d-none');
        break;
      case 'invalid':
        this.applyButtonElement.innerHTML = 'Apply';
        this.applyButtonElement.disabled = true;
        this.validationIndicatorElement.textContent = '✗';
        this.validationIndicatorElement.style.color = 'red';
        this.validationIndicatorElement.style.opacity = '1';
        this.appliedStatusMessageElement.classList.add('d-none');
        break;
      case 'loading':
        this.applyButtonElement.classList.add('is-loading');
        this.applyButtonElement.innerHTML = 'Applying...';
        this.applyButtonElement.disabled = true;
        this.validationIndicatorElement.style.opacity = '0';
        this.appliedStatusMessageElement.classList.add('d-none');
        break;
    }
  }

  async _validateCampaignCode(code) {
    const response = await fetch(`${API_URL}/discounts/is-valid?code=${code}`);
    const data = await response.json();
    return data.success;
  }

  async _disableCheckoutButton() {
    const checkoutButtons = Array.from(document.querySelectorAll('button[name="checkout"]'));
    for (const b of checkoutButtons) {
      b.disabled = true;
    }

    const saveCartButton = document.querySelector('#save-cart-rendered-button');
    if (saveCartButton) {
      saveCartButton.style.display = 'none';
    }
  }

  async _enableCheckoutButton() {
    const checkoutButtons = Array.from(document.querySelectorAll('button[name="checkout"]'));
    for (const b of checkoutButtons) {
      b.disabled = false;
    }

    const saveCartButton = document.querySelector('#save-cart-rendered-button');
    if (saveCartButton) {
      saveCartButton.style.display = 'block';
    }
  }

  async _displayError(error) {
    this.errorDivElement.innerHTML = error;
    this.errorDivElement.style.opacity = '1';
  }

  async _parsePriceBreaks(priceBreaks) {
    if (!priceBreaks?.length) return [];

    let breakMap = {};

    // Find the correct pricebreak for the qty, then grab its price
    for (const breakData of priceBreaks) {
      let breakList = [];
      for (let i = 1; i < 5; i++) {
        breakList.push({
          quantity: parseInt(breakData[`price_break${i}_qty`]),
          value: parseFloat(breakData[`price_break${i}_ex_gst`]),
        });
      }

      breakMap[breakData.sku] = JSON.stringify({
        breaks: breakList,
        taxRate: breakData.taxRate,
        hmac: breakData.hmac,
        couponCode: breakData.couponCode,
        accountNumber: breakData.accountNumber,
        priceSource: breakData.price_source,
      });
    }

    return breakMap;
  }
}

class MinicartReconciler extends HTMLElement {
  initalCart = null;
  cartCouponCode = null;
  companyExternalId = null;
  isB2B = false;

  constructor() {
    super();
  }

  connectedCallback() {
    this._init();
  }

  async _init() {
    this.companyExternalId = document.body.dataset.companyExternalId;
    this.isB2B = document.body.dataset.isB2b === 'true';

    // this should run on every page other than the cart page
    // CouponCodeInput will handle it there
    if (window.location.pathname == '/cart') {
      return;
    }

    await this._disableCheckoutButton();

    await this._initialiseCartState();
    await this._reconcileBadCouponState();

    await this._enableCheckoutButton();
  }

  async _initialiseCartState() {
    /* get the inital cart */
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    this.initalCart = cart;
  }

  async _reconcileBadCouponState() {
    // is there inconsistency between the lines and the cart attribute?
    const lines = this.initalCart.items;
    const cartAttribute = this.initalCart.attributes._campCode;

    const someLinesHaveDifferentCouponCodes = lines.some(
      (line) => (JSON.parse(line.properties._priceBreaks || '{}').couponCode || '') != (cartAttribute || ''),
    );

    if (someLinesHaveDifferentCouponCodes) {
      // use the cart attribute as the source of truth
      this.cartCouponCode = cartAttribute;

      console.warn('cart is in a bad state, reconciling');

      // grab all the skus in the cart
      const skus = lines.map((line) => line.sku);

      // fetch the pricebreaks
      const pricebreaksResponse = await fetch(`${API_URL}/pricing${this.isB2B ? '' : '/dtc'}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          skus,
          couponCode: this.cartCouponCode,
          accountNumber: this.companyExternalId,
          token: 'f3243f29-cdba-4b1c-bb62-ef9330db1450',
        }),
      });

      const refetchedPricebreaks = await pricebreaksResponse.json();

      const breakMap = await this._parsePriceBreaks(refetchedPricebreaks);

      // update the cart lines with the new pricebreaks
      const updates = lines.map((line) => {
        return {
          id: line.id.toString(),
          quantity: line.quantity,
          properties: {
            ...line.properties,
            _priceBreaks: breakMap[line.sku],
          },
        };
      });

      for (const update of updates) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(update),
        });
      }

      // reload the cart
      await window.location.reload();
    }
  }

  async _parsePriceBreaks(priceBreaks) {
    if (!priceBreaks?.length) return [];

    let breakMap = {};

    // Find the correct pricebreak for the qty, then grab its price
    for (const breakData of priceBreaks) {
      let breakList = [];
      for (let i = 1; i < 5; i++) {
        breakList.push({
          quantity: parseInt(breakData[`price_break${i}_qty`]),
          value: parseFloat(breakData[`price_break${i}_ex_gst`]),
        });
      }

      breakMap[breakData.sku] = JSON.stringify({
        breaks: breakList,
        taxRate: breakData.taxRate,
        hmac: breakData.hmac,
        couponCode: breakData.couponCode,
        accountNumber: breakData.accountNumber,
        priceSource: breakData.price_source,
      });
    }

    return breakMap;
  }

  async _disableCheckoutButton() {
    const checkoutButton = document.querySelector('.mini-cart__button-container button[name="checkout"]');
    if (checkoutButton) {
      checkoutButton.disabled = true;
    }
  }

  async _enableCheckoutButton() {
    const checkoutButton = document.querySelector('.mini-cart__button-container button[name="checkout"]');
    if (checkoutButton) {
      checkoutButton.disabled = false;
    }
  }
}

class GstToggle extends HTMLElement {
  isLoading = false;
  incLabel = 'Inc. GST';
  exLabel = 'Ex. GST';

  constructor() {
    super();
  }

  connectedCallback() {
    this._init();
  }

  async _init() {
    const storageKey = 'prices_incl_gst';
    let input = this.querySelector('input[type="checkbox"]');

    // If no input exists, create the complete toggle structure
    if (!input) {
      this._createToggleStructure();
      input = this.querySelector('input[type="checkbox"]');
    }

    if (!input) {
      console.warn('GstToggle: Failed to create checkbox input element');
      return;
    }

    // Load from localStorage - default to false (Exc GST)
    const savedValue = localStorage.getItem(storageKey);
    if (savedValue !== null) {
      input.checked = savedValue === 'true';
    } else {
      input.checked = true; // Default to Incl GST
      localStorage.setItem(storageKey, 'true');
    }

    // Save to localStorage on change
    input.addEventListener('change', () => {
      localStorage.setItem(storageKey, input.checked.toString());

      document.dispatchEvent(new CustomEvent('price:rerender'));

      this._updateLabelStates();
      this._updateCartPrices();
    });

    // document.addEventListener('theme:loading:end', () => {
    //   console.log('theme:loading:end');
    //   this._updateCartPrices();
    // });

    document.addEventListener('cart:rerendered', () => {
      this._updateCartPrices();
    });

    // Add labels for better UX
    this._initaliseLabelStates();
    this._updateCartPrices();
  }

  _createToggleStructure() {
    // Create the complete toggle structure (styles are in custom.css)
    this.innerHTML = `
      <div class="gst-toggle-container">

        <div style="display: flex; flex-direction: column; justify-content: space-between">
          <span class="gst-label gst-label-left">${this.incLabel}</span>
        </div>
        <label class="switch">
          <input id="gst-toggle-input" type="checkbox"/>
          <span class="slider round">
          </span>
        </label>
        <div style="display: flex; flex-direction: column; justify-content: space-between">
          <span class="gst-label gst-label-right active">${this.exLabel}</span>
        </div>
      </div>
    `;
  }

  _updateCartPrices() {
    // determine gst state
    const input = this.querySelector('input[type="checkbox"]');
    if (!input) {
      return;
    }
    const gstDisabled = input.checked == false;

    // grab cart price fields
    const cartPrices = document.querySelectorAll('[data-gst-inc-price]');
    const cartPricesFree = document.querySelectorAll('[data-gst-free-price]');
    const cartPricesTitle = document.querySelectorAll('[data-gst-title]');

    // update line item prices and labels
    if (gstDisabled) {
      for (const price of cartPricesFree) {
        price.classList.remove('d-none');
      }
      for (const price of cartPrices) {
        price.classList.add('d-none');
      }
      for (const price of cartPricesTitle) {
        price.innerText = '(Ex. GST)';
      }
    } else {
      for (const price of cartPricesFree) {
        price.classList.add('d-none');
      }
      for (const price of cartPrices) {
        price.classList.remove('d-none');
      }
      for (const price of cartPricesTitle) {
        price.innerText = '(Inc. GST)';
      }
    }

    // get cart total price
    const cartPricesCartTotalInc = document.querySelector('[data-gst-inc-cart-total]');
    const cartPricesCartTotalFree = document.querySelector('[data-gst-free-cart-total]');

    if (!cartPricesCartTotalInc || !cartPricesCartTotalFree) {
      return;
    }

    if (gstDisabled) {
      cartPricesCartTotalFree.classList.remove('d-none');
      cartPricesCartTotalInc.classList.add('d-none');
    } else {
      cartPricesCartTotalFree.classList.add('d-none');
      cartPricesCartTotalInc.classList.remove('d-none');
    }
  }

  _initaliseLabelStates() {
    const input = this.querySelector('input[type="checkbox"]');
    const labelRight = this.querySelector('.gst-label-right');
    const labelLeft = this.querySelector('.gst-label-left');

    // if (input && labelRight && labelLeft) {
    //   if (!input.checked) {
    //     labelLeft.classList.add('active');
    //     labelRight.classList.remove('active');
    //   }
    // }
  }
  _updateLabelStates() {
    const input = this.querySelector('input[type="checkbox"]');
    const labelRight = this.querySelector('.gst-label-right');
    const labelLeft = this.querySelector('.gst-label-left');

    // if (input && labelRight && labelLeft) {
    //   if (input.checked) {
    //     // Incl GST is active
    //     labelLeft.classList.remove('active');
    //     labelRight.classList.add('active');
    //   } else {
    //     // Exc GST is active
    //     labelLeft.classList.add('active');
    //     labelRight.classList.remove('active');
    //   }
    // }
  }
}

class TypesenseSearch extends HTMLElement {
  isLoggedIn = null;

  defaultPagination = {
    size: 0,
    perPage: 0,
    currPage: 1,
    nextPage: null,
    totalPages: 1,
    total: 0,
  };

  results = { products: [], collections: [], pages: [] };
  facets = [];
  pagination = { products: this.defaultPagination, collections: this.defaultPagination, pages: this.defaultPagination };
  page = 1;
  per_page = 24;
  query = '';
  filters = '';
  sort_by = '_text_match:desc'; // Default sort by relevance
  available_filters = ['price', 'brand', 'collections'];
  _filtersReady = null;

  constructor() {
    super();
  }

  connectedCallback() {
    // console.log('TypesenseSearch connectedCallback');
    this.isLoggedIn = Boolean(document.body.dataset.isLoggedIn == 'true');
    this._filtersReady = fetch(`${API_URL}/search/filter`)
      .then((res) => res.json())
      .then((data) => {
        this.available_filters.push(...data.filter((f) => f!= 'color'));
      })
      .catch((err) => {
        console.error('Error fetching available filters:', err);
      });

    const handleUrlChange = async () => {
      // console.log('triggered');
      this.page = new URLSearchParams(window.location.search)?.get('page') || 1;
      this.query =
        new URLSearchParams(window.location.search)?.get('q') ||
        new URLSearchParams(window.location.search)?.get('query');
      this.per_page = document.getElementById('items_per_page')?.innerText || 24;
      this.sort_by = new URLSearchParams(window.location.search)?.get('sort_by') || 'relevance';
      this.filters = {};

      for (const [key, value] of new URLSearchParams(window.location.search).entries()) {
        if (key.startsWith('filter.') && !!value) {
          if (key == 'filter.v.price.gte') {
            this.filters.price = { ...this.filters.price, gte: value };
          } else if (key == 'filter.v.price.lte') {
            this.filters.price = { ...this.filters.price, lte: value };
          } else {
            if (Object.keys(this.filters).includes(key.replace('filter.', ''))) {
              this.filters[key.replace('filter.', '')].push(value);
            } else {
              this.filters[key.replace('filter.', '')] = [value];
            }
          }
        }
      }

      await this._filtersReady;

      this.populateResults();
    };

    // Re-run when URL changes via browser navigation
    if (!window._typesensePopstateBound) {
      window.addEventListener('popstate', () => {
        handleUrlChange();
      });
      window._typesensePopstateBound = true;
    }

    // Intercept sort dropdown clicks to handle them without modifying theme.js
    this._addSortEventListeners();

    handleUrlChange();

    // Monkey patch pushState to trigger as well
    const originalPushState = history.pushState;
    history.pushState = function () {
      originalPushState.apply(this, arguments);
      window.dispatchEvent(new Event('popstate')); // trigger listener manually
    };

    // listen for price:rerender
    document.addEventListener('price:rerender', () => {
      this.renderProducts(this.results.products);
    });
  }

  // Add event listeners to intercept sort dropdown clicks
  _addSortEventListeners() {
    // Use event delegation to catch sort dropdown clicks
    document.addEventListener('click', (event) => {
      // Check if this is a sort option click
      if (event.target.matches('[data-action="select-value"][data-value]')) {
        const sortContainer = event.target.closest('.collection__toolbar-item--sort');
        if (sortContainer) {
          event.preventDefault();
          event.stopPropagation();

          const sortValue = event.target.getAttribute('data-value');
          console.log('Sort option clicked:', sortValue);

          // Update the sort_by property
          this.sort_by = sortValue;

          // Update the URL with the new sort parameter
          const url = new URL(window.location);
          url.searchParams.set('sort_by', sortValue);

          // Update the browser URL without triggering a page reload
          window.history.pushState({}, '', url);

          // Trigger our search update
          this.populateResults();
        }
      }
    });
  }

  // Populate all search results
  async populateResults() {
    // console.log('available_filters', this.available_filters.join(','));
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    const companyExternalId = document.body.dataset.companyExternalId;
    const couponCode = localStorage.getItem('coupon_code');
    const collectionFilter = 'All'; //searchFilterName.dataset.value;

    // Check for My Products filter from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const myProductsFilter = urlParams.get('filter.my_products') === '1';

    let collection = collectionFilter != 'All' ? collectionFilter : undefined;

    // Get subdomain for VIP filtering
    const subdomain = window.location.hostname.split('.')[0];
    let vip = collection === 'my-products' || myProductsFilter ? subdomain : undefined;

    // no search escape hatch
    if (this.query == '') {
      return;
    }

    // build filterBy parameter
    let filterBy = vip ? [`vip_domains:=${vip}`] : [];
    const filterByString = filterBy.length ? `&filter_by=${filterBy.join(' %26%26 ')}` : '';

    const filterByWithCollection =
      collection && collection !== 'my-products'
        ? [...filterBy, `collections:=${encodeURIComponent(collection)}`]
        : filterBy;

    const filters = Object.entries(this.filters)
      .map(([key, value]) => {
        if (key == 'price') {
          if (value.gte && value.lte) {
            return `price:=[${value.gte}..${value.lte}]`;
          } else if (value.gte) {
            return `price:>=${value.gte}`;
          } else if (value.lte) {
            return `price:<=${value.lte}`;
          }
        } else if (key == 'new_arrival') {
          return `is_new:=true`;
        } else if (key == 'best_seller') {
          return `is_best_seller:=true`;
        } else if (key == 'my_products') {
          // my_products is handled by VIP domain logic, not as a direct filter
          return null;
        } else {
          return `${key}:=[${value.map((v) => `\`${v}\``).join(',')}]`;
        }
      })
      .filter((filter) => filter !== null);
    const productFiltersAll = filterBy.concat(filters).join(' && ');
    const excludedFacetKeys = ['new_arrival', 'best_seller', 'my_products'];

    const facet_by = this.available_filters.join(',');
    const productSearchQueries = [
      {
        q: this.query,
        page: this.page,
        per_page: this.per_page,
        sort_by: this.sort_by,
        ...(productFiltersAll && { filter_by: productFiltersAll }),
        facet_by: facet_by,
      },
    ];

    Object.keys(this.filters).forEach((key) => {
      if (!excludedFacetKeys.includes(key)) {
        const filtersByOtherThanFacet = filterBy.concat(filters.filter((f) => !f.startsWith(key))).join(' && ');
        productSearchQueries.push({
          q: this.query,
          page: this.page,
          per_page: this.per_page,
          filter_by: filtersByOtherThanFacet,
          facet_by: key,
        });
      }
    });
    // execute queries, we split these up by schema because not all filters are available in each and will error.
    // eg. passing collection:= to anything other than product_schema
    try {
      const coreQuery = `${API_URL}/search?q=${this.query}&page=${this.page}&per_page=${this.per_page}`;

      const productResponse = await fetch(
        `${API_URL}/search/products${companyExternalId ? `?accountCode=${companyExternalId}${couponCode ? `&campaignCode=${couponCode}` : ''}` : ''}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(productSearchQueries),
        },
      );

      const pageResponse = await fetch(`${coreQuery}${filterByString}&schema=page_schema`);
      const blogResponse = await fetch(`${coreQuery}${filterByString}&schema=blog_schema`);

      await Promise.all([await productResponse.json(), await pageResponse.json(), await blogResponse.json()]).then(
        ([productResults, pageData, blogData]) => {
          const mapping = [
            { key: 'products', data: productResults?.[0]?.products },
            { key: 'pages', data: pageData?.pages },
            { key: 'blogs', data: blogData?.blogs },
          ];

          for (const { key, data } of mapping) {
            this.results[key] = data?.items || [];
            this.pagination[key] = data?.pagination || this.defaultPagination;
            if (key == 'products') {
              this.facets = data?.facets || [];
            }
          }
          if (productResults?.length > 1) {
            productResults.forEach((result, index) => {
              if (index == 0) return;
              const facet = result.products.facets?.[0];
              if (!facet) return;
              const existingIndex = this.facets.findIndex((f) => f.field_name === facet.field_name);
              if (existingIndex !== -1) {
                this.facets[existingIndex] = facet; // Replace existing facet
              }
            });
          }
        },
      );
    } catch (error) {
      console.error('Error populateResults:', error);
    }

    // console.log(this.results);
    this.renderProducts(this.results.products);
    this.renderAvailableFilters(this.facets);
    this.renderMobileFilters(this.facets);
    this.updatePagination();
    this.updateSortUI();
    window.updateAllWishlistIcons();
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  }

  renderProducts(products) {
    const typesenseSearchResults = document.getElementById('typesense-search-results');
    if (products.length == 0) {
      typesenseSearchResults.innerHTML =
        '<div style="display:flex;justify-content:center;align-items:center;height: 5em;width:100%;font-size:2em"><div>No Results</div></div>';
    }

    const gstToggle = document.querySelector('#gst-toggle-input');
    const gstDisabled = gstToggle?.checked == false;

    const productTable = (p, isGroup = false) => {
      if (!p.priceBreaksAttribute) {
        return '';
      }

      const breaks = JSON.parse(p.priceBreaksAttribute)?.breaks;
      let tax = JSON.parse(p.priceBreaksAttribute)?.taxRate;
      if (tax > 2) {
        tax = tax / 100;
      }
      const taxable = tax != 1;

      // console.log(p.sku, breaks, tax);

      if (!breaks || breaks[0].quantity == 0 || breaks[0].quantity == 999999) {
        return '';
      }

      const cells = breaks
        .map((b) => {
          if (b.quantity == 0) {
            return '';
          }

          // Multiply GST rounding up to nearest cent
          const gstPrice = calculateIncGst(b.value, tax).toFixed(2);

          // Determine price based on GST toggle
          const displayPrice = gstDisabled ? b.value.toFixed(2) : gstPrice;

          return `
         <tr style="border-bottom: 1px solid #eee;">
          <td
            style="text-align: center; border: 1px solid #ddd;"
          >
            ${b.quantity}+
          </td>
          <td
            style="text-align: center; border: 1px solid #ddd;"
          >
            ${displayPrice}
          </td>
        </tr>`;
        })
        .join('');

      // Dynamic label based on toggle state and tax
      const priceLabel = taxable ? (gstDisabled ? 'Ex. GST' : 'Inc. GST') : 'GST Free';

      return `<div class="price-breaks-table-wrapper ${isGroup ? 'product-group-price-breaks' : ''}" data-product-group-id="${p.group_id}" id="${p.shopify_variant_id}__price-breaks" style="margin-bottom: 1em;" data-product-group-sku="${p.sku}">
        <table style="width:100%; border-collapse: collapse;">
          <thead>
            <tr>
              <th style="border: 1px solid #ddd;">Quantity</th>
              <th style="border: 1px solid #ddd;" data-pricing-title>
                  Price (${priceLabel})
              </th>
            </tr>
          </thead>
          <tbody>
            ${cells}
          </tbody>
        </table>
      </div>`;
    };

    const selectBox = (p) => {
      if (!p.is_group || !p.group_id) return '<div class="product-group-select-wrapper"></div>';
      return `
      <div class="product-group-select-wrapper">
        <select id="product-group-${p.group_id}">
          ${p.group_members
            .filter((m) => m.group_id == p.group_id && !!m.description)
            .map((m) => `<option value="${m.sku}" ${m.sku == p.sku ? 'selected' : ''}>${m.description}</option>`)
            .join('')}
        </select>
      </div>`;
    };

    const productImages = (p) => {
      if (!p.is_group || !p.group_id) return '';
      return p.group_members
        .filter((m) => m.group_id == p.group_id && !!m.description)
        .map(
          (m) => `
           <a href="${m.url}" class="product-item__image-wrapper product-group-image" data-product-group-id="${p.group_id}" data-product-group-sku="${m.sku}">
              <div class="aspect-ratio aspect-ratio--short">
                <img src="${m.image_url}" alt="${m.variant_title}" width="567" height="567">
              </div>
            </a>
            `,
        )
        .join('');
    };

    const productInfo = (p, isGroup = false) => {
      return `
            <div class="product-item__info-inner ${isGroup ? 'product-group-info-inner' : ''}" data-product-group-id="${p.group_id}" ${isGroup ? `data-product-group-sku="${p.sku}"` : ''}>  
                <div class='justify-between' style="display: flex;"> 
                  ${p.sku}
                  ${
                    p.stock_status == 'low stock'
                      ? `<div><p class="product-label product-label--low-stock">Back Soon</p></div>`
                      : ''
                  }
                </div>

                <a href="${p.url}" class="product-item__title text--strong link">${p.title}</a>
                <div class="show-in-list">
                  ${p.description}
                </div>
              </div>
      `;
    };

    const productForm = (product, isGroup = false) => {
      return `
      
            <form method="post" action="/cart/add" accept-charset="UTF-8" class="product-item__action-list button-stack ${isGroup ? 'product-group-form' : ''}" enctype="multipart/form-data" data-product-group-id="${product.group_id}" data-product-group-sku="${product.sku}" style='margin-left: 0em;'>
                <input type="hidden" name="form_type" value="product">
                <input type="hidden" name="utf8" value="✓">
                <input type="hidden" name="id" value="${product.shopify_variant_id}">
                <input type="text" hidden="" id="priceBreaks" data-variant-sku="${product.sku}" name="properties[_priceBreaks]" readonly="" value='${product.priceBreaksAttribute}'>
              
                <div class="quantity-selector d-flex justify-end unit px-2">
                  <input class="quantity-selector__value" name="quantity" value="1" style="text-align:right">
                  <div> ${product.unit || 'Units'} </div>
                </div>
                <button type="submit" class="product-item__action-button button button--small button--primary" data-action="add-to-cart">Add to cart</button>
              </form>
      `;
    };

    const productHTML = products
      .map(
        (product) => `
        <div  class="product-item product-item--vertical 1/3--tablet-and-up 1/4--desk">
          <div class="badges-container">
            ${product.is_new ? `<div class="badge badge--new"><span class="badge__text">New</span></div>` : ''}
            ${
              product.is_best_seller
                ? `<div class="badge badge--best-seller"><svg fill="none" focusable="false" role="presentation" class="icon icon--rating-star rating__star rating__star--full" viewBox="0 0 896 832">
                <path d="M896 320l-313.5-40.781L448 0 313.469 279.219 0 320l230.469 208.875L171 831.938l277-148.812 277.062 148.812L665.5 528.875z" fill-rule="nonzero" fill="currentColor"></path>
              </svg><span class="badge__text">Top Seller</span></div>`
                : ''
            }
          </div>
          ${
            this.isLoggedIn
              ? `
            <wishlist-icon style="text-align: right;" data-product-id="${product.shopify_product_id}">
            <button style="cursor: pointer; text-align:center; width: 20px; height: 20px">
              <div>
                <div data-wishlist-unfav="${product.shopify_product_id}" style="display: none;">
                  <svg focusable="false" viewBox="0 0 24 23" role="presentation" height="20" width="20">
                    <g stroke-width="2" fill="none" fill-rule="evenodd">
                      <path d="M17 1c-2.1 0-3.9 1.1-5 2.7C10.9 2.1 9.1 1 7 1 3.7 1 1 3.7 1 7c0 6 11 15 11 15s11-9 11-15c0-3.3-2.7-6-6-6z" stroke="currentColor" stroke-linecap="square"></path>
                      <path d="M16 5c1.65 0 3 1.35 3 3" stroke="#00badb" stroke-linecap="round"></path>
                    </g>
                  </svg>
                </div>
                <div data-wishlist-fav="${product.shopify_product_id}" style="display: none">
                  <svg focusable="false" viewBox="0 0 24 23" role="presentation" height="20" width="20">
                    <g stroke-width="2" fill="currentColor" fill-rule="evenodd">
                      <path d="M17 1c-2.1 0-3.9 1.1-5 2.7C10.9 2.1 9.1 1 7 1 3.7 1 1 3.7 1 7c0 6 11 15 11 15s11-9 11-15c0-3.3-2.7-6-6-6z" stroke="currentColor" stroke-linecap="square"></path>
                      <path d="M16 5c1.65 0 3 1.35 3 3" stroke="#00badb" stroke-linecap="round"></path>
                    </g>
                  </svg>
                </div>
              </div>
            </button>
          </wishlist-icon>
            `
              : ''
          }
          
          <div
            data-product-skus="${product.sku}"
          ></div>
            <a href="${product.url}" class="product-item__image-wrapper" data-product-group-id="${product.group_id}">
              <div class="aspect-ratio aspect-ratio--short">
                <img src="${product.image_url}" alt="${product.variant_title || product.title}" width="567" height="567">
              </div>
            </a>
            ${productImages(product)}
            ${selectBox(product)}
           
            <div class="product-item__info">
                ${productInfo(product)}
                ${product.group_id && product.group_members ? product.group_members?.map((m) => productInfo(m, true)).join('') : ''}
                <div>
                ${productTable(product)}
                ${
                  product.group_id && product.group_members
                    ? product.group_members
                        ?.filter((m) => m.sku != product.sku)
                        .map((m) => productTable(m, true))
                        .join('')
                    : ''
                }
                
                ${productForm(product)}
                ${
                  product.group_id && product.group_members
                    ? product.group_members
                        ?.filter((m) => m.sku != product.sku)
                        .map((m) => productForm(m, true))
                        .join('')
                    : ''
                }
                </div>

            </div>
        </div>
        `,
      )
      .join('');

    typesenseSearchResults.innerHTML = `  ${productHTML} `;
    if (!typesenseSearchResults.dataset.hasSelectHandler) {
      typesenseSearchResults.addEventListener('change', (e) => {
        if (!e.isTrusted) return;

        const select = e.target;
        if (!(select instanceof HTMLSelectElement)) return;
        if (!select.closest('.product-group-select-wrapper')) return;

        if (!select) return;

        const groupId = select.id.replace('product-group-', '');
        const selectedSku = select.value;
        // console.log('selectedSku', selectedSku);

        // hide all siblings in the group, then show the selected SKU
        const nodes = typesenseSearchResults.querySelectorAll(`[data-product-group-id="${groupId}"]`);
        nodes.forEach((el) => {
          const display =
            el.classList.contains('price-breaks-table-wrapper') || el.classList.contains('product-item__action-list')
              ? 'flex'
              : 'block';
          el.style.display = el.getAttribute('data-product-group-sku') === selectedSku ? display : 'none';
        });
      });
      typesenseSearchResults.dataset.hasSelectHandler = '1';
    }
  }

  getVipProductsFilterHtml(isMobile = false) {
    // Check if VIP settings are available
    const vipSettingsScript = document.querySelector('[data-vip-settings]');
    if (!vipSettingsScript) return '';

    const vipData = JSON.parse(vipSettingsScript.textContent);
    if (!vipData.hasVipSettings) return '';

    const urlParams = new URLSearchParams(window.location.search);
    const myProductsChecked = urlParams.get('filter.my_products') === '1';
    const prefix = isMobile ? 'mobile-filter-' : 'filter_';

    return `
      <div class="collection__filter-group">
        <div class="collection__filter-group-name link link--secondary text--strong">
          <label for="${prefix}my_products">My Products</label>
          <input class="switch-checkbox" type="checkbox" name="filter.my_products" id="${prefix}my_products" value="1" ${myProductsChecked ? 'checked' : ''}>
        </div>
      </div>
    `;
  }

  renderAvailableFilters(facets) {
    const searchParams = new URLSearchParams(window.location.search);

    const FIELD_TO_LABEL = {
      brand: 'Brand',
      collections: 'Category',
    };

    const FIELD_TO_ID = {
      brand: 'filter-p-vendor',
      collections: 'filter-v-m-livingstone-cluster_attribute_collections',
    };

    facets.map((f) => {
      if (f.stats.total_values > 0 && f.field_name != 'price') {
        FIELD_TO_LABEL[f.field_name] = f.field_name
          .split('_')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ');
        FIELD_TO_ID[f.field_name] = `filter-v-m-livingstone-cluster_attribute_${f.field_name}`;
      }
    });

    const facet_min = facets.find((f) => f.field_name === 'price')?.stats?.min?.toFixed(2) || 0;
    const facet_max = facets.find((f) => f.field_name === 'price')?.stats?.max?.toFixed(2) || 10000;
    // Inject active filters section
    const priceGte = parseFloat(searchParams.get('filter.v.price.gte')) || facet_min;
    const priceLte = parseFloat(searchParams.get('filter.v.price.lte')) || facet_max;

    const priceRangeLowerPercentage = (priceGte / facet_max) * 100;
    const priceRangeUpperPercentage = (priceLte / facet_max) * 100;

    // check filter container and create if not exists
    const container = document.getElementById('desktop-search-filters');
    let filterList = container.querySelector('.collection__filter-group-list');
    if (!filterList) {
      container.innerHTML = `
      <div class="card">
        <form id="desktop-filters-form" class="card__section card__section--tight">
          <p class="card__title--small heading">Filters</p>
  
          <div class="collection__active-filters"></div>
          <div class="collection__filter-group-list">
            <!-- Price filter (static) -->
            <div class="collection__filter-group">
              <button type="button" class="collection__filter-group-name link link--secondary text--strong"
                data-action="toggle-collapsible" aria-controls="filter-v-price" data-close-siblings="false"
                data-collapsible-force-overflow="true" aria-expanded="false">
                Price
                <svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
                  <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none"
                    stroke-linecap="square"></path>
                </svg>
              </button>
              <div id="filter-v-price" class="collection__filter-collapsible" aria-hidden="true" style="height: 0px; overflow: hidden;"><price-range class="price-range">
                              
                <div class="price-range__range-group range-group" style="--range-min: ${priceRangeLowerPercentage}%; --range-max: ${priceRangeUpperPercentage}%">
                  <input type="range" aria-label="From" class="range" min="${facet_min}" max="${facet_max}" value="${priceGte}">
                  <input type="range" aria-label="To" class="range" min="${facet_min}" max="${facet_max}" value="${priceLte}">
                </div>

                <div class="price-range__input-group">
                  <div class="price-range__input input-prefix">
                    <span class="input-prefix__value">$</span>
                    <input aria-label="From" class="input-prefix__field" type="number" inputmode="numeric" name="filter.v.price.gte" min="${facet_min}" max="${priceLte}" value="${priceGte}" placeholder="0">
                  </div>

                  <span class="price-range__delimiter text--small">-</span>

                  <div class="price-range__input input-prefix">
                    <span class="input-prefix__value">$</span>
                    <input aria-label="To" class="input-prefix__field" type="number" inputmode="numeric" name="filter.v.price.lte" min="${priceGte}" max="${facet_max}" value="${priceLte}" placeholder="${priceLte}">
                  </div>
                </div>
              </price-range></div>
            </div>
  
            
          </div>
        </form>
      </div>
    `;
      filterList = container.querySelector('.collection__filter-group-list');
    }

    const facetMap = Object.fromEntries(facets.map((f) => [f.field_name, f]));
    for (const field of Object.keys(FIELD_TO_LABEL)) {
      const facet = facetMap[field];

      const label = FIELD_TO_LABEL[field];
      const contentId = FIELD_TO_ID[field] || `filter-${field}`;
      const groupId = `filter-group-${field}`;

      let section = document.getElementById(groupId);
      let collapsed = true;
      if (section) {
        const collapsible = section.querySelector('.collapsible');
        if (collapsible) {
          collapsed = collapsible.style.height === '0px';
        }
      } else {
        section = document.createElement('div');
        section.className = 'collection__filter-group';
        section.id = groupId;
        filterList.appendChild(section);
      }

      if (!facet || !facet.counts || facet.counts.length === 0) {
        section.style.display = 'none';
        continue;
      }

      section.style.display = 'block';

      const PAGE_SIZE = 50;
      const totalItems = facet.counts.length;

      // Get current page for this filter (stored in data attribute or default to 1)
      const currentPage = parseInt(section.dataset.filterPage || '1', 10);
      const itemsToShow = currentPage * PAGE_SIZE;

      const items = facet.counts
        .slice(0, itemsToShow)
        .map((item) => {
          const safeId = `filter.${field}.${item.value.replace(/\s+/g, '-')}`;
          const paramName = `filter.${field}`;
          const paramValues = searchParams.getAll(paramName);
          const isChecked = paramValues.includes(item.value);
          return `
          <li class="collection__filter-checkbox">
            <div class="checkbox-wrapper">
              <input type="checkbox" class="checkbox" id="${safeId}" name="filter.${field}" value="${item.value}" ${isChecked ? 'checked' : ''}>
              <svg focusable="false" class="icon icon--check" viewBox="0 0 24 24" role="presentation">
                <path fill="currentColor" d="M9 20l-7-7 3-3 4 4L19 4l3 3z"></path>
              </svg>
            </div>
            <label for="${safeId}">${item.value} (${item.count})</label>
          </li>`;
        })
        .join('');

      const hasMore = itemsToShow < totalItems;
      const remainingCount = totalItems - itemsToShow;
      const viewMoreButton = hasMore
        ? `
        <button type="button" class="button button--small button--transparent button--full" 
          data-action="load-more-filters" data-field="${field}" 
          style="margin-top: 0.5em;">
          View more
        </button>
      `
        : '';

      section.innerHTML = `
        <button type="button" class="collection__filter-group-name link link--secondary text--strong"
          data-action="toggle-collapsible" aria-controls="${contentId}" data-close-siblings="false"
          data-collapsible-force-overflow="true" aria-expanded="${!collapsed}">
          ${label}
          <svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
            <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none"
              stroke-linecap="square"></path>
          </svg>
        </button>
        <div id="${contentId}" class="collapsible" style="height: ${collapsed ? '0px' : 'auto'};">
          <div class="collapsible__content">
            <ul>${items}</ul>
            ${viewMoreButton}
          </div>
        </div>
      `;

      // Store the current page in the section
      section.dataset.filterPage = currentPage.toString();

      // filterList.appendChild(section);
    }

    const newArrivalChecked = searchParams.get('filter.new_arrival') === '1';
    const bestSellerChecked = searchParams.get('filter.best_seller') === '1';

    let bottomFilters = document.getElementById('bottom-filter-group');

    if (!bottomFilters) {
      bottomFilters = document.createElement('div');
      bottomFilters.id = 'bottom-filter-group';
      bottomFilters.innerHTML = `
      <div class="collection__filter-group"><div class="collection__filter-group-name link link--secondary text--strong">
        <label for="filter_best_seller">Best Seller</label>
        <input class="switch-checkbox" type="checkbox" name="filter.best_seller" id="filter_best_seller" value="1" ${bestSellerChecked ? 'checked' : ''}>
      </div></div>
     <div class="collection__filter-group"><div class="collection__filter-group-name link link--secondary text--strong">
        <label for="filter_new_arrival">New Arrival</label>
        <input class="switch-checkbox" type="checkbox" name="filter.new_arrival" id="filter_new_arrival" value="1" ${newArrivalChecked ? 'checked' : ''}>
      </div></div>
      ${this.getVipProductsFilterHtml()}
    `;
      filterList.appendChild(bottomFilters);
    } else {
      bottomFilters.querySelector('#filter_best_seller').checked = bestSellerChecked;
      bottomFilters.querySelector('#filter_new_arrival').checked = newArrivalChecked;

      // Update My Products checkbox if it exists
      const myProductsCheckbox = bottomFilters.querySelector('#filter_my_products');
      if (myProductsCheckbox) {
        const myProductsChecked = searchParams.get('filter.my_products') === '1';
        myProductsCheckbox.checked = myProductsChecked;
      }
    }

    const activeFilters = [];

    for (const [key, value] of searchParams.entries()) {
      if (
        key.startsWith('filter.') &&
        value &&
        !key.startsWith('filter.v.price') &&
        !key.startsWith('filter.new_arrival') &&
        !key.startsWith('filter.best_seller') &&
        !key.startsWith('filter.my_products')
      ) {
        // Generate a matching checkbox ID from field and value
        const safeValue = value.replace(/\s+/g, '-');
        const id = `${key}.${safeValue}`;
        const label = decodeURIComponent(value);
        activeFilters.push(`
      <label for="${id}" class="collection__active-filter-item">
        <span class="collection__active-filter-cross">
          <svg focusable="false" class="icon icon--close" viewBox="0 0 19 19" role="presentation">
            <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
          </svg>
        </span>${label}
      </label>
    `);
      }
    }
    let activeFiltersDiv = container.querySelector('.collection__active-filters');
    if (!activeFiltersDiv) {
      activeFiltersDiv = document.createElement('div');
      activeFiltersDiv.className = 'collection__active-filters';
      const titleEl = container.querySelector('.card__title--small.heading');
      titleEl.insertAdjacentElement('afterend', activeFiltersDiv);
    }
    let clearButton = ``;
    if (activeFilters.length > 0) {
      const clearUrl = new URL(window.location.href);
      // Remove all filters but keep q and sort_by
      for (const key of Array.from(clearUrl.searchParams.keys())) {
        if (key.startsWith('filter.')) clearUrl.searchParams.delete(key);
      }

      clearButton = `
    <button type="button" class="collection__clear-filter button button--small button--transparent button--full" 
      data-action="clear-filters" data-url="${clearUrl.pathname}?${clearUrl.searchParams.toString()}">
      Clear all
    </button>
  `;
    }

    activeFiltersDiv.innerHTML = activeFilters.join('') + clearButton;

    const q = searchParams.get('q');
    let input = document.getElementById('search-query-keep');
    if (input) {
      input.value = q;
    } else {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'q';
      input.id = 'search-query-keep';
      input.value = q;
      container.querySelector('form#desktop-filters-form').appendChild(input);
    }

    // Update sort_by input value
    let sortInput = container.querySelector('input[name="sort_by"]');
    if (sortInput) {
      sortInput.value = this.sort_by;
    }

    // Add event listener for "load more" buttons
    if (!container.dataset.hasLoadMoreHandler) {
      container.addEventListener('click', (e) => {
        const loadMoreButton = e.target.closest('[data-action="load-more-filters"]');
        if (!loadMoreButton) return;

        e.preventDefault();
        const field = loadMoreButton.getAttribute('data-field');
        const groupId = `filter-group-${field}`;
        const section = document.getElementById(groupId);

        if (section) {
          // Increment the page counter
          const currentPage = parseInt(section.dataset.filterPage || '1', 10);
          section.dataset.filterPage = (currentPage + 1).toString();

          // Re-render the filters to show more items
          this.renderAvailableFilters(facets);
        }
      });
      container.dataset.hasLoadMoreHandler = '1';
    }

    //return container;
  }

  renderMobileFilters(facets) {
    const searchParams = new URLSearchParams(window.location.search);
    const FIELD_TO_LABEL = {
      brand: 'Brand',
      collections: 'Category',
    };

    const FIELD_TO_ID = {
      brand: 'filter-p-vendor',
      collections: 'filter-v-m-livingstone-cluster_attribute_collections',
    };

    facets.map((f) => {
      if (f.stats.total_values > 0 && f.field_name != 'price') {
        FIELD_TO_LABEL[f.field_name] = f.field_name
          .split('_')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ');
        FIELD_TO_ID[f.field_name] = `filter-v-m-livingstone-cluster_attribute_${f.field_name}`;
      }
    });

    const mobileList = document.getElementById('mobile-collection-filters-list');
    if (!mobileList) return;

    const priceFacet = facets.find((f) => f.field_name === 'price');

    if (priceFacet && priceFacet.stats) {
      const facet_min = facets.find((f) => f.field_name === 'price')?.stats?.min?.toFixed(2) || 0;
      const facet_max = facets.find((f) => f.field_name === 'price')?.stats?.max?.toFixed(2) || 10000;
      // Inject active filters section
      const priceGte = parseFloat(searchParams.get('filter.v.price.gte')) || facet_min;
      const priceLte = parseFloat(searchParams.get('filter.v.price.lte')) || facet_max;
      const contentId = `mobile-price`;
      const priceRangeLowerPercentage = (priceGte / facet_max) * 100;
      const priceRangeUpperPercentage = (priceLte / facet_max) * 100;
      let mobilePriceFilter = document.getElementById('mobile-filter-v-price');
      let collapsed = true;

      if (!mobilePriceFilter) {
        mobilePriceFilter = document.createElement('div');
        mobilePriceFilter.className = 'collection__filter-group';
        mobilePriceFilter.id = 'mobile-filter-v-price';
        mobileList.appendChild(mobilePriceFilter);
      } else {
        const collapsible = mobilePriceFilter.querySelector('.collection__filter-collapsible');
        if (collapsible) {
          collapsed = collapsible.style.height === '0px';
        }
      }

      mobilePriceFilter.innerHTML = `
        <button type="button" class="collection__filter-group-name link link--secondary text--strong"
          data-action="toggle-collapsible" aria-controls="${contentId}" data-close-siblings="false"
          data-collapsible-force-overflow="true" aria-expanded="false">
          Price
          <svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
            <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>
          </svg>
        </button>
        <div id="${contentId}" class="collection__filter-collapsible" aria-hidden="${collapsed ? 'true' : 'false'}" style="height: ${collapsed ? '0px' : 'auto'};">
          <price-range class="price-range">
                              
                <div class="price-range__range-group range-group" style="--range-min: ${priceRangeLowerPercentage}%; --range-max: ${priceRangeUpperPercentage}%">
                  <input type="range" aria-label="From" class="range" min="${facet_min}" max="${facet_max}" value="${priceGte}">
                  <input type="range" aria-label="To" class="range" min="${facet_min}" max="${facet_max}" value="${priceLte}">
                </div>

                <div class="price-range__input-group">
                  <div class="price-range__input input-prefix">
                    <span class="input-prefix__value">$</span>
                    <input aria-label="From" class="input-prefix__field" type="number" inputmode="numeric" name="filter.v.price.gte" min="${facet_min}" max="${priceLte}" value="${priceGte}" placeholder="0">
                  </div>

                  <span class="price-range__delimiter text--small">-</span>

                  <div class="price-range__input input-prefix">
                    <span class="input-prefix__value">$</span>
                    <input aria-label="To" class="input-prefix__field" type="number" inputmode="numeric" name="filter.v.price.lte" min="${priceGte}" max="${facet_max}" value="${priceLte}" placeholder="${priceLte}">
                  </div>
                </div>
              </price-range>
        </div>
      `;
    }
    const facetMap = Object.fromEntries(facets.map((f) => [f.field_name, f]));

    for (const [field, label] of Object.entries(FIELD_TO_LABEL)) {
      const facet = facetMap[field];

      const paramName = `filter.${field}`;
      const paramValues = searchParams.getAll(paramName);
      const contentId = `mobile-${FIELD_TO_ID[field] || `filter-${field}`}`;
      const groupId = `mobile-filter-group-${field}`;

      let section = document.getElementById(groupId);
      let collapsed = true;
      if (section) {
        const collapsible = section.querySelector('.collection__filter-collapsible');
        if (collapsible) {
          collapsed = collapsible.style.height === '0px';
        }
      } else {
        section = document.createElement('div');
        section.className = 'collection__filter-group';
        section.id = groupId;
        mobileList.appendChild(section);
      }

      if (!facet || !facet.counts?.length) {
        section.style.display = 'none';
        continue;
      }

      section.style.display = 'block';

      const PAGE_SIZE = 50;
      const totalItems = facet.counts.length;

      // Get current page for this filter (stored in data attribute or default to 1)
      const currentPage = parseInt(section.dataset.filterPage || '1', 10);
      const itemsToShow = currentPage * PAGE_SIZE;

      const hasMore = itemsToShow < totalItems;
      const remainingCount = totalItems - itemsToShow;
      const viewMoreButton = hasMore
        ? `
        <button type="button" class="button button--small button--transparent button--full" 
          data-action="load-more-mobile-filters" data-field="${field}" 
          style="margin-top: 0.5em;">
          View more
        </button>
      `
        : '';

      section.innerHTML = `
        <button type="button" class="collection__filter-group-name link link--secondary text--strong"
          data-action="toggle-collapsible" aria-controls="${contentId}" data-close-siblings="false"
          data-collapsible-force-overflow="true">
          ${label}
          <svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
            <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>
          </svg>
        </button>
        <div id="${contentId}" class="collection__filter-collapsible" aria-hidden="${collapsed ? 'true' : 'false'}" style="height: ${collapsed ? '0px' : 'auto'}; ">
          <ul class="collection__filter-checkbox-list" role="list">
            ${facet.counts
              .slice(0, itemsToShow)
              .map((item) => {
                const safeId = `mobile-${paramName}-${item.value.replace(/\s+/g, '-')}`;
                const checked = paramValues.includes(item.value) ? 'checked' : '';
                return `
                <li class="collection__filter-checkbox">
                  <div class="checkbox-wrapper">
                    <input type="checkbox" class="checkbox" id="${safeId}" name="${paramName}" value="${item.value}" ${checked}>
                    <svg focusable="false" class="icon icon--check" viewBox="0 0 24 24" role="presentation">
                      <path fill="currentColor" d="M9 20l-7-7 3-3 4 4L19 4l3 3z"></path>
                    </svg>
                  </div>
                  <label for="${safeId}">${item.value} (${item.count})</label>
                </li>`;
              })
              .join('')}
          </ul>
          ${viewMoreButton}
        </div>`;

      // Store the current page in the section
      section.dataset.filterPage = currentPage.toString();

      mobileList.appendChild(section);
    }

    const newArrivalChecked = searchParams.get('filter.new_arrival') === '1';
    const bestSellerChecked = searchParams.get('filter.best_seller') === '1';

    let bottomFiltersContainer = document.getElementById('mobile-bottom-filter-group');
    if (!bottomFiltersContainer) {
      bottomFiltersContainer = document.createElement('div');
      bottomFiltersContainer.id = 'mobile-bottom-filter-group';
    }

    bottomFiltersContainer.innerHTML = `
      <div class="collection__filter-group">
        <div class="collection__filter-group-name link link--secondary text--strong">
          <label for="mobile-filter-best_seller">Best Seller</label>
          <input class="switch-checkbox" type="checkbox" name="filter.best_seller" id="mobile-filter-best_seller" value="1" ${bestSellerChecked ? 'checked' : ''}>
        </div>
      </div>
      <div class="collection__filter-group">
        <div class="collection__filter-group-name link link--secondary text--strong">
          <label for="mobile-filter-new_arrival">New Arrival</label>
          <input class="switch-checkbox" type="checkbox" name="filter.new_arrival" id="mobile-filter-new_arrival" value="1" ${newArrivalChecked ? 'checked' : ''}>
        </div>
      </div>
      ${this.getVipProductsFilterHtml(true)}
    `;

    mobileList.appendChild(bottomFiltersContainer);

    const activeMobileContainer = document.querySelector('.collection__mobile-active-filters');
    activeMobileContainer.innerHTML = '';

    const activeFilters = [];
    for (const [key, value] of searchParams.entries()) {
      if (
        key.startsWith('filter.') &&
        value &&
        !key.startsWith('filter.v.price') &&
        !key.startsWith('filter.new_arrival') &&
        !key.startsWith('filter.best_seller') &&
        !key.startsWith('filter.my_products')
      ) {
        const safeValue = value.replace(/\s+/g, '-');
        const id = `mobile-${key}-${value.replace(/\s+/g, '-')}`;
        const label = decodeURIComponent(value);
        activeFilters.push(`
      <label for="${id}" class="collection__active-filter-item">
        <span class="collection__active-filter-cross">
          <svg focusable="false" class="icon icon--close" viewBox="0 0 19 19" role="presentation">
            <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
          </svg>
        </span>${label}
      </label>`);
      }
    }

    if (activeFilters.length > 0) {
      const clearUrl = new URL(window.location.href);
      for (const key of Array.from(clearUrl.searchParams.keys())) {
        if (key.startsWith('filter.')) clearUrl.searchParams.delete(key);
      }
      const clearButton = `
    <button type="button" class="collection__clear-filter button button--small button--transparent button--full"
      data-action="clear-filters" data-url="${clearUrl.pathname}?${clearUrl.searchParams.toString()}">
      Clear all
    </button>`;

      activeMobileContainer.innerHTML = activeFilters.join('') + clearButton;
    }

    const q = searchParams.get('q');
    let input = document.getElementById('search-query-mobile');
    if (input) {
      input.value = q;
    }

    // Add event listener for mobile "load more" buttons
    if (mobileList && !mobileList.dataset.hasLoadMoreHandler) {
      mobileList.addEventListener('click', (e) => {
        const loadMoreButton = e.target.closest('[data-action="load-more-mobile-filters"]');
        if (!loadMoreButton) return;

        e.preventDefault();
        const field = loadMoreButton.getAttribute('data-field');
        const groupId = `mobile-filter-group-${field}`;
        const section = document.getElementById(groupId);

        if (section) {
          // Increment the page counter
          const currentPage = parseInt(section.dataset.filterPage || '1', 10);
          section.dataset.filterPage = (currentPage + 1).toString();

          // Re-render the mobile filters to show more items
          this.renderMobileFilters(facets);
        }
      });
      mobileList.dataset.hasLoadMoreHandler = '1';
    }
  }

  updatePagination() {
    const prodPagination = this.pagination.products;

    const summaryDiv = document.querySelector('.collection__showing-count');
    if (summaryDiv) {
      const start = (prodPagination.currPage - 1) * prodPagination.perPage + 1;

      const summary = `Showing ${start} - ${start + prodPagination.size - 1} of ${prodPagination.total} results`;
      summaryDiv.innerHTML = summary;
    }

    // Update the HTML page title with Typesense result count
    const searchTerm = this.query || '';
    const resultCount = prodPagination.total || 0;
    if (searchTerm) {
      document.title = `Search: ${resultCount} result${resultCount !== 1 ? 's' : ''} found for "${searchTerm}" | Livingstone International`;
    }

    // Update mobile product count displays
    const mobileCountEl = document.querySelector('.collection__products-count-total');
    if (mobileCountEl) {
      mobileCountEl.textContent = `${resultCount} result${resultCount !== 1 ? 's' : ''}`;
    }

    const mobileActiveFiltersResults = document.querySelector('.collection__mobile-active-filters-results');
    if (mobileActiveFiltersResults) {
      mobileActiveFiltersResults.textContent = `${resultCount} result${resultCount !== 1 ? 's' : ''}`;
    }

    const window = 2;

    const pageNav = document.getElementById('page-nav');
    let html = '';
    const query = encodeURIComponent(this.query);
    const startPage = Math.max(1, prodPagination.currPage - window);
    const endPage = Math.min(prodPagination.totalPages, prodPagination.currPage + window);

    // Show first page and leading ellipsis if needed
    if (startPage > 1) {
      html += `
    <a href="/search?page=1&amp;q=${query}" data-page="1" class="pagination__nav-item link" title="Navigate to page 1">1</a>`;
      if (startPage > 2) {
        html += `<span class="pagination__nav-item">…</span>`;
      }
    }

    // Main loop for pages
    for (let i = startPage; i <= endPage; i++) {
      if (i === prodPagination.currPage) {
        html += `<span class="pagination__nav-item is-active">${i}</span>`;
      } else {
        html += `
      <a href="/search?page=${i}&amp;q=${query}" data-page="${i}" class="pagination__nav-item link" title="Navigate to page ${i}">${i}</a>`;
      }
    }

    // Show trailing ellipsis and last page if needed
    if (endPage < prodPagination.totalPages) {
      if (endPage < prodPagination.totalPages - 1) {
        html += `<span class="pagination__nav-item">…</span>`;
      }
      html += `
    <a href="/search?page=${prodPagination.totalPages}&amp;q=${query}" data-page="${prodPagination.totalPages}" class="pagination__nav-item link" title="Navigate to page ${prodPagination.totalPages}">${prodPagination.totalPages}</a>`;
    }

    pageNav.innerHTML = html;
    this._attachPaginationScrollHandler();
  }

  _attachPaginationScrollHandler() {
    const pageNav = document.getElementById('page-nav');
    if (!pageNav || pageNav.dataset.hasScrollHandler) return;

    pageNav.addEventListener('click', (e) => {
      const paginationLink = e.target.closest('.pagination__nav-item.link, .pagination__prev, .pagination__next');
      if (paginationLink) {
        scrollToCollectionTop();
      }
    });
    pageNav.dataset.hasScrollHandler = '1';
  }

  updateSortUI() {
    // Update the sort button text to show the current sort option
    const sortButton = document.querySelector('.collection__toolbar-item--sort .value-picker-button .hidden-phone');
    if (sortButton) {
      const sortLookup = {
        '_text_match:desc': 'Relevance',
        relevance: 'Relevance',
        'sort_priority:desc': 'Featured',
        'is_best_seller:desc': 'Best Seller',
        'price:asc': 'Price: Low to High',
        'price:desc': 'Price: High to Low',
        'title:asc': 'Alphabetically: A-Z',
        'title:desc': 'Alphabetically: Z-A',
      };

      const sortName = sortLookup[this.sort_by] || this.sort_by;
      // The text should be "Sort by: [sort name]" format
      sortButton.textContent = `Sort by: ${sortName}`;
    }

    // Update the selected state of sort options
    const sortOptions = document.querySelectorAll('.collection__toolbar-item--sort [data-action="select-value"]');
    sortOptions.forEach((option) => {
      const optionValue = option.getAttribute('data-value');
      if (optionValue === this.sort_by) {
        option.classList.add('is-selected');
      } else {
        option.classList.remove('is-selected');
      }
    });
  }
}

class BasketOfGoods extends HTMLElement {
  defaultPagination = {
    size: 0,
    perPage: 0,
    currPage: 1,
    nextPage: null,
    totalPages: 1,
    total: 0,
  };

  results = { products: [], categories: [] };
  pagination = { products: this.defaultPagination };
  page = 1;
  per_page = 24;
  query = '';
  selectedCategory = '';

  searchInputVIP = null;

  domain = location.host.split('.')[0];

  constructor() {
    super();
  }

  connectedCallback() {
    this.searchInputVIP = document.getElementById('bog-search-input');
    const urlParams = new URLSearchParams(window.location.search);
    this.page = urlParams.get('page') || 1;
    this.query = urlParams.get('q') || '';
    this.selectedCategory = urlParams.get('category') || '';
    this.per_page = document.getElementById('items_per_page').innerText || 24;

    //we might be in theme preview so override the domain
    if (document.body.dataset.isEditorMode) {
      console.log('searching basket of goods in editor mode');
      this.domain = document.body.dataset.vipDomain;
    }

    this.initaliseSearch();
    this.initializePaginationHandler();
    this.populateResults();

    // listen for price:rerender
    document.addEventListener('price:rerender', () => {
      this.renderProducts(this.results.products);
    });
  }

  async initaliseCategories() {
    const categoryButtons = document.querySelectorAll('[data-vip-search-filter]');
    for (const btn of categoryButtons) {
      if (btn.dataset.ishooked == 0) {
        btn.addEventListener('click', (e) => {
          const categoryButtons = document.querySelectorAll('[data-vip-search-filter]');
          for (const btn of categoryButtons) {
            btn.classList.remove('selected');
          }

          const selectedBtn = e.target.closest('[data-vip-search-filter]');
          selectedBtn.classList.add('selected');

          // Update the selected category and URL
          const categoryValue = selectedBtn.dataset.vipSearchFilter || '';
          this.selectedCategory = categoryValue;

          // Update URL without page reload
          const url = new URL(window.location);
          if (categoryValue) {
            url.searchParams.set('category', categoryValue);
          } else {
            url.searchParams.delete('category');
          }
          // Reset to page 1 when changing category
          url.searchParams.delete('page');
          this.page = 1;
          window.history.pushState({}, '', url);

          this.populateResults();
        });
        btn.dataset.ishooked = 1;
      }
    }
  }

  initializePaginationHandler() {
    // Use event delegation on the page-nav container to handle pagination clicks
    document.addEventListener(
      'click',
      (event) => {
        const paginationLink = event.target.closest('.pagination [data-page]');
        if (paginationLink && document.getElementById('page-nav')?.contains(paginationLink)) {
          event.preventDefault();
          event.stopPropagation(); // Stop theme.js from handling it

          const pageNumber = parseInt(paginationLink.getAttribute('data-page'));
          this.page = pageNumber;

          // Update URL with both page and category
          const url = new URL(window.location);
          url.searchParams.set('page', pageNumber);
          if (this.query) {
            url.searchParams.set('q', this.query);
          }
          if (this.selectedCategory) {
            url.searchParams.set('category', this.selectedCategory);
          } else {
            url.searchParams.delete('category');
          }

          window.history.pushState({}, '', url);
          this.populateResults();

          // Scroll to top of results
          scrollToCollectionTop();
        }
      },
      true,
    ); // Use capture phase to intercept before theme.js
  }

  async initaliseSearch() {
    let VIPsearchDebounceTimeout;

    // VIP Search input handler
    if (this.searchInputVIP) {
      this.searchInputVIP.addEventListener('input', (event) => {
        this.query = event.target?.value;

        // Reset category filter to "All" when search is performed
        const categoryButtons = document.querySelectorAll('[data-vip-search-filter]');
        categoryButtons.forEach((btn) => {
          btn.classList.remove('selected');
          // Select the "All" category (the one without a value)
          if (!btn.dataset.vipSearchFilter) {
            btn.classList.add('selected');
          }
        });

        // Reset category in state and URL
        this.selectedCategory = '';
        const url = new URL(window.location);
        url.searchParams.delete('category');
        window.history.pushState({}, '', url);

        clearTimeout(VIPsearchDebounceTimeout);

        VIPsearchDebounceTimeout = setTimeout(() => {
          this.populateResults();
        }, 300);
      });
    }
  }
  // Populate all search results
  async populateResults() {
    console.log('basket-of-goods search');

    const accountCode = document.body.dataset.companyExternalId;

    const couponInput = document.querySelector('.coupon-input');
    let couponValue = couponInput?.value;

    if (!couponValue) {
      const storageValue = localStorage.getItem('coupon_code');
      if (storageValue) {
        couponValue = storageValue;
      }
    }

    try {
      let coreQuery = `${API_URL}/vip/bog/${this.domain}?page=${this.page}&per_page=${this.per_page}`;
      coreQuery += this.query != '' ? `&query=${this.query}` : '';
      coreQuery += accountCode != '' ? `&accountCode=${accountCode}` : '';
      coreQuery += this.selectedCategory ? `&category=${this.selectedCategory}` : '';
      coreQuery += couponValue ? `&campaignCode=${couponValue}` : '';

      const productResponse = await fetch(coreQuery);

      await Promise.all([await productResponse.json()]).then(([productData]) => {
        this.results = productData?.results || [];
        this.pagination['products'] = productData?.pagination || this.defaultPagination;
      });
    } catch (error) {
      console.error('BOG ERROR');
      console.error(error);
    }

    // console.log('rendering them', this.results?.products?.length || 0);
    // console.log('results', this.results);
    this.renderProducts(this.results.products);
    this.renderCategories(this.results.categories);
    this.initaliseCategories();
    this.updatePagination();
  }

  renderCategories(categoryList) {
    const categoryListContainer = document.querySelector('[data-vip-search-filter-list].placeholder');

    if (!categoryListContainer) {
      return;
    }

    // Check if "All" should be selected (no category or empty category)
    const isAllSelected = !this.selectedCategory;

    let newList = `<li>
      <a
        tabindex="0"
        data-vip-search-filter
        data-ishooked=0 
        class="${isAllSelected ? 'selected' : ''} collection__filter-link link link--primary"
      >
        All
      </a>
    </li>`;
    for (const cat of categoryList) {
      const isSelected = this.selectedCategory === cat.category_name;
      newList += `<li>
        <a
          tabindex="0"
          data-vip-search-filter="${cat.category_name}"
          data-ishooked=0
          class="${isSelected ? 'selected' : ''} collection__filter-link link link--primary"
        >
          ${cat.category_name} (${cat.count})
        </a>
      </li>`;
    }

    categoryListContainer.classList.remove('placeholder');
    categoryListContainer.innerHTML = newList;
  }

  renderProducts(products) {
    const container = document.getElementById('vip-search-target');

    if (products.length == 0) {
      const emptyText = this.query == '' ? `Your Basket of Goods is Empty` : 'No Results';
      container.innerHTML = `<div style="display:flex;justify-content:center;align-items:center;height: 5em;width:100%;font-size:2em">
        <div>${emptyText}</div>
      </div>`;
      return;
    }

    const shouldRenderPrices = !!document.body.dataset.companyExternalId;

    const gstToggle = document.querySelector('#gst-toggle-input');
    const gstDisabled = gstToggle?.checked == false;

    const productTable = (p) => {
      if (!p.priceBreaksAttribute) {
        return '';
      }

      const breaks = JSON.parse(p.priceBreaksAttribute)?.breaks;
      let tax = JSON.parse(p.priceBreaksAttribute)?.taxRate;
      if (tax > 2) {
        tax = tax / 100;
      }
      const taxable = tax != 1;

      if (!breaks || breaks[0].quantity == 0 || breaks[0].quantity == 999999) {
        return '';
      }

      const cells = breaks
        .map((b) => {
          if (b.quantity == 0) {
            return '';
          }

          // Multiply GST rounding up to nearest cent
          const gstPrice = calculateIncGst(b.value, tax).toFixed(2);

          // Determine price based on GST toggle
          const displayPrice = gstDisabled ? b.value.toFixed(2) : gstPrice;

          return `
         <tr style="border-bottom: 1px solid #eee;">
          <td
            style="text-align: center; border: 1px solid #ddd;"
          >
            ${b.quantity}+
          </td>
          <td
            style="text-align: center; border: 1px solid #ddd;"
          >
            ${displayPrice}
          </td>
        </tr>`;
        })
        .join('');

      // Dynamic label based on toggle state and tax
      const priceLabel = gstDisabled ? (taxable ? 'Ex. GST' : 'GST Free') : 'Inc. GST';

      return `<div class="price-breaks-table-wrapper" id="{{product_variant.id}}__price-breaks" style="margin-bottom: 1em;">
        <table style="width:100%; border-collapse: collapse;">
          <thead>
            <tr>
              <th style="border: 1px solid #ddd;">Quantity</th>
              <th style="border: 1px solid #ddd;">
                    Price (${priceLabel})
              </th>
            </tr>
          </thead>
          <tbody>
            ${cells}
          </tbody>
        </table>
      </div>`;
    };

    const productHTML = products
      .map(
        (product) => `
        <div class="product-item product-item--vertical 1/3--tablet-and-up 1/4--desk">
          <div
            data-product-skus="${product.sku}"
          ></div>
            <a href="${product.url}" class="product-item__image-wrapper">
              <div class="aspect-ratio aspect-ratio--short">
                <img src="${product.image_url}" alt="${product.variant_title || product.title}" width="567" height="567">
              </div>
            </a>
            <div class="product-item__info">
              <div class="product-item__info-inner"> 
                <div class='justify-between' style="display: flex;"> 
                  ${product.sku}
                  ${
                    product.stock_status == 'low stock'
                      ? `<div><p class="product-label product-label--low-stock">Back Soon</p></div>`
                      : ''
                  }
                </div>
                <a href="${product.url}" class="product-item__title text--strong link">${product.variant_title || product.title}</a>
                <div class="show-in-list">
                  ${product.description}
                </div>
              </div>
              <form method="post" action="/cart/add" accept-charset="UTF-8" class="product-item__action-list button-stack" enctype="multipart/form-data">
                <input type="hidden" name="form_type" value="product">
                <input type="hidden" name="utf8" value="✓">
                <input type="hidden" name="id" value="${product.shopify_variant_id}">
                <input type="text" hidden="" id="priceBreaks" data-variant-sku="${product.sku}" name="properties[_priceBreaks]" readonly="" value='${product.priceBreaksAttribute}'>

                ${
                  shouldRenderPrices
                    ? `${productTable(product)}
                  <div class="quantity-selector d-flex justify-end unit px-2">
                    <input class="quantity-selector__value" name="quantity" value="1" style="text-align:right">
                    <div> ${product.unit || 'Units'} </div>
                  </div>
                  <button type="submit" class="product-item__action-button button button--small button--primary" data-action="add-to-cart">Add to cart</button>
                `
                    : '<span>Please Login for Prices</span>'
                }
              </form>
            </div>
        </div>
        `,
      )
      .join('');

    container.innerHTML = productHTML;
  }

  updatePagination() {
    const prodPagination = this.pagination.products;
    // console.log({ prodPagination });

    const summaryDiv = document.querySelector('.collection__showing-count');
    if (summaryDiv) {
      const start = (prodPagination.currPage - 1) * prodPagination.perPage + 1;

      const summary = `Showing ${start} - ${start + prodPagination.size - 1} of ${prodPagination.total} results`;
      summaryDiv.innerHTML = summary;
    }

    // Update the HTML page title with Typesense result count
    const searchTerm = this.query || '';
    const resultCount = prodPagination.total || 0;
    if (searchTerm) {
      document.title = `Search: ${resultCount} result${resultCount !== 1 ? 's' : ''} found for "${searchTerm}" | Livingstone International`;
    }

    // Update mobile product count displays
    const mobileCountEl = document.querySelector('.collection__products-count-total');
    if (mobileCountEl) {
      mobileCountEl.textContent = `${resultCount} result${resultCount !== 1 ? 's' : ''}`;
    }

    const mobileActiveFiltersResults = document.querySelector('.collection__mobile-active-filters-results');
    if (mobileActiveFiltersResults) {
      mobileActiveFiltersResults.textContent = `${resultCount} result${resultCount !== 1 ? 's' : ''}`;
    }

    const window = 2;

    const pageNav = document.getElementById('page-nav');
    let html = '';
    const query = encodeURIComponent(this.query);
    const categoryParam = this.selectedCategory ? `&amp;category=${encodeURIComponent(this.selectedCategory)}` : '';
    const startPage = Math.max(1, prodPagination.currPage - window);
    const endPage = Math.min(prodPagination.totalPages, prodPagination.currPage + window);

    // Show first page and leading ellipsis if needed
    if (startPage > 1) {
      html += `
    <a href="/search?page=1&amp;q=${query}${categoryParam}" data-page="1" class="pagination__nav-item link" title="Navigate to page 1">1</a>`;
      if (startPage > 2) {
        html += `<span class="pagination__nav-item">…</span>`;
      }
    }

    // Main loop for pages
    for (let i = startPage; i <= endPage; i++) {
      if (i === prodPagination.currPage) {
        html += `<span class="pagination__nav-item is-active">${i}</span>`;
      } else {
        html += `
      <a href="/search?page=${i}&amp;q=${query}${categoryParam}" data-page="${i}" class="pagination__nav-item link" title="Navigate to page ${i}">${i}</a>`;
      }
    }

    // Show trailing ellipsis and last page if needed
    if (endPage < prodPagination.totalPages) {
      if (endPage < prodPagination.totalPages - 1) {
        html += `<span class="pagination__nav-item">…</span>`;
      }
      html += `
    <a href="/search?page=${prodPagination.totalPages}&amp;q=${query}${categoryParam}" data-page="${prodPagination.totalPages}" class="pagination__nav-item link" title="Navigate to page ${prodPagination.totalPages}">${prodPagination.totalPages}</a>`;
    }

    pageNav.innerHTML = html;
  }
}

class BoughtWithAddToCart extends HTMLElement {
  inputs = [];

  constructor() {
    super();
  }

  connectedCallback() {
    this._init();
    this._addEventListeners();
  }

  async _init() {
    this.inputs = this.parentElement.querySelectorAll('input[type="checkbox"]');
    this.renderSelf();
  }

  _getBreaksForVariant(sku) {
    const breaks = window.b2bpricing?.find((p) => p.sku === sku);

    if (!breaks) return;

    // Find the correct pricebreak for the qty, then grab its price
    let breakList = [];
    for (let i = 1; i < 5; i++) {
      breakList.push({
        quantity: parseInt(breaks[`price_break${i}_qty`]),
        value: parseFloat(breaks[`price_break${i}_ex_gst`]),
      });
    }

    return breakList;
  }

  _addEventListeners() {
    for (const input of this.inputs) {
      input.addEventListener('change', this.handleUpdate.bind(this));
    }

    document.addEventListener('price:loaded', () => {
      this.renderSelf();
    });
  }

  async handleUpdate(event) {
    event.preventDefault();
    this.renderSelf();
  }

  async _addToCart() {
    // console.log('imagine if you will... an add to cart ~*');
    // figure out which prodcuts have been selected
    const selectedSkus = Array.from(this.inputs)
      .filter((i) => i.checked)
      .map((i) => i.name);

    const possibleVariantElems = document.querySelectorAll('[data-variant-sku][data-bought-together]');
    const selected = Array.from(possibleVariantElems).filter((elem) => selectedSkus.includes(elem.dataset.variantSku));

    let items = selected
      .filter((i) => i.dataset.variantSku)
      .map((i) => {
        const sku = i.dataset.variantSku;
        const breaks = window.b2bpricing?.find((p) => p.sku === sku);
        const breakList = this._getBreaksForVariant(sku);

        return {
          quantity: 1,
          id: i.dataset.variantId,
          properties: {
            _priceBreaks: JSON.stringify({
              breaks: breakList,
              taxRate: breaks.taxRate,
              hmac: breaks.hmac,
              couponCode: breaks.couponCode,
              accountNumber: breaks.accountNumber,
            }),
          },
        };
      });

    this.querySelector('button').classList.add('button--disabled');
    this.querySelector('button').setAttribute('disabled', true);

    // Add all items to cart
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    });

    const result = await response.json();

    if (response.ok) {
      document.documentElement.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: 1,
          },
        }),
      );
    } else {
      throw new Error(result.description || 'Error adding to cart');
    }
    this.querySelector('button').classList.remove('button--disabled');
    this.querySelector('button').removeAttribute('disabled');
  }

  /* Use selected items to set total price */
  renderSelf() {
    // figure out which prodcuts have been selected
    const selectedSkus = Array.from(this.inputs)
      .filter((i) => i.checked)
      .map((i) => i.name);

    const possibleVariantElems = document.querySelectorAll('[data-variant-sku][data-bought-together]');
    const selected = Array.from(possibleVariantElems).filter((elem) => selectedSkus.includes(elem.dataset.variantSku));

    // accumulate selected item unit prices
    let sum = 0;
    for (const div of selected) {
      const breaks = window.b2bpricing?.find((p) => p.sku === div.dataset.variantSku);
      if (!breaks) {
        continue;
      }
      const taxRate = parseInt(breaks['taxRate'] || '100') / 100;

      // round to 2 decimal places so that rounding is at a line level, similar to Shopify checkout
      sum += calculateIncGst(breaks[`price_break1_ex_gst`], taxRate);
    }

    // update price total
    const finalPrice = sum.toFixed(2);

    const shouldHidePrices = !document.body.dataset.companyExternalId && document.body.dataset.isVip === 'true';

    if (!shouldHidePrices) {
      this.innerHTML = `
      <div style="height: 100%;text-align:center;">
        <div style="font-size:1.2em">Total Price: <b>$${finalPrice}</b></div> 
        <button class="button button--primary" style="white-space:nowrap">Add selected to cart</button>
      </div>`;
    } else {
      this.innerHTML = `<div style="height: 100%;text-align:center;">Please Login for Prices</div>`;
    }

    // add hook for add to cart
    const buttonElem = this.querySelector('button');
    buttonElem.addEventListener('click', () => {
      this._addToCart();
    });

    // Don't allow ATC if no items selected
    if (finalPrice == '0.00') {
      buttonElem.setAttribute('disabled', true);
      buttonElem.classList.add('button--disabled');
    } else {
      buttonElem.removeAttribute('disabled');
      buttonElem.classList.remove('button--disabled');
    }
  }
}

class TypesenseCollection extends HTMLElement {
  isLoggedIn = null;

  defaultPagination = {
    size: 0,
    perPage: 0,
    currPage: 1,
    nextPage: null,
    totalPages: 1,
    total: 0,
  };

  results = { products: [], collections: [], pages: [] };
  facets = [];
  pagination = { products: this.defaultPagination, collections: this.defaultPagination, pages: this.defaultPagination };
  page = 1;
  per_page = 24;
  query = '';
  filters = '';
  sort_by = '_text_match:desc'; // Default sort by relevance
  available_filters = ['price', 'brand', 'collections'];
  _filtersReady = null;

  elementHandle = 'typesense-collection-results';

  constructor() {
    super();
  }

  connectedCallback() {
    this._initTitle();

    this.isLoggedIn = Boolean(document.body.dataset.isLoggedIn == 'true');
    this._filtersReady = fetch(`${API_URL}/search/filter`)
      .then((res) => res.json())
      .then((data) => {
        this.available_filters.push(...data.filter((f) => f!= 'color'));
      })
      .catch((err) => {
        console.error('Error fetching available filters:', err);
      });

    const handleUrlChange = async () => {
      this.page = new URLSearchParams(window.location.search)?.get('page') || 1;
      this.query = '*';
      this.per_page = document.getElementById('items_per_page')?.innerText || 24;
      this.sort_by = new URLSearchParams(window.location.search)?.get('sort_by') || 'relevance';
      this.filters = {};

      for (const [key, value] of new URLSearchParams(window.location.search).entries()) {
        if (key.startsWith('filter.') && !!value) {
          if (key == 'filter.v.price.gte') {
            this.filters.price = { ...this.filters.price, gte: value };
          } else if (key == 'filter.v.price.lte') {
            this.filters.price = { ...this.filters.price, lte: value };
          } else {
            if (Object.keys(this.filters).includes(key.replace('filter.', ''))) {
              this.filters[key.replace('filter.', '')].push(value);
            } else {
              this.filters[key.replace('filter.', '')] = [value];
            }
          }
        }
      }

      await this._filtersReady;

      this.populateResults();
    };

    // Re-run when URL changes via browser navigation
    // if (!window._typesensePopstateBound) {
    //   window.addEventListener('popstate', () => {
    //     handleUrlChange();
    //   });
    //   window._typesensePopstateBound = true;
    // }

    // Intercept sort dropdown clicks to handle them without modifying theme.js
    this._addSortEventListeners();

    handleUrlChange();

    // Monkey patch pushState to trigger as well
    // const originalPushState = history.pushState;
    // history.pushState = function () {
    //   originalPushState.apply(this, arguments);
    //   window.dispatchEvent(new Event('popstate')); // trigger listener manually
    // };

    // listen for price:rerender
    document.addEventListener('price:rerender', () => {
      this.renderProducts(this.results.products);
    });
  }

  _initTitle() {
    const title = document.getElementById('page-header-title');
    const isCampaignPage = window.location.pathname.includes('/pages/campaign');
    const nameParam = new URLSearchParams(window.location.search).get('name');
    if (title && isCampaignPage && nameParam) {
      title.innerText = nameParam;
    }
  }

  // Add event listeners to intercept sort dropdown clicks
  _addSortEventListeners() {
    // Use event delegation to catch sort dropdown clicks
    document.addEventListener('click', (event) => {
      // Check if this is a sort option click
      if (event.target.matches('[data-action="select-value"][data-value]')) {
        const sortContainer = event.target.closest('.collection__toolbar-item--sort');
        if (sortContainer) {
          event.preventDefault();
          event.stopPropagation();

          const sortValue = event.target.getAttribute('data-value');
          console.log('Sort option clicked:', sortValue);

          // Update the sort_by property
          this.sort_by = sortValue;

          // Update the URL with the new sort parameter
          const url = new URL(window.location);
          url.searchParams.set('sort_by', sortValue);

          // Update the browser URL without triggering a page reload
          window.history.pushState({}, '', url);

          // Trigger our search update
          this.populateResults();
        }
      }
    });
  }

  // Populate all search results
  async populateResults() {
    // console.log('available_filters', this.available_filters.join(','));
    // document.dispatchEvent(new CustomEvent('theme:loading:start'));
    const companyExternalId = document.body.dataset.companyExternalId;
    const couponCode = localStorage.getItem('coupon_code');

    // const collectionFilter = 'All'; //searchFilterName.dataset.value;

    // Check for My Products filter from URL parameters
    // const urlParams = new URLSearchParams(window.location.search);
    // const myProductsFilter = urlParams.get('filter.my_products') === '1';

    const collectionId = this.dataset.collectionId;

    const isCampaignPage = window.location.pathname.includes('/pages/campaign');
    const isAllCollectionPage = window.location.pathname.includes('/collections/all');

    const nameParam = new URLSearchParams(window.location.search).get('name');

    if (!collectionId && !isCampaignPage && !isAllCollectionPage) {
      console.error('No collectionId found');
      return;
    }

    let filterBy = [];
    if (isCampaignPage) {
      filterBy = [`campaign_collection_name:=${nameParam}`];
    } else if (collectionId) {
      filterBy = [`collection_ids:=${collectionId}`];
    }

    const filters = Object.entries(this.filters)
      .map(([key, value]) => {
        if (key == 'price') {
          if (value.gte && value.lte) {
            return `price:=[${value.gte}..${value.lte}]`;
          } else if (value.gte) {
            return `price:>=${value.gte}`;
          } else if (value.lte) {
            return `price:<=${value.lte}`;
          }
        } else if (key == 'new_arrival') {
          return `is_new:=true`;
        } else if (key == 'best_seller') {
          return `is_best_seller:=true`;
        } else if (key == 'my_products') {
          // my_products is handled by VIP domain logic, not as a direct filter
          return null;
        } else {
          return `${key}:=[${value.map((v) => `\`${v}\``).join(',')}]`;
        }
      })
      .filter((filter) => filter !== null);
    const productFiltersAll = filterBy.concat(filters).join(' && ');
    const excludedFacetKeys = ['new_arrival', 'best_seller', 'my_products'];

    const facet_by = this.available_filters.join(',');
    const productSearchQueries = [
      {
        q: this.query,
        page: this.page,
        per_page: this.per_page,
        sort_by: this.sort_by,
        ...(productFiltersAll && { filter_by: productFiltersAll }),
        facet_by: facet_by,
      },
    ];

    Object.keys(this.filters).forEach((key) => {
      if (!excludedFacetKeys.includes(key)) {
        const filtersByOtherThanFacet = filterBy.concat(filters.filter((f) => !f.startsWith(key))).join(' && ');
        productSearchQueries.push({
          q: this.query,
          page: this.page,
          per_page: this.per_page,
          filter_by: filtersByOtherThanFacet,
          facet_by: key,
        });
      }
    });
    // execute queries, we split these up by schema because not all filters are available in each and will error.
    // eg. passing collection:= to anything other than product_schema
    let hasError = false;
    try {
      const productResponse = await fetch(
        `${API_URL}/search/products${companyExternalId ? `?accountCode=${companyExternalId}${couponCode ? `&campaignCode=${couponCode}` : ''}` : ''}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(productSearchQueries),
        },
      );

      // Check if the response is ok (status 200-299)
      if (!productResponse.ok) {
        throw new Error(`HTTP error! status: ${productResponse.status}`);
      }

      const productResults = await productResponse.json();
      const mapping = [{ key: 'products', data: productResults?.[0]?.products }];

      for (const { key, data } of mapping) {
        this.results[key] = data?.items || [];
        this.pagination[key] = data?.pagination || this.defaultPagination;
        if (key == 'products') {
          this.facets = data?.facets || [];
        }
      }
      if (productResults?.length > 1) {
        productResults.forEach((result, index) => {
          if (index == 0) return;
          const facet = result.products.facets?.[0];
          if (!facet) return;
          const existingIndex = this.facets.findIndex((f) => f.field_name === facet.field_name);
          if (existingIndex !== -1) {
            this.facets[existingIndex] = facet; // Replace existing facet
          }
        });
      }
    } catch (error) {
      console.error('Error populateResults:', error);
      hasError = true;
      // Set empty results and facets for error state
      this.results.products = [];
      this.facets = [];
      this.pagination.products = this.defaultPagination;
    }

    this.renderProducts(this.results.products, hasError);
    this.renderAvailableFilters(this.facets);
    this.renderMobileFilters(this.facets);
    this.updatePagination();
    this.updateSortUI();
    window.updateAllWishlistIcons();
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  }

  renderProducts(products, hasError = false) {
    const collectionResults = document.getElementById('typesense-collection-results');
    if (hasError) {
      collectionResults.innerHTML = `<div style="display:flex;justify-content:center;align-items:center;height: 5em;width:100%;font-size:1.5em;text-align:center">
          <div>
            Error loading products.<br/>
            <button onclick="window.location.reload()" class="button button--small button--primary">
              Refresh Page
            </button>
          </div>
        </div>`;
      return;
    }
    if (products.length == 0) {
      collectionResults.innerHTML = `<div style="display:flex;justify-content:center;align-items:center;height: 5em;width:100%;font-size:1.5em">
          <div>No Results</div>
        </div>`;
      return;
    }

    const gstToggle = document.querySelector('#gst-toggle-input');
    const gstDisabled = gstToggle?.checked == false;

    const productTable = (p, isGroup = false) => {
      if (!p.priceBreaksAttribute) {
        return '';
      }

      const breaks = JSON.parse(p.priceBreaksAttribute)?.breaks;
      let tax = JSON.parse(p.priceBreaksAttribute)?.taxRate;
      if (tax > 2) {
        tax = tax / 100;
      }
      const taxable = tax != 1;

      if (!breaks || breaks[0].quantity == 0 || breaks[0].quantity == 999999) {
        return '';
      }

      const cells = breaks
        .map((b) => {
          if (b.quantity == 0) {
            return '';
          }

          // Multiply GST rounding up to nearest cent
          const gstPrice = calculateIncGst(b.value, tax).toFixed(2);

          // Determine price based on GST toggle
          const displayPrice = gstDisabled ? b.value.toFixed(2) : gstPrice;

          return `
         <tr style="border-bottom: 1px solid #eee;">
          <td
            style="text-align: center; border: 1px solid #ddd;"
          >
            ${b.quantity}+
          </td>
          <td
            style="text-align: center; border: 1px solid #ddd;"
          >
            ${displayPrice}
          </td>
        </tr>`;
        })
        .join('');

      // Dynamic label based on toggle state and tax
      const priceLabel = taxable ? (gstDisabled ? 'Ex. GST' : 'Inc. GST') : 'GST Free';

      return `<div class="price-breaks-table-wrapper ${isGroup ? 'product-group-price-breaks' : ''}" data-product-group-id="${p.group_id}" id="${p.shopify_variant_id}__price-breaks" style="margin-bottom: 1em;" data-product-group-sku="${p.sku}">
        <table style="width:100%; border-collapse: collapse;">
          <thead>
            <tr>
              <th style="border: 1px solid #ddd;">Quantity</th>
              <th style="border: 1px solid #ddd;" data-pricing-title>
                  Price (${priceLabel})
              </th>
            </tr>
          </thead>
          <tbody>
            ${cells}
          </tbody>
        </table>
      </div>`;
    };

    const selectBox = (p) => {
      if (!p.is_group || !p.group_id) return '<div class="product-group-select-wrapper"></div>';
      return `
      <div class="product-group-select-wrapper">
        <select id="product-group-${p.group_id}">
          ${p.group_members
            .filter((m) => m.group_id == p.group_id && !!m.description)
            .map((m) => `<option value="${m.sku}" ${m.sku == p.sku ? 'selected' : ''}>${m.description}</option>`)
            .join('')}
        </select>
      </div>`;
    };

    const productImages = (p) => {
      if (!p.is_group || !p.group_id) return '';
      return p.group_members
        .filter((m) => m.group_id == p.group_id && !!m.description)
        .map(
          (m) => `
           <a href="${m.url}" class="product-item__image-wrapper product-group-image" data-product-group-id="${p.group_id}" data-product-group-sku="${m.sku}">
              <div class="aspect-ratio aspect-ratio--short">
                <img src="${m.image_url}" alt="${m.variant_title}" width="567" height="567" loading="lazy">
              </div>
            </a>
            `,
        )
        .join('');
    };

    const productInfo = (p, isGroup = false) => {
      return `
            <div class="product-item__info-inner ${isGroup ? 'product-group-info-inner' : ''}" data-product-group-id="${p.group_id}" ${isGroup ? `data-product-group-sku="${p.sku}"` : ''}>  
                <div class='justify-between' style="display: flex;"> 
                  ${p.sku}
                  ${
                    p.stock_status == 'low stock'
                      ? `<div><p class="product-label product-label--low-stock">Back Soon</p></div>`
                      : ''
                  }
                </div>

                <a href="${p.url}" class="product-item__title text--strong link">${p.title}</a>
                <div class="show-in-list">
                  ${p.description}
                </div>
              </div>
      `;
    };

    const productForm = (product, isGroup = false) => {
      return `
        <form method="post" action="/cart/add" accept-charset="UTF-8" class="product-item__action-list button-stack ${isGroup ? 'product-group-form' : ''}" enctype="multipart/form-data" data-product-group-id="${product.group_id}" data-product-group-sku="${product.sku}" style='margin-left: 0em;'>
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="id" value="${product.shopify_variant_id}">
            <input type="text" hidden="" id="priceBreaks" data-variant-sku="${product.sku}" name="properties[_priceBreaks]" readonly="" value='${product.priceBreaksAttribute}'>
          
            <div class="quantity-selector d-flex justify-end unit px-2">
              <input class="quantity-selector__value" name="quantity" value="1" style="text-align:right">
              <div> ${product.unit || 'Units'} </div>
            </div>
            <button type="submit" class="product-item__action-button button button--small button--primary" data-action="add-to-cart">Add to cart</button>
          </form>
      `;
    };

    // console.log('products', products);

    const productHTML = products
      .map(
        (product) => `
        <div  class="product-item product-item--vertical 1/3--tablet-and-up 1/4--desk">
          <div class="badges-container">
            ${product.is_new ? `<div class="badge badge--new"><span class="badge__text">New</span></div>` : ''}
            ${
              product.is_best_seller
                ? `<div class="badge badge--best-seller"><svg fill="none" focusable="false" role="presentation" class="icon icon--rating-star rating__star rating__star--full" viewBox="0 0 896 832">
                <path d="M896 320l-313.5-40.781L448 0 313.469 279.219 0 320l230.469 208.875L171 831.938l277-148.812 277.062 148.812L665.5 528.875z" fill-rule="nonzero" fill="currentColor"></path>
              </svg><span class="badge__text">Top Seller</span></div>`
                : ''
            }
          </div>
          ${
            this.isLoggedIn
              ? `
            <wishlist-icon style="text-align: right;" data-product-id="${product.shopify_product_id}">
            <button style="cursor: pointer; text-align:center; width: 20px; height: 20px">
              <div>
                <div data-wishlist-unfav="${product.shopify_product_id}" style="display: none;">
                  <svg focusable="false" viewBox="0 0 24 23" role="presentation" height="20" width="20">
                    <g stroke-width="2" fill="none" fill-rule="evenodd">
                      <path d="M17 1c-2.1 0-3.9 1.1-5 2.7C10.9 2.1 9.1 1 7 1 3.7 1 1 3.7 1 7c0 6 11 15 11 15s11-9 11-15c0-3.3-2.7-6-6-6z" stroke="currentColor" stroke-linecap="square"></path>
                      <path d="M16 5c1.65 0 3 1.35 3 3" stroke="#00badb" stroke-linecap="round"></path>
                    </g>
                  </svg>
                </div>
                <div data-wishlist-fav="${product.shopify_product_id}" style="display: none">
                  <svg focusable="false" viewBox="0 0 24 23" role="presentation" height="20" width="20">
                    <g stroke-width="2" fill="currentColor" fill-rule="evenodd">
                      <path d="M17 1c-2.1 0-3.9 1.1-5 2.7C10.9 2.1 9.1 1 7 1 3.7 1 1 3.7 1 7c0 6 11 15 11 15s11-9 11-15c0-3.3-2.7-6-6-6z" stroke="currentColor" stroke-linecap="square"></path>
                      <path d="M16 5c1.65 0 3 1.35 3 3" stroke="#00badb" stroke-linecap="round"></path>
                    </g>
                  </svg>
                </div>
              </div>
            </button>
          </wishlist-icon>
            `
              : ''
          }
          
          <div
            data-product-skus="${product.sku}"
          ></div>
            <a href="${product.url}" class="product-item__image-wrapper" data-product-group-id="${product.group_id}">
              <div class="aspect-ratio aspect-ratio--short">
                <!--<img src="${product.image_url}" alt="${product.variant_title || product.title}" width="567" height="567" loading="lazy">-->
                <img 
                  src="https://livingstone-au.myshopify.com/cdn/shop/files/box.png?v=1732597686&width=300" 
                  data-src="${product.image_url}" 
                  alt="${product.variant_title || product.title}" 
                  width="567" 
                  height="567"
                  class="product-image-lazy"
                  onload="
                    if (this.src !== this.dataset.src) {
                      const img = new Image();
                      img.onload = () => {
                        this.style.opacity = '0';
                        setTimeout(() => {
                          this.src = this.dataset.src;
                          this.style.opacity = '1';
                          this.onload = null;
                        }, 300);
                      };
                      img.onerror = () => {
                        this.onload = null;
                        this.onerror = null;
                      };
                      img.src = this.dataset.src;
                    }
                  "
                  onerror="this.onload = null; this.onerror = null;">
              </div>
            </a>
            ${productImages(product)}
            ${selectBox(product)}
           
            <div class="product-item__info">
                ${productInfo(product)}
                ${product.group_id && product.group_members ? product.group_members?.map((m) => productInfo(m, true)).join('') : ''}
                <div>
                ${productTable(product)}
                ${
                  product.group_id && product.group_members
                    ? product.group_members
                        ?.filter((m) => m.sku != product.sku)
                        .map((m) => productTable(m, true))
                        .join('')
                    : ''
                }
                
                ${productForm(product)}
                ${
                  product.group_id && product.group_members
                    ? product.group_members
                        ?.filter((m) => m.sku != product.sku)
                        .map((m) => productForm(m, true))
                        .join('')
                    : ''
                }
                </div>

            </div>
        </div>
        `,
      )
      .join('');

    collectionResults.innerHTML = `  ${productHTML} `;
    if (!collectionResults.dataset.hasSelectHandler) {
      collectionResults.addEventListener('change', (e) => {
        if (!e.isTrusted) return;

        const select = e.target;
        if (!(select instanceof HTMLSelectElement)) return;
        if (!select.closest('.product-group-select-wrapper')) return;

        if (!select) return;

        const groupId = select.id.replace('product-group-', '');
        const selectedSku = select.value;
        // console.log('selectedSku', selectedSku);

        // hide all siblings in the group, then show the selected SKU
        const nodes = collectionResults.querySelectorAll(`[data-product-group-id="${groupId}"]`);
        nodes.forEach((el) => {
          const display =
            el.classList.contains('price-breaks-table-wrapper') || el.classList.contains('product-item__action-list')
              ? 'flex'
              : 'block';
          el.style.display = el.getAttribute('data-product-group-sku') === selectedSku ? display : 'none';
        });
      });
      collectionResults.dataset.hasSelectHandler = '1';
    }
  }

  getVipProductsFilterHtml(isMobile = false) {
    // Check if VIP settings are available
    const vipSettingsScript = document.querySelector('[data-vip-settings]');
    if (!vipSettingsScript) return '';

    const vipData = JSON.parse(vipSettingsScript.textContent);
    if (!vipData.hasVipSettings) return '';

    const urlParams = new URLSearchParams(window.location.search);
    const myProductsChecked = urlParams.get('filter.my_products') === '1';
    const prefix = isMobile ? 'mobile-filter-' : 'filter_';

    return `
      <div class="collection__filter-group">
        <div class="collection__filter-group-name link link--secondary text--strong">
          <label for="${prefix}my_products">My Products</label>
          <input class="switch-checkbox" type="checkbox" name="filter.my_products" id="${prefix}my_products" value="1" ${myProductsChecked ? 'checked' : ''}>
        </div>
      </div>
    `;
  }

  renderAvailableFilters(facets) {
    const searchParams = new URLSearchParams(window.location.search);

    const FIELD_TO_LABEL = {
      brand: 'Brand',
      collections: 'Category',
    };

    const FIELD_TO_ID = {
      brand: 'filter-p-vendor',
      collections: 'filter-v-m-livingstone-cluster_attribute_collections',
    };

    facets.map((f) => {
      if (f.stats.total_values > 0 && f.field_name != 'price') {
        FIELD_TO_LABEL[f.field_name] = f.field_name
          .split('_')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ');
        FIELD_TO_ID[f.field_name] = `filter-v-m-livingstone-cluster_attribute_${f.field_name}`;
      }
    });

    const facet_min = facets.find((f) => f.field_name === 'price')?.stats?.min?.toFixed(2) || 0;
    const facet_max = facets.find((f) => f.field_name === 'price')?.stats?.max?.toFixed(2) || 10000;
    // Inject active filters section
    const priceGte = parseFloat(searchParams.get('filter.v.price.gte')) || facet_min;
    const priceLte = parseFloat(searchParams.get('filter.v.price.lte')) || facet_max;

    const priceRangeLowerPercentage = (priceGte / facet_max) * 100;
    const priceRangeUpperPercentage = (priceLte / facet_max) * 100;

    // check filter container and create if not exists
    const container = document.getElementById('desktop-search-filters');
    let filterList = container.querySelector('.collection__filter-group-list');
    if (!filterList) {
      container.innerHTML = `
      <div class="card">
        <form id="desktop-filters-form" class="card__section card__section--tight">
          <p class="card__title--small heading">Filters</p>
  
          <div class="collection__active-filters"></div>
          <div class="collection__filter-group-list">
            <!-- Price filter (static) -->
            <div class="collection__filter-group">
              <button type="button" class="collection__filter-group-name link link--secondary text--strong"
                data-action="toggle-collapsible" aria-controls="filter-v-price" data-close-siblings="false"
                data-collapsible-force-overflow="true" aria-expanded="false">
                Price
                <svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
                  <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none"
                    stroke-linecap="square"></path>
                </svg>
              </button>
              <div id="filter-v-price" class="collection__filter-collapsible" aria-hidden="true" style="height: 0px; overflow: hidden;"><price-range class="price-range">
                              
                <div class="price-range__range-group range-group" style="--range-min: ${priceRangeLowerPercentage}%; --range-max: ${priceRangeUpperPercentage}%">
                  <input type="range" aria-label="From" class="range" min="${facet_min}" max="${facet_max}" value="${priceGte}">
                  <input type="range" aria-label="To" class="range" min="${facet_min}" max="${facet_max}" value="${priceLte}">
                </div>

                <div class="price-range__input-group">
                  <div class="price-range__input input-prefix">
                    <span class="input-prefix__value">$</span>
                    <input aria-label="From" class="input-prefix__field" type="number" inputmode="numeric" name="filter.v.price.gte" min="${facet_min}" max="${priceLte}" value="${priceGte}" placeholder="0">
                  </div>

                  <span class="price-range__delimiter text--small">-</span>

                  <div class="price-range__input input-prefix">
                    <span class="input-prefix__value">$</span>
                    <input aria-label="To" class="input-prefix__field" type="number" inputmode="numeric" name="filter.v.price.lte" min="${priceGte}" max="${facet_max}" value="${priceLte}" placeholder="${priceLte}">
                  </div>
                </div>
              </price-range></div>
            </div>
  
            
          </div>
        </form>
      </div>
    `;
      filterList = container.querySelector('.collection__filter-group-list');
    }

    const facetMap = Object.fromEntries(facets.map((f) => [f.field_name, f]));
    for (const field of Object.keys(FIELD_TO_LABEL)) {
      const facet = facetMap[field];

      const label = FIELD_TO_LABEL[field];
      const contentId = FIELD_TO_ID[field] || `filter-${field}`;
      const groupId = `filter-group-${field}`;

      let section = document.getElementById(groupId);
      let collapsed = true;
      if (section) {
        const collapsible = section.querySelector('.collapsible');
        if (collapsible) {
          collapsed = collapsible.style.height === '0px';
        }
      } else {
        section = document.createElement('div');
        section.className = 'collection__filter-group';
        section.id = groupId;
        filterList.appendChild(section);
      }

      if (!facet || !facet.counts || facet.counts.length === 0) {
        section.style.display = 'none';
        continue;
      }

      section.style.display = 'block';

      const PAGE_SIZE = 50;
      const totalItems = facet.counts.length;

      // Get current page for this filter (stored in data attribute or default to 1)
      const currentPage = parseInt(section.dataset.filterPage || '1', 10);
      const itemsToShow = currentPage * PAGE_SIZE;

      const items = facet.counts
        .slice(0, itemsToShow)
        .map((item) => {
          const safeId = `filter.${field}.${item.value.replace(/\s+/g, '-')}`;
          const paramName = `filter.${field}`;
          const paramValues = searchParams.getAll(paramName);
          const isChecked = paramValues.includes(item.value);
          return `
          <li class="collection__filter-checkbox">
            <div class="checkbox-wrapper">
              <input type="checkbox" class="checkbox" id="${safeId}" name="filter.${field}" value="${item.value}" ${isChecked ? 'checked' : ''}>
              <svg focusable="false" class="icon icon--check" viewBox="0 0 24 24" role="presentation">
                <path fill="currentColor" d="M9 20l-7-7 3-3 4 4L19 4l3 3z"></path>
              </svg>
            </div>
            <label for="${safeId}">${item.value} (${item.count})</label>
          </li>`;
        })
        .join('');

      const hasMore = itemsToShow < totalItems;
      const remainingCount = totalItems - itemsToShow;
      const viewMoreButton = hasMore
        ? `
        <button type="button" class="button button--small button--transparent button--full" 
          data-action="load-more-filters" data-field="${field}" 
          style="margin-top: 0.5em;">
          View more
        </button>
      `
        : '';

      section.innerHTML = `
        <button type="button" class="collection__filter-group-name link link--secondary text--strong"
          data-action="toggle-collapsible" aria-controls="${contentId}" data-close-siblings="false"
          data-collapsible-force-overflow="true" aria-expanded="${!collapsed}">
          ${label}
          <svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
            <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none"
              stroke-linecap="square"></path>
          </svg>
        </button>
        <div id="${contentId}" class="collapsible" style="height: ${collapsed ? '0px' : 'auto'};">
          <div class="collapsible__content">
            <ul>${items}</ul>
            ${viewMoreButton}
          </div>
        </div>
      `;

      // Store the current page in the section
      section.dataset.filterPage = currentPage.toString();

      // filterList.appendChild(section);
    }

    const newArrivalChecked = searchParams.get('filter.new_arrival') === '1';
    const bestSellerChecked = searchParams.get('filter.best_seller') === '1';

    let bottomFilters = document.getElementById('bottom-filter-group');

    if (!bottomFilters) {
      bottomFilters = document.createElement('div');
      bottomFilters.id = 'bottom-filter-group';
      bottomFilters.innerHTML = `
      <div class="collection__filter-group"><div class="collection__filter-group-name link link--secondary text--strong">
        <label for="filter_best_seller">Best Seller</label>
        <input class="switch-checkbox" type="checkbox" name="filter.best_seller" id="filter_best_seller" value="1" ${bestSellerChecked ? 'checked' : ''}>
      </div></div>
     <div class="collection__filter-group"><div class="collection__filter-group-name link link--secondary text--strong">
        <label for="filter_new_arrival">New Arrival</label>
        <input class="switch-checkbox" type="checkbox" name="filter.new_arrival" id="filter_new_arrival" value="1" ${newArrivalChecked ? 'checked' : ''}>
      </div></div>
      ${this.getVipProductsFilterHtml()}
    `;
      filterList.appendChild(bottomFilters);
    } else {
      bottomFilters.querySelector('#filter_best_seller').checked = bestSellerChecked;
      bottomFilters.querySelector('#filter_new_arrival').checked = newArrivalChecked;

      // Update My Products checkbox if it exists
      const myProductsCheckbox = bottomFilters.querySelector('#filter_my_products');
      if (myProductsCheckbox) {
        const myProductsChecked = searchParams.get('filter.my_products') === '1';
        myProductsCheckbox.checked = myProductsChecked;
      }
    }

    const activeFilters = [];

    for (const [key, value] of searchParams.entries()) {
      if (
        key.startsWith('filter.') &&
        value &&
        !key.startsWith('filter.v.price') &&
        !key.startsWith('filter.new_arrival') &&
        !key.startsWith('filter.best_seller') &&
        !key.startsWith('filter.my_products')
      ) {
        // Generate a matching checkbox ID from field and value
        const safeValue = value.replace(/\s+/g, '-');
        const id = `${key}.${safeValue}`;
        const label = decodeURIComponent(value);
        activeFilters.push(`
      <label for="${id}" class="collection__active-filter-item">
        <span class="collection__active-filter-cross">
          <svg focusable="false" class="icon icon--close" viewBox="0 0 19 19" role="presentation">
            <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
          </svg>
        </span>${label}
      </label>
    `);
      }
    }
    let activeFiltersDiv = container.querySelector('.collection__active-filters');
    if (!activeFiltersDiv) {
      activeFiltersDiv = document.createElement('div');
      activeFiltersDiv.className = 'collection__active-filters';
      const titleEl = container.querySelector('.card__title--small.heading');
      titleEl.insertAdjacentElement('afterend', activeFiltersDiv);
    }
    let clearButton = ``;
    if (activeFilters.length > 0) {
      const clearUrl = new URL(window.location.href);
      // Remove all filters but keep q and sort_by
      for (const key of Array.from(clearUrl.searchParams.keys())) {
        if (key.startsWith('filter.')) clearUrl.searchParams.delete(key);
      }

      clearButton = `
    <button type="button" class="collection__clear-filter button button--small button--transparent button--full" 
      data-action="clear-filters" data-url="${clearUrl.pathname}?${clearUrl.searchParams.toString()}">
      Clear all
    </button>
  `;
    }

    activeFiltersDiv.innerHTML = activeFilters.join('') + clearButton;

    const q = searchParams.get('q');
    let input = document.getElementById('search-query-keep');
    if (input) {
      input.value = q;
    } else {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'q';
      input.id = 'search-query-keep';
      input.value = q;
      container.querySelector('form#desktop-filters-form').appendChild(input);
    }

    // Update sort_by input value
    let sortInput = container.querySelector('input[name="sort_by"]');
    if (sortInput) {
      sortInput.value = this.sort_by;
    }

    // Add event listener for "load more" buttons
    if (!container.dataset.hasLoadMoreHandler) {
      container.addEventListener('click', (e) => {
        const loadMoreButton = e.target.closest('[data-action="load-more-filters"]');
        if (!loadMoreButton) return;

        e.preventDefault();
        const field = loadMoreButton.getAttribute('data-field');
        const groupId = `filter-group-${field}`;
        const section = document.getElementById(groupId);

        if (section) {
          // Increment the page counter
          const currentPage = parseInt(section.dataset.filterPage || '1', 10);
          section.dataset.filterPage = (currentPage + 1).toString();

          // Re-render the filters to show more items
          this.renderAvailableFilters(facets);
        }
      });
      container.dataset.hasLoadMoreHandler = '1';
    }

    //return container;
  }

  renderMobileFilters(facets) {
    const searchParams = new URLSearchParams(window.location.search);
    const FIELD_TO_LABEL = {
      brand: 'Brand',
      collections: 'Category',
    };

    const FIELD_TO_ID = {
      brand: 'filter-p-vendor',
      collections: 'filter-v-m-livingstone-cluster_attribute_collections',
    };

    facets.map((f) => {
      if (f.stats.total_values > 0 && f.field_name != 'price') {
        FIELD_TO_LABEL[f.field_name] = f.field_name
          .split('_')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ');
        FIELD_TO_ID[f.field_name] = `filter-v-m-livingstone-cluster_attribute_${f.field_name}`;
      }
    });

    const mobileList = document.getElementById('mobile-collection-filters-list');
    if (!mobileList) return;

    const priceFacet = facets.find((f) => f.field_name === 'price');

    if (priceFacet && priceFacet.stats) {
      const facet_min = facets.find((f) => f.field_name === 'price')?.stats?.min?.toFixed(2) || 0;
      const facet_max = facets.find((f) => f.field_name === 'price')?.stats?.max?.toFixed(2) || 10000;
      // Inject active filters section
      const priceGte = parseFloat(searchParams.get('filter.v.price.gte')) || facet_min;
      const priceLte = parseFloat(searchParams.get('filter.v.price.lte')) || facet_max;
      const contentId = `mobile-price`;
      const priceRangeLowerPercentage = (priceGte / facet_max) * 100;
      const priceRangeUpperPercentage = (priceLte / facet_max) * 100;
      let mobilePriceFilter = document.getElementById('mobile-filter-v-price');
      let collapsed = true;

      if (!mobilePriceFilter) {
        mobilePriceFilter = document.createElement('div');
        mobilePriceFilter.className = 'collection__filter-group';
        mobilePriceFilter.id = 'mobile-filter-v-price';
        mobileList.appendChild(mobilePriceFilter);
      } else {
        const collapsible = mobilePriceFilter.querySelector('.collection__filter-collapsible');
        if (collapsible) {
          collapsed = collapsible.style.height === '0px';
        }
      }

      mobilePriceFilter.innerHTML = `
        <button type="button" class="collection__filter-group-name link link--secondary text--strong"
          data-action="toggle-collapsible" aria-controls="${contentId}" data-close-siblings="false"
          data-collapsible-force-overflow="true" aria-expanded="false">
          Price
          <svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
            <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>
          </svg>
        </button>
        <div id="${contentId}" class="collection__filter-collapsible" aria-hidden="${collapsed ? 'true' : 'false'}" style="height: ${collapsed ? '0px' : 'auto'};">
          <price-range class="price-range">
                              
                <div class="price-range__range-group range-group" style="--range-min: ${priceRangeLowerPercentage}%; --range-max: ${priceRangeUpperPercentage}%">
                  <input type="range" aria-label="From" class="range" min="${facet_min}" max="${facet_max}" value="${priceGte}">
                  <input type="range" aria-label="To" class="range" min="${facet_min}" max="${facet_max}" value="${priceLte}">
                </div>

                <div class="price-range__input-group">
                  <div class="price-range__input input-prefix">
                    <span class="input-prefix__value">$</span>
                    <input aria-label="From" class="input-prefix__field" type="number" inputmode="numeric" name="filter.v.price.gte" min="${facet_min}" max="${priceLte}" value="${priceGte}" placeholder="0">
                  </div>

                  <span class="price-range__delimiter text--small">-</span>

                  <div class="price-range__input input-prefix">
                    <span class="input-prefix__value">$</span>
                    <input aria-label="To" class="input-prefix__field" type="number" inputmode="numeric" name="filter.v.price.lte" min="${priceGte}" max="${facet_max}" value="${priceLte}" placeholder="${priceLte}">
                  </div>
                </div>
              </price-range>
        </div>
      `;
    }
    const facetMap = Object.fromEntries(facets.map((f) => [f.field_name, f]));

    for (const [field, label] of Object.entries(FIELD_TO_LABEL)) {
      const facet = facetMap[field];

      const paramName = `filter.${field}`;
      const paramValues = searchParams.getAll(paramName);
      const contentId = `mobile-${FIELD_TO_ID[field] || `filter-${field}`}`;
      const groupId = `mobile-filter-group-${field}`;

      let section = document.getElementById(groupId);
      let collapsed = true;
      if (section) {
        const collapsible = section.querySelector('.collection__filter-collapsible');
        if (collapsible) {
          collapsed = collapsible.style.height === '0px';
        }
      } else {
        section = document.createElement('div');
        section.className = 'collection__filter-group';
        section.id = groupId;
        mobileList.appendChild(section);
      }

      if (!facet || !facet.counts?.length) {
        section.style.display = 'none';
        continue;
      }

      section.style.display = 'block';

      const PAGE_SIZE = 50;
      const totalItems = facet.counts.length;

      // Get current page for this filter (stored in data attribute or default to 1)
      const currentPage = parseInt(section.dataset.filterPage || '1', 10);
      const itemsToShow = currentPage * PAGE_SIZE;

      const hasMore = itemsToShow < totalItems;
      const remainingCount = totalItems - itemsToShow;
      const viewMoreButton = hasMore
        ? `
        <button type="button" class="button button--small button--transparent button--full" 
          data-action="load-more-mobile-filters" data-field="${field}" 
          style="margin-top: 0.5em;">
          View more
        </button>
      `
        : '';

      section.innerHTML = `
        <button type="button" class="collection__filter-group-name link link--secondary text--strong"
          data-action="toggle-collapsible" aria-controls="${contentId}" data-close-siblings="false"
          data-collapsible-force-overflow="true">
          ${label}
          <svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
            <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>
          </svg>
        </button>
        <div id="${contentId}" class="collection__filter-collapsible" aria-hidden="${collapsed ? 'true' : 'false'}" style="height: ${collapsed ? '0px' : 'auto'}; ">
          <ul class="collection__filter-checkbox-list" role="list">
            ${facet.counts
              .slice(0, itemsToShow)
              .map((item) => {
                const safeId = `mobile-${paramName}-${item.value.replace(/\s+/g, '-')}`;
                const checked = paramValues.includes(item.value) ? 'checked' : '';
                return `
                <li class="collection__filter-checkbox">
                  <div class="checkbox-wrapper">
                    <input type="checkbox" class="checkbox" id="${safeId}" name="${paramName}" value="${item.value}" ${checked}>
                    <svg focusable="false" class="icon icon--check" viewBox="0 0 24 24" role="presentation">
                      <path fill="currentColor" d="M9 20l-7-7 3-3 4 4L19 4l3 3z"></path>
                    </svg>
                  </div>
                  <label for="${safeId}">${item.value} (${item.count})</label>
                </li>`;
              })
              .join('')}
          </ul>
          ${viewMoreButton}
        </div>`;

      // Store the current page in the section
      section.dataset.filterPage = currentPage.toString();

      mobileList.appendChild(section);
    }

    const newArrivalChecked = searchParams.get('filter.new_arrival') === '1';
    const bestSellerChecked = searchParams.get('filter.best_seller') === '1';

    let bottomFiltersContainer = document.getElementById('mobile-bottom-filter-group');
    if (!bottomFiltersContainer) {
      bottomFiltersContainer = document.createElement('div');
      bottomFiltersContainer.id = 'mobile-bottom-filter-group';
    }

    bottomFiltersContainer.innerHTML = `
      <div class="collection__filter-group">
        <div class="collection__filter-group-name link link--secondary text--strong">
          <label for="mobile-filter-best_seller">Best Seller</label>
          <input class="switch-checkbox" type="checkbox" name="filter.best_seller" id="mobile-filter-best_seller" value="1" ${bestSellerChecked ? 'checked' : ''}>
        </div>
      </div>
      <div class="collection__filter-group">
        <div class="collection__filter-group-name link link--secondary text--strong">
          <label for="mobile-filter-new_arrival">New Arrival</label>
          <input class="switch-checkbox" type="checkbox" name="filter.new_arrival" id="mobile-filter-new_arrival" value="1" ${newArrivalChecked ? 'checked' : ''}>
        </div>
      </div>
      ${this.getVipProductsFilterHtml(true)}
    `;

    mobileList.appendChild(bottomFiltersContainer);

    const activeMobileContainer = document.querySelector('.collection__mobile-active-filters');
    activeMobileContainer.innerHTML = '';

    const activeFilters = [];
    for (const [key, value] of searchParams.entries()) {
      if (
        key.startsWith('filter.') &&
        value &&
        !key.startsWith('filter.v.price') &&
        !key.startsWith('filter.new_arrival') &&
        !key.startsWith('filter.best_seller') &&
        !key.startsWith('filter.my_products')
      ) {
        const safeValue = value.replace(/\s+/g, '-');
        const id = `mobile-${key}-${value.replace(/\s+/g, '-')}`;
        const label = decodeURIComponent(value);
        activeFilters.push(`
      <label for="${id}" class="collection__active-filter-item">
        <span class="collection__active-filter-cross">
          <svg focusable="false" class="icon icon--close" viewBox="0 0 19 19" role="presentation">
            <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
          </svg>
        </span>${label}
      </label>`);
      }
    }

    if (activeFilters.length > 0) {
      const clearUrl = new URL(window.location.href);
      for (const key of Array.from(clearUrl.searchParams.keys())) {
        if (key.startsWith('filter.')) clearUrl.searchParams.delete(key);
      }
      const clearButton = `
    <button type="button" class="collection__clear-filter button button--small button--transparent button--full"
      data-action="clear-filters" data-url="${clearUrl.pathname}?${clearUrl.searchParams.toString()}">
      Clear all
    </button>`;

      activeMobileContainer.innerHTML = activeFilters.join('') + clearButton;
    }

    const q = searchParams.get('q');
    let input = document.getElementById('search-query-mobile');
    if (input) {
      input.value = q;
    }

    // Add event listener for mobile "load more" buttons
    if (mobileList && !mobileList.dataset.hasLoadMoreHandler) {
      mobileList.addEventListener('click', (e) => {
        const loadMoreButton = e.target.closest('[data-action="load-more-mobile-filters"]');
        if (!loadMoreButton) return;

        e.preventDefault();
        const field = loadMoreButton.getAttribute('data-field');
        const groupId = `mobile-filter-group-${field}`;
        const section = document.getElementById(groupId);

        if (section) {
          // Increment the page counter
          const currentPage = parseInt(section.dataset.filterPage || '1', 10);
          section.dataset.filterPage = (currentPage + 1).toString();

          // Re-render the mobile filters to show more items
          this.renderMobileFilters(facets);
        }
      });
      mobileList.dataset.hasLoadMoreHandler = '1';
    }
  }

  updatePagination() {
    const prodPagination = this.pagination.products;

    const summaryDiv = document.querySelector('.collection__showing-count');
    if (summaryDiv) {
      const start = (prodPagination.currPage - 1) * prodPagination.perPage + 1;

      const summary = `Showing ${start} - ${start + prodPagination.size - 1} of ${prodPagination.total} results`;
      summaryDiv.innerHTML = summary;
    }
    const pageWindow = 2;

    const pageNav = document.getElementById('page-nav');
    let html = '';
    const startPage = Math.max(1, prodPagination.currPage - pageWindow);
    const endPage = Math.min(prodPagination.totalPages, prodPagination.currPage + pageWindow);

    // Show first page and leading ellipsis if needed
    if (startPage > 1) {
      html += `
    <a href="${window.location.pathname}?page=1" data-page="1" class="pagination__nav-item link" title="Navigate to page 1">1</a>`;
      if (startPage > 2) {
        html += `<span class="pagination__nav-item">…</span>`;
      }
    }

    // Main loop for pages
    for (let i = startPage; i <= endPage; i++) {
      if (i === prodPagination.currPage) {
        html += `<span class="pagination__nav-item is-active">${i}</span>`;
      } else {
        html += `
      <a href="${window.location.pathname}?page=${i}" data-page="${i}" class="pagination__nav-item link" title="Navigate to page ${i}">${i}</a>`;
      }
    }

    // Show trailing ellipsis and last page if needed
    if (endPage < prodPagination.totalPages) {
      if (endPage < prodPagination.totalPages - 1) {
        html += `<span class="pagination__nav-item">…</span>`;
      }
      html += `
    <a href="${window.location.pathname}?page=${prodPagination.totalPages}" data-page="${prodPagination.totalPages}" class="pagination__nav-item link" title="Navigate to page ${prodPagination.totalPages}">${prodPagination.totalPages}</a>`;
    }

    pageNav.innerHTML = html;
    this._attachPaginationScrollHandler();
  }

  _attachPaginationScrollHandler() {
    const pageNav = document.getElementById('page-nav');
    if (!pageNav || pageNav.dataset.hasScrollHandler) return;

    pageNav.addEventListener('click', (e) => {
      const paginationLink = e.target.closest('.pagination__nav-item.link, .pagination__prev, .pagination__next');
      if (paginationLink) {
        scrollToCollectionTop();
      }
    });
    pageNav.dataset.hasScrollHandler = '1';
  }

  updateSortUI() {
    // Update the sort button text to show the current sort option
    const sortButton = document.querySelector('.collection__toolbar-item--sort .value-picker-button .hidden-phone');
    if (sortButton) {
      const sortLookup = {
        '_text_match:desc': 'Relevance',
        relevance: 'Relevance',
        'sort_priority:desc': 'Featured',
        'is_best_seller:desc': 'Best Seller',
        'price:asc': 'Price: Low to High',
        'price:desc': 'Price: High to Low',
        'title:asc': 'Alphabetically: A-Z',
        'title:desc': 'Alphabetically: Z-A',
      };

      const sortName = sortLookup[this.sort_by] || this.sort_by;
      // The text should be "Sort by: [sort name]" format
      sortButton.textContent = `Sort by: ${sortName}`;
    }

    // Update the selected state of sort options
    const sortOptions = document.querySelectorAll('.collection__toolbar-item--sort [data-action="select-value"]');
    sortOptions.forEach((option) => {
      const optionValue = option.getAttribute('data-value');
      if (optionValue === this.sort_by) {
        option.classList.add('is-selected');
      } else {
        option.classList.remove('is-selected');
      }
    });
  }
}

class NavigationAffinity extends HTMLElement {
  toggleButton = null;
  menu = null;
  desktopNavElement = null;

  constructor() {
    super();
    this.toggleButton = document.querySelector('.header__desktop-nav-toggle');
    this.menu = document.querySelector('.header__desktop-nav [data-type="menu"]');
    this.desktopNavElement = document.querySelector('.header__desktop-nav');
  }

  connectedCallback() {
    this._init();
  }

  _init() {
    // Close desktop nav toggle when hovering over this affinity nav
    this.addEventListener('mouseenter', this._closeDesktopNavToggle.bind(this));
  }

  _closeDesktopNavToggle() {
    if (!this.toggleButton || this.toggleButton.getAttribute('aria-expanded') !== 'true') {
      return;
    }

    if (this.desktopNavElement && !this.desktopNavElement.contains(document.body)) {
      setTimeout(() => {
        // Trigger DesktopNavigation's _onClick handler
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        });
        document.body.dispatchEvent(clickEvent);
      }, 0);
    }
  }
}

class CataloguesGrid extends HTMLElement {
  constructor() {
    super();
    this.currentView = 'catalogues';
    this.brochures = [];
    this.isLoading = true;

    // Get settings from data attributes
    this.buttonSpecials = this.dataset.buttonSpecials || 'Monthly Specials';
    this.buttonCatalogues = this.dataset.buttonCatalogues || 'Brochures and Catalogues';
    this.bodySpecials = this.dataset.bodySpecials || 'Browse our monthly special offers and promotions';
    this.bodyCatalogues = this.dataset.bodyCatalogues || 'View our full range of brochures and catalogues';

    this.customerId = this.dataset.customerId || null;
    this.customerLocation = this.dataset.locationId || null;
    this.storeId = this.dataset.storeId || null;
    this.hmac = this.dataset.hmac || null;

    // Use the local storage if you want to use the affinity code from the last page the customer visited
    // this.affinityCode = localStorage.getItem('affinityCode');
  }

  connectedCallback() {
    this._init();
  }

  async _init() {
    // Render initial UI
    this._render();

    // Fetch data
    await this._fetchBrochures();
  }

  async _fetchBrochures() {
    this.isLoading = true;
    this._render();

    const brochureType = this.currentView === 'specials' ? 'MonthlySpecial' : 'Catalogue';

    try {
      const response = await fetch(
        `${API_URL}/storefront/brochures?type=${brochureType}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Storefront-Customer-Id': this.customerId,
            'X-Storefront-Location-Id': this.customerLocation,
            'X-Storefront-Store-Id': this.storeId,
            'X-Hmac': this.hmac,
          },
        },
      );

      if (!response.ok) {
        throw new Error('Failed to fetch brochures');
      }

      const data = await response.json();
      this.brochures = data.data || [];
      this.meta = data.meta || {};
    } catch (error) {
      console.error('Error fetching brochures:', error);
      this.brochures = [];
    } finally {
      this.isLoading = false;
      this._render();
    }
  }

  _handleViewChange(view) {
    if (this.currentView !== view) {
      this.currentView = view;
      this._fetchBrochures();
    }
  }

  _formatDate(dateString) {
    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }).format(date);
    } catch (e) {
      return 'N/A';
    }
  }

  _openBrochure(brochure) {
    const url = brochure.cacheUrl || brochure.sourceFileUrl;
    if (url) {
      window.open(url, '_blank');
    }
  }

  _renderToggleButtons() {
    return `
      <div class="catalogues-grid__toggle">
        <button 
          class="catalogues-grid__toggle-btn active"
          data-view="catalogues"
          disabled="true"
        >
          ${this.buttonCatalogues}
        </button>
      </div>
    `;

    // Replace with this when re-enabling the specials toggle button
    // return `
    //   <div class="catalogues-grid__toggle">
    //     <button 
    //       class="catalogues-grid__toggle-btn ${this.currentView === 'specials' ? 'active' : ''}"
    //       data-view="specials"
    //     >
    //       ${this.buttonSpecials}
    //     </button>
    //     <button 
    //       class="catalogues-grid__toggle-btn ${this.currentView === 'catalogues' ? 'active' : ''}"
    //       data-view="catalogues"
    //     >
    //       ${this.buttonCatalogues}
    //     </button>
    //   </div>
    // `;
  }

  _renderSubheading() {
    const bodyText = this.currentView === 'specials' ? this.bodySpecials : this.bodyCatalogues;
    return `
      <div class="section__subheading">
        ${bodyText}
      </div>
    `;
  }

  _renderLoadingSkeleton() {
    const skeletons = Array(6)
      .fill(0)
      .map(
        () => `
      <div class="catalogues-grid__card catalogues-grid__card--skeleton">
        <div class="catalogues-grid__card-image skeleton-pulse"></div>
        <div class="catalogues-grid__card-body">
          <div class="skeleton-line skeleton-pulse" style="height: 80px; margin-bottom: 12px;"></div>
          <div class="skeleton-line skeleton-pulse" style="height: 16px; margin-bottom: 8px;"></div>
          <div class="skeleton-line skeleton-pulse" style="height: 16px; margin-bottom: 8px;"></div>
          <div class="skeleton-line skeleton-pulse" style="height: 16px; margin-bottom: 12px;"></div>
          <div class="skeleton-line skeleton-pulse" style="height: 32px;"></div>
        </div>
      </div>
    `,
      )
      .join('');

    return `<div class="catalogues-grid__grid">${skeletons}</div>`;
  }

  _renderEmptyState() {
    return `
      <div class="catalogues-grid__empty">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
        <h3>Nothing found</h3>
        <p>There are no materials available at this time.</p>
      </div>
    `;
  }

  _renderBrochureCard(brochure) {
    const typeColorClass =
      brochure.type === 'Brochure' ? 'badge--green' : brochure.type === 'Catalogue' ? 'badge--blue' : 'badge--purple';

    return `
      <div class="catalogues-grid__card" data-erp-id="${brochure.erpId}">
        <div class="catalogues-grid__card-image-wrapper">
          <img 
            src="${brochure.thumbnailUrl || ''}" 
            alt="${brochure.name}"
            class="catalogues-grid__card-image"
            onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
          />
          <div class="catalogues-grid__card-fallback" style="display: none;">
            <span class="fallback-icon">📄</span>
            <span class="fallback-text">PDF Document</span>
          </div>
          <span class="catalogues-grid__badge ${typeColorClass}">
            ${brochure.type}
          </span>
        </div>
        <div class="catalogues-grid__card-body">
          <h3 class="catalogues-grid__card-title">${brochure.name}</h3>
          
          <div class="catalogues-grid__card-info">
          ${ brochure.campCode ? 
            `<div class="info-row">
              <span class="info-label">Campaign Code:</span>
              <span class="info-value">${brochure.campCode}</span>
            </div>` : ''}
            ${ brochure.startTime ? 
            `<div class="info-row">
              <span class="info-label">Start Date:</span>
              <span class="info-value">${this._formatDate(brochure.startTime)}</span>
            </div>` : ''}
            ${ brochure.expiryTime ? 
            `<div class="info-row">
              <span class="info-label">Expiry Date:</span>
              <span class="info-value">${this._formatDate(brochure.expiryTime)}</span>
            </div>` : ''}
          </div>

          <button class="catalogues-grid__view-btn" ${!brochure.cacheUrl ? 'disabled="true"' : ''}>${brochure.cacheUrl ? 'View' : 'Login to View'}</button>
        </div>
      </div>
    `;
  }

  _renderGrid() {
    if (this.isLoading) {
      return this._renderLoadingSkeleton();
    }

    if (!this.brochures || this.brochures.length === 0) {
      return this._renderEmptyState();
    }

    const cards = this.brochures.map((brochure) => this._renderBrochureCard(brochure)).join('');
    return `<div class="catalogues-grid__grid">${cards}</div>`;
  }

  _render() {
    this.innerHTML = `
      <style>
        .section__subheading {
          font-size: 16px;
          margin-bottom: 32px;
          line-height: 1.6;
        }

        .catalogues-grid__toggle {
          display: inline-flex;
          background-color: #f7fafc;
          border-radius: 8px;
          padding: 4px;
          margin-bottom: 24px;
          gap: 0;
        }

        .catalogues-grid__toggle-btn {
          padding: 8px 16px;
          font-size: 14px;
          font-weight: 500;
          border: none;
          border-radius: 6px;
          background-color: transparent;
          color: #4a5568;
          cursor: pointer;
          transition: all 0.2s;
        }

        .catalogues-grid__toggle-btn:hover {
          background-color: #e2e8f0;
        }

        .catalogues-grid__toggle-btn.active {
          background-color: #232C67;
          color: white;
        }

        .catalogues-grid__grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
          margin-bottom: 24px;
        }

        @media (min-width: 768px) {
          .catalogues-grid__grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        @media (min-width: 1024px) {
          .catalogues-grid__grid {
            grid-template-columns: repeat(4, 1fr);
          }
        }

        .catalogues-grid__card {
          background: white;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          flex-direction: column;
        }


        .catalogues-grid__card-image-wrapper {
          position: relative;
          width: 100%;
          height: 200px;
          background-color: #f7fafc;
          overflow: hidden;
        }

        .catalogues-grid__card-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .catalogues-grid__card-fallback {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          background-color: #edf2f7;
          color: #a0aec0;
        }

        .fallback-icon {
          font-size: 3rem;
          margin-bottom: 8px;
        }

        .fallback-text {
          font-size: 14px;
        }

        .catalogues-grid__badge {
          position: absolute;
          top: 8px;
          right: 8px;
          padding: 4px 12px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
        }

        .badge--green {
          background-color: #c6f6d5;
          color: #22543d;
        }

        .badge--blue {
          background-color: #bee3f8;
          color: #2c5282;
        }

        .badge--purple {
          background-color: #e9d8fd;
          color: #44337a;
        }

        .catalogues-grid__card-body {
          padding: 16px;
          cursor: auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex-grow: 1;
        }

        .catalogues-grid__card-title {
          font-size: 16px;
          font-weight: 600;
          margin: 0 0 12px 0;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .catalogues-grid__card-info {
          margin-bottom: 16px;
          font-size: 14px;
        }

        .info-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
        }

        .info-label {
          color: #718096;
          font-weight: 500;
        }

        .info-value {
          font-weight: 600;
          color: #2d3748;
        }

        .catalogues-grid__view-btn {
          width: 100%;
          padding: 10px;
          background-color: #3182ce;
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .catalogues-grid__view-btn:hover {
          background-color: #2c5282;
        }

        .catalogues-grid__view-btn:disabled {
          background-color: #e2e8f0;
        }

        .catalogues-grid__empty {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 64px 24px;
          text-align: center;
          color: #718096;
        }

        .catalogues-grid__empty svg {
          margin-bottom: 16px;
          width: 48px;
          height: 48px;
        }

        .catalogues-grid__empty h3 {
          font-size: 20px;
          font-weight: 600;
          margin: 0 0 8px 0;
          color: #2d3748;
        }

        .catalogues-grid__empty p {
          font-size: 14px;
          margin: 0;
        }

        /* Loading skeleton styles */
        .catalogues-grid__card--skeleton {
          cursor: default;
          pointer-events: none;
        }

        .catalogues-grid__card--skeleton:hover {
          transform: none;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }

        .skeleton-pulse {
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
        }

        .skeleton-line {
          border-radius: 4px;
        }

        @keyframes skeleton-loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      </style>
      
      <div class="catalogues-grid">
        ${this._renderSubheading()}
        ${this._renderToggleButtons()}
        ${this._renderGrid()}
      </div>
    `;

    // Add event listeners after render
    this._attachEventListeners();
  }

  _attachEventListeners() {
    // Toggle button listeners
    const toggleButtons = this.querySelectorAll('.catalogues-grid__toggle-btn');
    toggleButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const view = e.target.dataset.view;
        this._handleViewChange(view);
      });
    });

    // Card click listeners
    const cards = this.querySelectorAll('.catalogues-grid__card:not(.catalogues-grid__card--skeleton)');
    cards.forEach((card, index) => {
      card.addEventListener('click', () => {
        if (this.brochures[index]) {
          this._openBrochure(this.brochures[index]);
        }
      });
    });
  }
}

/* Tracks the last affinity visited by a guest to determine catalogue code to show */
class CatalogueTracker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._init();
  }

  async _init() {
    this.affinityCode = document.body.dataset.affinityCode || null;

    // if we're on a collection page, set the affinity code in local storage
    // otherwise, get the affinity code from local storage
    if (this.affinityCode) {
      localStorage.setItem('affinityCode', this.affinityCode);
      console.log('>>> affinityCode set', this.affinityCode);
    } else {
      this.affinityCode = localStorage.getItem('affinityCode');
      console.log('>>> affinityCode get', this.affinityCode);
    }
  }
}

/* Define custom elements */
customElements.define('custom-registration', CustomRegistration);
customElements.define('register-education', RegisterEducation);
customElements.define('address-autocomplete', AddressAutocomplete);
customElements.define('bulk-buy-quote-form', BulkBuyQuoteForm);
customElements.define('cart-lines', CartLines);
customElements.define('cart-recs', ProductCartRecommendations);
customElements.define('search-dropdown', SearchDropdown);
customElements.define('budget-widget', BudgetWidget);
customElements.define('coupon-code-input', CouponCodeInput);
customElements.define('minicart-reconciler', MinicartReconciler);
customElements.define('gst-toggle', GstToggle);
customElements.define('typesense-search-results', TypesenseSearch);
customElements.define('typesense-collection-results', TypesenseCollection);
customElements.define('basket-of-goods', BasketOfGoods);
customElements.define('bought-with-atc', BoughtWithAddToCart);
customElements.define('navigation-affinity', NavigationAffinity);
customElements.define('catalogues-grid', CataloguesGrid);
customElements.define('catalogue-tracker', CatalogueTracker);

document.addEventListener('price:refresh', () => {
  console.log('price:refresh');
  customPricingInit();
});

// Global pagination scroll handler for server-rendered pagination
document.addEventListener('DOMContentLoaded', function () {
  // Handle clicks on server-rendered pagination (from pagination.liquid)
  document.addEventListener('click', function (e) {
    const paginationLink = e.target.closest('.pagination__nav-item.link, .pagination__prev, .pagination__next');
    if (paginationLink) {
      const pageNav = paginationLink.closest('#page-nav');
      // Only handle if not already handled by dynamic pagination handlers
      if (!pageNav || !pageNav.dataset.hasScrollHandler) {
        scrollToCollectionTop();
      }
    }
  });
});

// Search dropdown
document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.tab-content');
  const searchInput = document.getElementById('search-input');
  const searchDropdown = document.getElementById('search-dropdown');
  const searchToggleButton = document.getElementById('search-toggle-button');
  const iconSearch = searchToggleButton?.querySelector('.icon-search');
  const iconClose = searchToggleButton?.querySelector('.icon-close');
  const vipToggle = document.querySelector('#vip-bog-toggle');
  const searchFilterButtons = document.querySelectorAll('a[data-type="search-filter"]');
  const searchFilterName = document.querySelector('#search-category-filter');
  const contactForm = document.getElementById('livingstone-contact-form');

  // Sample suggestions
  const additionalProducts = [
    {
      id: '482128',
      productId: '8896520323317',
      sku: 'FAKNSWPOL2',
      title: 'First Aid Kit - Nsw Police Gunshot, Ea Kit 2',
      price: '$140.00',
      priceNote: '(ex GST)',
      originalPrice: '$7.95',
      imgUrl: 'https://livingstone-au.myshopify.com/cdn/shop/files/FAKNSWPOL_510cbe38-6d3c-43f5-a355-c6d8f4f76d07.png',
      url: '/products/faknswpol2',
    },
  ];

  // Toggle search dropdown
  function toggleSearchDropdown(show) {
    if (show) {
      searchDropdown?.classList.add('active');
      iconSearch.style.display = 'none';
      iconClose.style.display = 'flex';
    } else {
      searchDropdown?.classList.remove('active');
      iconSearch.style.display = 'flex';
      iconClose.style.display = 'none';
    }
  }

  // Clear search input
  function clearSearchInput() {
    searchInput.value = '';
    toggleSearchDropdown(false);
    searchInput.focus();
  }

  // Handle tab switching
  function switchTab(tabName) {
    tabButtons.forEach((button) => {
      if (button.getAttribute('data-tab') === tabName) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });

    tabContents.forEach((content) => {
      if (content.id === tabName + '-tab') {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  }

  // Populate product results
  async function populateProducts(products) {
    const productList = document.querySelector('.product-search-list');
    productList.innerHTML = '';
    // console.log({ products });

    products = products.slice(0, 5);

    if (products.length === 0) {
      productList.innerHTML = '<p>No products found.</p>';
      return;
    }

    products.forEach((product) => {
      const productEl = document.createElement('div');
      productEl.className = 'product-search-item';

      let priceHTML = `<span class="current-price">${product.price}</span> <span class="price-note">${product.priceNote}</span>`;
      if (product.originalPrice) {
        priceHTML += ` <span class="original-price">${product.originalPrice}</span>`;
      }

      productEl.innerHTML =
        `
                            <a href="${product.url}" class="product-search-link">
                            <img class="product-search-image" src="${product.image_url}" alt="${product.variant_title || product.title}">
                            <div class="product-search-details">
                            <h3 class="product-search-title">${product.title}</h3>` +
        // <div class="product-search-price">${priceHTML}</div>
        `<div class="product-search-code">${product.sku}</div>
                            </div>  
                            </a>
                            `;

      productList.appendChild(productEl);
    });

    // Add "View More Products" button
    // const viewMoreEl = document.createElement('div');
    // viewMoreEl.className = 'view-more';
    // viewMoreEl.innerHTML = `<button class="view-more-button">View More Products</button>`;
    // productList.appendChild(viewMoreEl);

    // Add event listener to load more products
    // viewMoreEl?.querySelector('.view-more-button')?.addEventListener('click', loadMoreProducts);
  }

  // Populate Collection results
  async function populateCollections(collections) {
    const collectionList = document.querySelector('.collection-search-list');
    collectionList.innerHTML = '';

    // shenanigans
    const uniqueTitles = {};

    collections = collections
      .sort((a, b) => {
        // First, sort by type (Base first, Affinity last)
        if (a.type === 'Base' && b.type !== 'Base') return -1;
        if (a.type !== 'Base' && b.type === 'Base') return 1;
        if (a.type === 'Affinity' && b.type !== 'Affinity') return 1;
        if (a.type !== 'Affinity' && b.type === 'Affinity') return -1;

        // If types are the same (or neither Base/Affinity), sort by parent_category length
        return b.parent_category.length - a.parent_category.length;
      })
      // hack: only show the first category with a given title
      .filter((c) => {
        if (!uniqueTitles[c.title]) {
          uniqueTitles[c.title] = true;
          return true;
        }
      })
      .slice(0, 10);

    if (collections.length === 0) {
      collectionList.innerHTML = '<p>No collections found.</p>';
      return;
    }

    collections.forEach((collection) => {
      const collectionEl = document.createElement('div');
      collectionEl.className = 'product-search-item';

      collectionEl.innerHTML = `
                            <a href="${collection.url}" class="product-search-link">
                            <h3 class="product-search-title">${collection.title}</h3>
                            </div>  
                            </a>
                            `;

      collectionList.appendChild(collectionEl);
    });
  }

  // Populate Page/Article results
  async function populateArticles(articles) {
    const articleList = document.querySelector('.article-search-list');
    articleList.innerHTML = '';

    articles = articles.slice(0, 5);
    // console.log(articles);

    if (articles.length === 0) {
      articleList.innerHTML = '<p>Nothing found.</p>';
      return;
    }

    articles.forEach((article) => {
      const articleEl = document.createElement('div');
      articleEl.className = 'product-search-item';

      articleEl.innerHTML = `
                            <a href="${article.url}" class="product-search-link">
                            <h3 class="product-search-title">${article.title}</h3>
                            </div>
                            </a>
                            `;

      articleList.appendChild(articleEl);
    });
  }

  // Populate More ProductsView More Products
  function loadMoreProducts() {
    const productList = document.querySelector('.product-search-list');
    const viewMoreButton = document.querySelector('.view-more-button');

    // Show loading text
    viewMoreButton.textContent = 'Loading...';

    // Simulate a delay for loading more products
    setTimeout(() => {
      additionalProducts.forEach((product) => {
        const productEl = document.createElement('div');
        productEl.className = 'product-item';

        let priceHTML = `<span class="current-price">${product.price}</span> <span class="price-note">${product.priceNote}</span>`;
        if (product.originalPrice) {
          priceHTML += ` <span class="original-price">${product.originalPrice}</span>`;
        }

        productEl.innerHTML = `
          <a href="${product.url}" class="product-link">
            <img class="product-image" src="${product.imgUrl}" alt="${product.variant_title || product.title}">
            <div class="product-details">
              <h3 class="product-title">${product.variant_title || product.title}</h3>
              <div class="product-price">${priceHTML}</div>
              <div class="product-code">${product.code}</div>
            </div>
          </a>
        `;

        productList.appendChild(productEl);
      });

      // Remove the "View More Products" button after loading more products
      const viewMoreContainer = document.querySelector('.view-more');
      if (viewMoreContainer) {
        viewMoreContainer.remove();
      }

      // Keep the dropdown open
      toggleSearchDropdown(true);
    }, 10);
  }

  // Populate all search results
  async function populateResults() {
    const results = { products: [], collections: [], pages: [] };

    const query = searchInput.value;
    const companyExternalId = document.body.dataset.companyExternalId;
    const collectionFilter = searchFilterName.dataset.value;

    let collection = collectionFilter != 'All' ? collectionFilter : undefined;

    /* Get the first subdomain */
    const subdomain = window.location.hostname.split('.')[0];

    let vip = collection === 'my-products' ? subdomain : undefined;

    // no search escape hatch
    if (query == '') {
      return;
    }

    // build filterBy parameter
    let filterBy = vip ? [`vip_domains:=${vip}`] : [];
    const filterByString = filterBy.length ? `&filter_by=${filterBy.join(' %26%26 ')}` : '';

    filterByWithCollection =
      collection && collection !== 'my-products'
        ? [...filterBy, `collections:=${encodeURIComponent(collection)}`]
        : filterBy;
    const filterByStringWithCollection = filterByWithCollection.length
      ? `&filter_by=${filterByWithCollection.join(' %26%26 ')}`
      : '';

    // execute queries, we split these up by schema because not all filters are available in each and will error.
    // eg. passing collection:= to anything other than product_schema
    try {
      const productResponse = await fetch(
        `${API_URL}/search?q=${query}${filterByStringWithCollection}&schema=product_schema`,
      );
      const collectionResponse = await fetch(
        `${API_URL}/search?q=${query}${filterByString}&schema=collection_schema&per_page=150`,
      );
      const pageResponse = await fetch(`${API_URL}/search?q=${query}${filterByString}&schema=page_schema`);
      const blogResponse = await fetch(`${API_URL}/search?q=${query}${filterByString}&schema=blog_schema`);

      await Promise.all([
        await productResponse.json(),
        await collectionResponse.json(),
        await pageResponse.json(),
        await blogResponse.json(),
      ]).then(([productData, collectionData, pageData, blogData]) => {
        results.products = productData?.products?.items || [];
        results.collections = collectionData?.collections?.items || [];
        results.pages = (pageData?.pages?.items || []).concat(blogData?.blogs?.items || []);
      });
    } catch (error) {
      console.error('Error main search populateResults:', error);
    }
    // console.log('results', results);
    populateProducts(results.products);
    populateCollections(results.collections);
    populateArticles(results.pages);
  }

  let searchDebounceTimeout = 1000;

  // Search input handler
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      const query = this.value.trim();
      clearTimeout(searchDebounceTimeout);

      if (query.length > 0) {
        toggleSearchDropdown(true);

        searchDebounceTimeout = setTimeout(() => {
          populateResults();
        }, 300);
      } else {
        toggleSearchDropdown(false);
      }
    });
  }

  // VIP toggle handler
  if (vipToggle) {
    if (document.body.dataset.vipShowSearch) {
      document.querySelector('.vip-bog-wrapper')?.classList.add('d-none');
    }

    vipToggle.addEventListener('change', () => {
      clearTimeout(searchDebounceTimeout);

      searchDebounceTimeout = setTimeout(() => {
        populateResults();
      }, 300);
    });
  }

  // Search input focus
  if (searchInput) {
    searchInput.addEventListener('focus', function () {
      if (this.value.trim().length > 0) {
        toggleSearchDropdown(true);
      }
    });
  }

  // Clear button handler
  iconClose.addEventListener('click', clearSearchInput);

  // Tab button handler
  tabButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const tabName = this.getAttribute('data-tab');
      switchTab(tabName);
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function (event) {
    if (!searchDropdown.contains(event.target) && event.target !== searchInput) {
      toggleSearchDropdown(false);
    }
  });

  // Allow filtering searches to affinity categories
  for (const button of searchFilterButtons) {
    button.addEventListener('click', (e) => {
      // console.log('click', e.target);
      const collectionData = e.target.dataset;
      const truncatedName = collectionData.value ? collectionData.shortName : 'All';
      searchFilterName.innerHTML = truncatedName;
      searchFilterName.dataset.value = collectionData.value || 'All';

      // Update the hidden input field for form submission
      const hiddenCollectionFilter = document.getElementById('search-collection-filter');
      if (hiddenCollectionFilter) {
        if (collectionData.value === 'my-products') {
          // Use filter.my_products for My Products selection
          hiddenCollectionFilter.name = 'filter.my_products';
          hiddenCollectionFilter.value = '1';
        } else {
          // Use filter.collections for other collections
          hiddenCollectionFilter.name = 'filter.collections';
          hiddenCollectionFilter.value =
            collectionData.value && collectionData.value !== 'All' ? collectionData.value : '';
        }
      }

      populateResults();
    });
  }

  // Initialize search dropdown based on URL parameters
  function initializeSearchDropdownFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const collectionFilter = urlParams.get('filter.collections');
    const myProductsFilter = urlParams.get('filter.my_products');

    let targetValue = null;
    let targetName = 'filter.collections';
    let targetValueForForm = '';

    if (myProductsFilter === '1') {
      // My Products filter is active
      targetValue = 'my-products';
      targetName = 'filter.my_products';
      targetValueForForm = '1';
    } else if (collectionFilter) {
      // Regular collection filter is active
      targetValue = collectionFilter;
      targetName = 'filter.collections';
      targetValueForForm = collectionFilter;
    }

    if (targetValue) {
      // Find the filter button that matches the URL parameter
      const matchingButton = Array.from(searchFilterButtons).find((button) => button.dataset.value === targetValue);

      if (matchingButton) {
        const collectionData = matchingButton.dataset;
        const truncatedName = collectionData.shortName || collectionData.value;

        // Update the dropdown display
        searchFilterName.innerHTML = truncatedName;
        searchFilterName.dataset.value = collectionData.value;

        // Update the hidden input field
        const hiddenCollectionFilter = document.getElementById('search-collection-filter');
        if (hiddenCollectionFilter) {
          hiddenCollectionFilter.name = targetName;
          hiddenCollectionFilter.value = targetValueForForm;
        }
      }
    }
  }

  // Initialize with default products
  populateProducts([]);
  // populateSuggestions('');

  // Initialize dropdown selection from URL
  initializeSearchDropdownFromURL();

  //jdgm email prefill
  document.addEventListener(
    'click',
    function (e) {
      if (e.target.matches('.jdgm-write-rev-link')) {
        console.log('Review clicked:', e.target);
        const emailField = document.querySelector('input[name="reviewer_email"]');
        if (emailField) {
          emailField.value = window.customer;
        }
      }
      /** They must have a e.stopPropagation() in the event listener, so need to add capture: true in the listener */
    },
    true,
  );

  document.addEventListener(
    'blur',
    function (e) {
      if (e.target.matches('input[name="order_id"]')) {
        const input = e.target;
        const value = input.value.trim();

        if (value && !value.startsWith('#')) {
          input.value = `#${value}`;
        }
      }
    },
    true,
  );

  document.addEventListener('change', function (e) {
    if (e.target.matches("select[name='topic']")) {
      const orderNumberField = document.querySelector('input[name="order_id"]');
      const fieldWrap = orderNumberField.closest('.collapse');
      if (fieldWrap) {
        if (e.target.value === 'Trace an order' || e.target.value === 'Return/exchange request') {
          orderNumberField.setAttribute('required', 'required');
          fieldWrap.classList.add('show');
        } else {
          orderNumberField.removeAttribute('required');
          orderNumberField.value = '';
          fieldWrap.classList.remove('show');
        }
      }
    }
  });

  if (contactForm)
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      grecaptcha.enterprise.ready(async () => {
        const token = await grecaptcha.enterprise.execute('6LdzLq0rAAAAAD462Kwro-SVw3aE3bdY57-V035b', {
          action: 'contact_form',
        });

        // console.log('submit');

        const formData = new FormData(contactForm);
        const data = Object.fromEntries(formData);
        fetch(`${API_URL}/livingstone/contact?token=${token}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((data) => {
            // console.log('data', data);
            if (data && data.ref) {
              window.location.href = `/pages/thank-you?ref=${data.ref}`;
            } else {
              document.getElementById('contact-form-error-message').innerHTML = data.message;
              document.getElementById('contact-form-error').classList.add('show');
            }
          })
          .catch((error) => {
            console.error('Error:', error);
            document.getElementById('contact-form-error-message').innerHTML =
              'Something went wrong. Please try again.å';
            document.getElementById('contact-form-error').classList.add('show');
          });
      });
    });
});

// For Shopify-specific integration
document.addEventListener('shopify:section:load', function () {
  // Reinitialize the search functionality when Shopify sections are reloaded
  if (window.searchInit) {
    window.searchInit();
  }
});

/** Render appropriate variant blocks */
document.addEventListener('product:swap-block', function (event) {
  const matchingElement = event.detail.matchingElement;
  const actions = [];
  // console.log(matchingElement.children);
  for (block of matchingElement.children[0].children[0].children) {
    if (block.classList?.contains('product-block-list__item--description')) {
      const elementToReplace2 = document.querySelector('.product-block-list__item--description');
      actions.push({ src: elementToReplace2, dest: block });
    }
    if (block.classList?.contains('product-block-list__item--details')) {
      const elementToReplace = document.querySelector('.product-block-list__item--details');
      actions.push({ src: elementToReplace, dest: block });
    }
  }

  // I've added some sections outside of the normal block structure that also need to response to variant selection change
  if (matchingElement.children.length > 1) {
    for (suffixSection of Array.from(matchingElement.children).slice(1)) {
      if (suffixSection?.classList.contains('dynamic-section')) {
        const elementToReplace = document.getElementById(suffixSection.id);
        actions.push({ src: elementToReplace, dest: suffixSection });
      }
    }
  }

  /* execute all changes after selections so we don't cook the DOM we're iterating through */
  for (action of actions) {
    action['src'].replaceWith(action['dest']);
  }
});

/* Invalid Variant Switcher
 * If an option combination doesn't have a variant then we want to switch to the next valid option
 * We do this with an MutationObserver because of DOM update timing */
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    // find the first invalid option choice
    const checkedInput = Array.from(document.querySelectorAll('input[checked]')).find((e) =>
      e.closest('.block-swatch--disabled'),
    );

    // assuming we can successfully locate it
    if (checkedInput) {
      if (checkedInput?.parentElement?.parentElement?.children) {
        // click the first valid option value from that option group
        const IshouldClick = Array.from(checkedInput.parentElement.parentElement.children).find(
          (e) => !e.classList.contains('block-swatch--disabled'),
        );
        IshouldClick?.querySelector('input')?.click();
      }
    }
  });

  // observe the main product form
  if (document.querySelector('product-form form')) {
    observer.observe(document.querySelector('product-form form'), {
      attributes: true,
      subtree: true,
    });
  }
});

// For Shopify-specific integration
document.addEventListener('search:toggle-mobile', function () {
  // const container = document.querySelector('.search-container');
  // if (container.classList.contains('expanded')) {
  //   container.classList.remove('expanded');
  // } else {
  //   container.classList.add('expanded');
  // }
});

/**
 * Variant Auto-Selection Logic
 *
 * When a user selects an option that makes the current variant unavailable,
 * automatically select the first available variant that matches the selected options.
 */
class VariantAutoSelector {
  constructor(variantPicker) {
    this.variantPicker = variantPicker;
    this.variants = this.getVariantsData();
    this.form = document.forms[variantPicker.getAttribute('form-id')];

    if (!this.variants || !this.form) {
      return;
    }

    // Listen for option changes
    this.form.addEventListener('change', (event) => {
      if (event.target.name && event.target.name.includes('option')) {
        this.handleOptionChange();
      }
    });
  }

  getVariantsData() {
    const variantsScript = this.variantPicker.querySelector('script[data-variants]');
    if (!variantsScript) {
      return null;
    }

    try {
      return JSON.parse(variantsScript.textContent);
    } catch (e) {
      console.error('Failed to parse variants data:', e);
      return null;
    }
  }

  getCurrentlySelectedOptions() {
    const optionInputs = Array.from(this.form.elements).filter(
      (input) => input.name && input.name.includes('option') && (input.type !== 'radio' || input.checked),
    );

    return optionInputs
      .sort(
        (a, b) => parseInt(a.getAttribute('data-option-position')) - parseInt(b.getAttribute('data-option-position')),
      )
      .map((input) => this.getOptionValueFromInput(input));
  }

  getOptionValueFromInput(input) {
    // For radio buttons and other inputs, we need to get the actual option value (like "Red")
    // rather than the input value (which might be an ID)

    if (input.type === 'radio') {
      // First try to get from title attribute (color swatches often use this)
      if (input.title) {
        return input.title;
      }

      // Try to get the option value from the label
      const label = input.nextElementSibling || this.form.querySelector(`label[for="${input.id}"]`);
      if (label) {
        // Look for visually hidden span (common in color swatches)
        const hiddenSpan = label.querySelector('.visually-hidden');
        if (hiddenSpan) {
          return hiddenSpan.textContent.trim();
        }

        // Try to get from title attribute on the label
        if (label.title) {
          return label.title;
        }

        // Get all text content but try to clean it
        const labelText = label.textContent.trim();
        if (labelText && labelText !== '' && !labelText.includes('✕')) {
          // Exclude sold out icons
          return labelText;
        }
      }

      // Try to get from title attribute on the input itself
      if (input.getAttribute('title')) {
        return input.getAttribute('title');
      }

      // Fallback to input value
      return input.value;
    }

    if (input.tagName === 'SELECT') {
      const selectedOption = input.options[input.selectedIndex];
      return selectedOption ? selectedOption.textContent.trim() : input.value;
    }

    return input.value;
  }

  findVariantByOptions(options) {
    return this.variants.find((variant) => {
      return options.every((optionValue, index) => {
        const optionKey = `option${index + 1}`;
        return variant[optionKey] === optionValue;
      });
    });
  }

  findFirstAvailableVariant(partialOptions = []) {
    // Find the first available variant that matches the given partial options
    return this.variants.find((variant) => {
      if (!variant.available) {
        return false;
      }

      // Check if this variant matches all the partial options provided
      return partialOptions.every((optionValue, index) => {
        const optionKey = `option${index + 1}`;
        return variant[optionKey] === optionValue;
      });
    });
  }

  selectVariant(variant) {
    if (!variant) {
      return;
    }

    // console.log('Selecting variant:', variant.title, variant);

    // Update form inputs to match the variant options
    for (let i = 1; i <= 3; i++) {
      // Shopify supports up to 3 options
      const optionKey = `option${i}`;
      const optionValue = variant[optionKey];

      if (!optionValue) {
        continue;
      }

      // console.log(`Looking for option${i} with value:`, optionValue);

      // Get all inputs for this option position
      const allOptionInputs = this.form.querySelectorAll(`[name="option${i}"], [data-option-position="${i}"]`);

      for (const input of allOptionInputs) {
        if (input.type === 'radio') {
          // Get the actual option value this radio button represents
          const inputOptionValue = this.getOptionValueFromInput(input);

          // console.log(
          //   `Checking radio button with value "${input.value}", option value "${inputOptionValue}", looking for "${optionValue}"`,
          // );

          // Try different matching strategies
          const matches =
            inputOptionValue === optionValue ||
            inputOptionValue.toLowerCase() === optionValue.toLowerCase() ||
            input.value === optionValue;

          if (matches && !input.checked) {
            console.log(`✓ Selecting radio button for ${optionValue}`);
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        } else if (input.tagName === 'SELECT') {
          // For selects, find the option with matching text content
          const options = Array.from(input.options);
          const matchingOption = options.find((opt) => opt.textContent.trim() === optionValue);

          if (matchingOption && input.value !== matchingOption.value) {
            console.log(`Selecting select option for ${optionValue}`);
            input.value = matchingOption.value;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        } else if (input.type === 'hidden') {
          // For hidden inputs, we need to find the corresponding visible input first
          // Hidden inputs in Shopify usually mirror the selected radio button value
          continue; // Skip hidden inputs for now, they'll be updated by the radio button change
        }
      }
    }
  }

  handleOptionChange() {
    // Small delay to ensure DOM has updated
    setTimeout(() => {
      const selectedOptions = this.getCurrentlySelectedOptions();
      const currentVariant = this.findVariantByOptions(selectedOptions);

      // If current selection is unavailable, find first available variant
      if (!currentVariant || !currentVariant.available) {
        console.log('Current variant unavailable, finding alternative...');

        // Try to find available variant with progressively fewer constraints
        let availableVariant = null;

        // First try with all selected options
        availableVariant = this.findFirstAvailableVariant(selectedOptions);

        // If no variant found, try with fewer options (remove last option iteratively)
        if (!availableVariant) {
          for (let i = selectedOptions.length - 1; i >= 0; i--) {
            const partialOptions = selectedOptions.slice(0, i);
            availableVariant = this.findFirstAvailableVariant(partialOptions);
            if (availableVariant) {
              break;
            }
          }
        }

        // If still no variant found, get any available variant
        if (!availableVariant) {
          availableVariant = this.variants.find((variant) => variant.available);
        }

        if (availableVariant && availableVariant.id !== currentVariant?.id) {
          console.log('Auto-selecting available variant:', availableVariant.title);
          this.selectVariant(availableVariant);
        }
      }
    }, 10);
  }
}

// Initialize variant auto-selector for all variant pickers
document.addEventListener('DOMContentLoaded', function () {
  const variantPickers = document.querySelectorAll('variant-picker');
  variantPickers.forEach((picker) => {
    new VariantAutoSelector(picker);
  });
});

// Also initialize for dynamically loaded content
document.addEventListener('product:rerender', function () {
  setTimeout(() => {
    const variantPickers = document.querySelectorAll('variant-picker');
    variantPickers.forEach((picker) => {
      if (!picker._variantAutoSelector) {
        picker._variantAutoSelector = new VariantAutoSelector(picker);
      }
    });
  }, 100);
});

/**
 * Gallery Image Variant Selection
 *
 * When a user clicks on a gallery thumbnail image that's associated with a variant,
 * automatically select that variant.
 */
class GalleryVariantSelector {
  constructor() {
    this.variantPickers = document.querySelectorAll('variant-picker');
    this.initializeGalleryClickHandlers();
  }

  initializeGalleryClickHandlers() {
    // Find all product gallery thumbnails
    const galleryThumbnails = document.querySelectorAll('.product-gallery__thumbnail');

    galleryThumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', (event) => {
        this.handleImageClick(event, thumbnail);
      });
    });

    // Also handle clicks on main carousel images
    const carouselItems = document.querySelectorAll('.product-gallery__carousel-item');

    carouselItems.forEach((item) => {
      item.addEventListener('click', (event) => {
        this.handleImageClick(event, item);
      });
    });
  }

  handleImageClick(event, element) {
    // Don't prevent the default click behavior, just add our variant selection logic
    const mediaId = element.getAttribute('data-media-id');
    const groupName = element.getAttribute('data-group-name');
    const groupValue = element.getAttribute('data-group-value');

    console.log('Gallery image clicked:', { mediaId, groupName, groupValue });

    if (!mediaId) {
      return;
    }

    // Find the variant picker for this product
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) {
      return;
    }

    // Get variants data
    const variantsScript = variantPicker.querySelector('script[data-variants]');
    const mediaVariantsScript = variantPicker.querySelector('script[data-media-variants]');

    if (!variantsScript) {
      return;
    }

    let variants, mediaVariants;
    try {
      variants = JSON.parse(variantsScript.textContent);
      if (mediaVariantsScript) {
        mediaVariants = JSON.parse(mediaVariantsScript.textContent);
      }
    } catch (e) {
      console.error('Failed to parse variants data:', e);
      return;
    }

    // Find variant associated with this media
    let targetVariant = null;

    // Method 1: Use media-variants mapping if available
    if (mediaVariants && mediaVariants[mediaId]) {
      const mediaData = mediaVariants[mediaId];
      if (mediaData.variants && mediaData.variants.length > 0) {
        // Find the first available variant associated with this media
        for (const variantId of mediaData.variants) {
          const variant = variants.find((v) => v.id.toString() === variantId);
          if (variant && variant.available) {
            targetVariant = variant;
            break;
          }
        }

        // If no available variant, just take the first one
        if (!targetVariant && mediaData.variants.length > 0) {
          const variantId = mediaData.variants[0];
          targetVariant = variants.find((v) => v.id.toString() === variantId);
        }
      }
    }

    // Method 2: If we have group name/value, find variant with matching option
    if (!targetVariant && groupName && groupValue) {
      targetVariant = this.findVariantByOptionValue(variants, groupName, groupValue);
    }

    // Method 3: Find variant that has this media ID in its featured_media
    if (!targetVariant) {
      targetVariant = variants.find((variant) => {
        return variant.featured_media && variant.featured_media.id.toString() === mediaId;
      });
    }

    if (targetVariant && targetVariant.available) {
      console.log('Found target variant for gallery image:', targetVariant.title);

      // Use our existing VariantAutoSelector to select this variant
      const autoSelector = variantPicker._variantAutoSelector;
      if (autoSelector) {
        autoSelector.selectVariant(targetVariant);
      } else {
        // Fallback: create a temporary auto selector
        const tempSelector = new VariantAutoSelector(variantPicker);
        tempSelector.selectVariant(targetVariant);
      }
    } else if (targetVariant && !targetVariant.available) {
      console.log('Target variant found but not available:', targetVariant.title);
      // Could potentially show a message or find the closest available variant
    } else {
      console.log('No variant found for gallery image');
    }
  }

  findVariantByOptionValue(variants, optionName, optionValue) {
    // Find which option position this corresponds to
    const variantPicker = document.querySelector('variant-picker');
    const form = document.forms[variantPicker.getAttribute('form-id')];

    if (!form) {
      return null;
    }

    // Look for option inputs to determine the mapping
    for (let i = 1; i <= 3; i++) {
      const optionInputs = form.querySelectorAll(`[name="option${i}"]`);

      for (const input of optionInputs) {
        // Check if this input's associated label or data matches the group name
        const label = input.nextElementSibling || form.querySelector(`label[for="${input.id}"]`);

        if (label) {
          const groupNameFromData = input.closest('[data-group-name]')?.getAttribute('data-group-name');
          const labelText = label.textContent.trim().toLowerCase();

          if (groupNameFromData === optionName || labelText.includes(optionName)) {
            // This is the right option position, now find variant with this value
            return variants.find((variant) => {
              const optionKey = `option${i}`;
              return variant[optionKey] && variant[optionKey].toLowerCase() === optionValue.toLowerCase();
            });
          }
        }
      }
    }

    return null;
  }
}

// Initialize gallery variant selector
document.addEventListener('DOMContentLoaded', function () {
  new GalleryVariantSelector();
});

document.addEventListener('product:rerender', function () {
  setTimeout(() => {
    new GalleryVariantSelector();
  }, 100);
});

document.addEventListener('quickview:opened', function (event) {
  const currentVariantId = event.detail.variantId;

  // Wait for the quickview modal to be available AND visible in the DOM
  function waitForQuickViewModal(callback, maxAttempts = 20, interval = 100) {
    let attempts = 0;

    const checkModal = setInterval(() => {
      const quickViewModal = document.querySelector('.featured-product');

      if (quickViewModal) {
        // Also check if the modal has actual dimensions (is visible)
        const rect = quickViewModal.getBoundingClientRect();
        const isVisible = rect.width > 0 && rect.height > 0;

        if (isVisible) {
          clearInterval(checkModal);
          callback(quickViewModal);
        }
      }

      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(checkModal);
      }
    }, interval);
  }

  waitForQuickViewModal((quickViewModal) => {
    document.dispatchEvent(new CustomEvent('quickview:loaded'));

    function handlePriceBreaksVisibility(variantId) {
      document.dispatchEvent(new CustomEvent('price:rerender'));

      // Query for tables fresh each time to handle DOM updates
      const priceBreakTables = document.querySelectorAll('.featured-product .price-breaks-table-wrapper');

      priceBreakTables.forEach(function (table) {
        if (table.id === `${variantId}__price-breaks`) {
          table.style.display = 'block';
        } else {
          table.style.display = 'none';
        }
      });
    }

    // document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver(() => {
      // find the first invalid option choice
      const checkedInput = Array.from(quickViewModal.querySelectorAll('input[checked]')).find((e) =>
        e.closest('.block-swatch--disabled'),
      );

      // assuming we can successfully locate it
      if (checkedInput) {
        if (checkedInput?.parentElement?.parentElement?.children) {
          // click the first valid option value from that option group
          const IshouldClick = Array.from(checkedInput.parentElement.parentElement.children).find(
            (e) => !e.classList.contains('block-swatch--disabled'),
          );
          IshouldClick?.querySelector('input')?.click(); //
        }
      }
    });

    // observe the main product form
    if (quickViewModal.querySelector('product-form form')) {
      observer.observe(quickViewModal.querySelector('product-form form'), {
        attributes: true,
        subtree: true,
      });
    }

    new GalleryVariantSelector();
    // });

    function waitForDOMUpdate(variantId, callback, maxAttempts = 20, interval = 50) {
      let attempts = 0;
      let previousSku = null;

      const checkForUpdate = setInterval(() => {
        // Query for the first data-pricing-sum-price element to check if SKU has changed
        const sumTarget = document.querySelector('.featured-product [data-pricing-sum-price]');
        const currentSku = sumTarget?.dataset.variantSku;

        // If we have a SKU and it's different from what we saw before, DOM has updated
        if (currentSku && currentSku !== previousSku) {
          clearInterval(checkForUpdate);
          callback();
          return;
        }

        // Store the first SKU we see for comparison
        if (previousSku === null && currentSku) {
          previousSku = currentSku;
        }

        attempts++;
        if (attempts >= maxAttempts) {
          clearInterval(checkForUpdate);
          // Call callback anyway after max attempts
          callback();
        }
      }, interval);
    }

    document.addEventListener('variant:changed', (data) => {
      console.log('variant:changed');
      if (data.detail.variant) {
        // Wait for Shopify to update the DOM with new variant data
        waitForDOMUpdate(data.detail.variant.id, () => {
          handlePriceBreaksVisibility(data.detail.variant.id);
        });
      }
    });

    if (currentVariantId) {
      handlePriceBreaksVisibility(currentVariantId);
    }
  });
});

/* Refetch price breaks when the customer account changes */
document.addEventListener('DOMContentLoaded', async function () {
  /* Initialise variables */
  const companyExternalId = document.body.dataset.companyExternalId;
  const isB2B = document.body.dataset.isB2b === 'true';
  const couponInput = document.querySelector('.coupon-input');
  let couponValue = couponInput?.value;

  if (!couponValue) {
    const storageValue = localStorage.getItem('coupon_code');
    if (storageValue) {
      couponValue = storageValue;
    }
  }

  // console.log('❗️=== Running cart rectifier ===');
  // console.log({ companyExternalId, isB2B, couponValue });

  /* Helper functions */
  async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  async function ensureAccountAttribute(cart) {
    // console.log('❗️=== ensureAccountAttribute ===');

    if (cart.items?.length > 0) {
      const item = cart.items[0];
      const customerExternalIds = new Set(cart.items.map((i) => i.properties?.__customer_external_id));

      // console.log('❗️customerExternalIds SET', customerExternalIds);

      // not all cart lines have the same customer external id, so we need to refetch the cart breaks
      if (customerExternalIds.size > 1) {
        // console.log('❗️not all cart lines have the same customer external id, so we need to refetch the cart breaks');
        await refetchCartBreaks(cart.items);
      }

      // There is an edgecase where the customer navigates to the cart before refetchCartBreaks is complete.
      // The cart will render the old price, but fetchCart will return the new price because the cart has been updated.
      // so we have to check the cart.json against the rendered cart lines to see if the account code is different
      const renderedCustomerExternalIds = Array.from(
        document.querySelectorAll('input[name="__customer_external_id"]'),
      ).map((x) => x.value);
      // console.log('❗️renderedCustomerExternalIds', renderedCustomerExternalIds);
      // console.log('❗️companyExternalId', companyExternalId);

      if (renderedCustomerExternalIds.some((id) => id !== companyExternalId)) {
        // console.log('❗️renderedCustomerExternalIds mismatch, fetching cart breaks');
        await refetchCartBreaks(cart.items);
      }

      // console.log('❗️cart.__customer_external_id', item.properties?.__customer_external_id);

      if (!item.properties?.__customer_external_id && !!companyExternalId) {
        // console.log('❗️setting account attribute:', companyExternalId);
        await refetchCartBreaks(cart.items);
      } else if (item.properties?.__customer_external_id !== companyExternalId) {
        // console.log('❗️account attribute mismatch, fetching cart breaks');
        await refetchCartBreaks(cart.items);
      } else {
        // console.log('❗️account attribute matches, no action needed');
        // console.log('❗️companyExternalId', companyExternalId);
        // console.log('❗️__customer_external_id', item.properties?.__customer_external_id);
        // clearAccountAttribute(item);
      }
    }
  }

  async function refetchCartBreaks(items) {
    // console.log('❗️=== refetchCartBreaks ===');

    // disabled checkout while we reload
    const checkoutButtons = Array.from(document.querySelectorAll('button[name="checkout"]'));
    for (const b of checkoutButtons) {
      b.disabled = true;
    }

    fetch(`${API_URL}/pricing${isB2B ? '' : '/dtc'}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        accountNumber: companyExternalId,
        token: 'f3243f29-cdba-4b1c-bb62-ef9330db1450',
        skus: items.map((item) => item.sku),
        couponCode: couponValue,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const breakMap = parsePriceBreaks(data);
        // update the cart lines where the customer external id does not match the company external id
        const updates = items
          .filter((item) => item.properties?.__customer_external_id != companyExternalId)
          .map((item) => {
            return {
              id: item.id.toString(),
              quantity: item.quantity,
              properties: {
                ...item.properties,
                __customer_external_id: companyExternalId,
                _priceBreaks: breakMap[item.sku],
              },
            };
          });

        // console.log('❗️updates', JSON.stringify(updates, null, 2));

        // update breaks on the cart line items
        setProperties(updates).then(() => {
          // console.log('❗️=== setProperties success ===');
          // console.log('❗️=== reloading page ===');
          window.location.reload();
        });

        // rerender the prices in cart
        // document.documentElement.dispatchEvent(
        //   new CustomEvent('cart:refresh', {
        //     bubbles: true,
        //   }),
        // );
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  // for troubleshooting
  async function clearAccountAttribute(item) {
    const { __customer_external_id, ...restProperties } = item.properties;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: item.id.toString(),
        quantity: item.quantity,
        properties: { ...restProperties, __customer_external_id: '' },
      }),
    });
  }

  async function setProperties(updates) {
    // console.log('❗️=== setProperties ===');
    // console.log('❗️updates', updates);
    // Change cart line items with the new properties
    // Run sequentially to avoid cart state race conditions
    for (const update of updates) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(update),
      });
    }
  }

  function parsePriceBreaks(priceBreaks) {
    if (!priceBreaks?.length) return [];

    let breakMap = {};

    // Find the correct pricebreak for the qty, then grab its price
    for (const breakData of priceBreaks) {
      let breakList = [];
      for (let i = 1; i < 5; i++) {
        breakList.push({
          quantity: parseInt(breakData[`price_break${i}_qty`]),
          value: parseFloat(breakData[`price_break${i}_ex_gst`]),
        });
      }

      breakMap[breakData.sku] = JSON.stringify({
        breaks: breakList,
        taxRate: breakData.taxRate,
        hmac: breakData.hmac,
        couponCode: breakData.couponCode,
        accountNumber: breakData.accountNumber,
        priceSource: breakData.price_source,
      });
    }

    return breakMap;
  }

  /* Main logic */
  const cart = await fetchCart();
  await ensureAccountAttribute(cart);
});
